/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/light");

var $root = ($protobuf.roots["default"] || ($protobuf.roots["default"] = new $protobuf.Root()))
.setOptions({
  java_multiple_files: true,
  java_package: "com.huaying.framework.protos.wechat",
  java_outer_classname: "WechatProtos",
  objc_class_prefix: ""
})
.addJSON({
  framework: {
    nested: {
      PBSite: {
        fields: {
          siteId: {
            type: "uint32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          type: {
            type: "PBSiteType",
            id: 3
          },
          url: {
            type: "string",
            id: 4
          },
          remark: {
            type: "string",
            id: 5
          },
          partner: {
            type: "framework.PBPartner",
            id: 6
          },
          status: {
            type: "PBSiteStatus",
            id: 7
          },
          createDate: {
            type: "uint64",
            id: 10
          },
          modifyDate: {
            type: "uint64",
            id: 11
          },
          createAdmin: {
            type: "framework.PBAdmin",
            id: 12
          },
          modifyAdmin: {
            type: "framework.PBAdmin",
            id: 13
          }
        }
      },
      PBSiteList: {
        fields: {
          website: {
            rule: "repeated",
            type: "PBSite",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBInventory: {
        fields: {
          inventoryId: {
            type: "uint32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          site: {
            type: "PBSite",
            id: 3
          },
          partner: {
            type: "framework.PBPartner",
            id: 4
          },
          remark: {
            type: "string",
            id: 5
          },
          status: {
            type: "PBInventoryStatus",
            id: 6
          },
          dictionaryRecord: {
            rule: "repeated",
            type: "PBDataDictionaryRecord",
            id: 7
          },
          contentSelectMode: {
            type: "PBInventoryContentSelectMode",
            id: 8
          },
          contentType: {
            type: "PBInventoryContentType",
            id: 9
          },
          imageWidth: {
            type: "int64",
            id: 14
          },
          imageHeight: {
            type: "int64",
            id: 15
          },
          createDate: {
            type: "uint64",
            id: 10
          },
          modifyDate: {
            type: "uint64",
            id: 11
          },
          createAdmin: {
            type: "framework.PBAdmin",
            id: 12
          },
          modifyAdmin: {
            type: "framework.PBAdmin",
            id: 13
          }
        }
      },
      PBInventoryList: {
        fields: {
          inventory: {
            rule: "repeated",
            type: "PBInventory",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBAdContent: {
        fields: {
          contentId: {
            type: "uint32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          type: {
            type: "PBAdContentType",
            id: 3
          },
          partner: {
            type: "framework.PBPartner",
            id: 4
          },
          clickUrl: {
            type: "string",
            id: 5
          },
          text: {
            type: "string",
            id: 6
          },
          image: {
            type: "string",
            id: 7
          },
          remark: {
            type: "string",
            id: 8
          },
          status: {
            type: "PBAdContentStatus",
            id: 9
          },
          imageWidth: {
            type: "uint64",
            id: 15
          },
          imageHeight: {
            type: "uint64",
            id: 16
          },
          dictionaryRecord: {
            rule: "repeated",
            type: "PBDataDictionaryRecord",
            id: 17
          },
          createDate: {
            type: "uint64",
            id: 10
          },
          modifyDate: {
            type: "uint64",
            id: 11
          },
          createAdmin: {
            type: "framework.PBAdmin",
            id: 12
          },
          modifyAdmin: {
            type: "framework.PBAdmin",
            id: 13
          }
        }
      },
      PBAdContentList: {
        fields: {
          content: {
            rule: "repeated",
            type: "PBAdContent",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBCampaign: {
        fields: {
          campaignId: {
            type: "uint32",
            id: 1
          },
          site: {
            type: "PBSite",
            id: 2
          },
          inventory: {
            type: "PBInventory",
            id: 4
          },
          content: {
            type: "PBAdContent",
            id: 5
          },
          beginDate: {
            type: "uint64",
            id: 6
          },
          endDate: {
            type: "uint64",
            id: 7
          },
          endDateType: {
            type: "PBCampaignEndDateType",
            id: 8
          },
          remark: {
            type: "string",
            id: 9
          },
          status: {
            type: "PBCampaignStatus",
            id: 10
          },
          transferUrl: {
            type: "string",
            id: 11
          },
          "default": {
            type: "bool",
            id: 12
          },
          campaignWeight: {
            type: "uint32",
            id: 13
          },
          week: {
            rule: "repeated",
            type: "int32",
            id: 14
          },
          period: {
            rule: "repeated",
            type: "PBCampaignPeriod",
            id: 15
          },
          validStatus: {
            type: "PBCampaignValidStatus",
            id: 16
          },
          createDate: {
            type: "uint64",
            id: 20
          },
          modifyDate: {
            type: "uint64",
            id: 21
          },
          createAdmin: {
            type: "framework.PBAdmin",
            id: 22
          },
          modifyAdmin: {
            type: "framework.PBAdmin",
            id: 23
          }
        }
      },
      PBCampaignPeriod: {
        fields: {
          beginTime: {
            type: "uint64",
            id: 6
          },
          endTime: {
            type: "uint64",
            id: 7
          }
        }
      },
      PBCampaignList: {
        fields: {
          campaign: {
            rule: "repeated",
            type: "PBCampaign",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBCampaignStats: {
        fields: {
          campaign: {
            type: "PBCampaign",
            id: 1
          },
          totalImpressionCount: {
            type: "uint64",
            id: 2
          },
          totalImpressionUv: {
            type: "uint64",
            id: 3
          },
          totalClickCount: {
            type: "uint64",
            id: 4
          },
          totalClickUv: {
            type: "uint64",
            id: 5
          },
          totalClickThroughRate: {
            type: "string",
            id: 6
          },
          item: {
            rule: "repeated",
            type: "PBCampaignStatsItem",
            id: 7
          }
        }
      },
      PBCampaignStatsItem: {
        fields: {
          statsDate: {
            type: "uint64",
            id: 1
          },
          impressionCount: {
            type: "uint64",
            id: 2
          },
          impressionUv: {
            type: "uint64",
            id: 3
          },
          clickCount: {
            type: "uint64",
            id: 4
          },
          clickUv: {
            type: "uint64",
            id: 5
          },
          totalClickThroughRate: {
            type: "string",
            id: 6
          }
        }
      },
      PBCampaignStatsList: {
        fields: {
          stats: {
            rule: "repeated",
            type: "PBCampaignStats",
            id: 1
          },
          totalImpressionCount: {
            type: "uint64",
            id: 2
          },
          totalImpressionUv: {
            type: "uint64",
            id: 3
          },
          totalClickCount: {
            type: "uint64",
            id: 4
          },
          totalClickUv: {
            type: "uint64",
            id: 5
          },
          totalClickThroughRate: {
            type: "string",
            id: 6
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBAdImpression: {
        fields: {
          impressionId: {
            type: "string",
            id: 1
          },
          campaignId: {
            type: "uint32",
            id: 2
          },
          siteId: {
            type: "uint32",
            id: 3
          },
          adContentId: {
            type: "uint32",
            id: 4
          },
          inventoryId: {
            type: "uint32",
            id: 5
          },
          adPartnerId: {
            type: "uint32",
            id: 6
          },
          inventoryPartnerId: {
            type: "uint32",
            id: 7
          },
          ip: {
            type: "string",
            id: 8
          },
          referer: {
            type: "string",
            id: 9
          },
          userAgent: {
            type: "string",
            id: 10
          },
          createDate: {
            type: "uint64",
            id: 11
          }
        }
      },
      PBAdClick: {
        fields: {
          clickId: {
            type: "uint64",
            id: 1
          },
          impressionId: {
            type: "string",
            id: 2
          },
          campaignId: {
            type: "uint32",
            id: 3
          },
          siteId: {
            type: "uint32",
            id: 4
          },
          adContentId: {
            type: "uint32",
            id: 5
          },
          inventoryId: {
            type: "uint32",
            id: 6
          },
          adPartnerId: {
            type: "uint32",
            id: 7
          },
          inventoryPartnerId: {
            type: "uint32",
            id: 8
          },
          ip: {
            type: "string",
            id: 9
          },
          referer: {
            type: "string",
            id: 10
          },
          userAgent: {
            type: "string",
            id: 11
          },
          createDate: {
            type: "uint64",
            id: 12
          }
        }
      },
      PBSiteType: {
        values: {
          ST_DEFAULT: 0,
          ST_WEB: 1,
          ST_H5: 2,
          ST_APP: 3,
          ST_ANCHOR: 4,
          ST_WECHAT_SELF_MEDIA: 5
        }
      },
      PBSiteStatus: {
        values: {
          SS_DEFAULT: 0,
          SS_ENABLE: 1,
          SS_DISABLE: 2
        }
      },
      PBInventoryStatus: {
        values: {
          IS_DEFAULT: 0,
          IS_ENABLE: 1,
          IS_DISABLE: 2
        }
      },
      PBInventoryContentSelectMode: {
        values: {
          ICSM_DEFAULT: 0,
          ICSM_AVERAGE: 1,
          ICSM_WEIGHT: 2,
          ICSM_LATEST: 3
        }
      },
      PBInventoryContentType: {
        values: {
          ICT_DEFAULT: 0,
          ICT_IMAGE: 1,
          ICT_TEXT: 2
        }
      },
      PBAdContentType: {
        values: {
          ACT_DEFAULT: 0,
          ACT_IMAGE: 1,
          ACT_TEXT: 2
        }
      },
      PBAdContentStatus: {
        values: {
          ACS_DEFAULT: 0,
          ACS_ENABLE: 1,
          ACS_DISABLE: 2
        }
      },
      PBCampaignStatus: {
        values: {
          CS_DEFAULT: 0,
          CS_ENABLE: 1,
          CS_DISABLE: 2
        }
      },
      PBCampaignEndDateType: {
        values: {
          CEDT_DEFAULT: 0,
          CEDT_OTHER: 1,
          CEDT_LONG_TERM: 2
        }
      },
      PBSearchSiteReq: {
        fields: {
          keyType: {
            type: "PBSearchSiteKeyType",
            id: 1
          },
          searchKey: {
            type: "string",
            id: 2
          },
          status: {
            type: "PBSiteStatus",
            id: 3
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBSearchInventoryReq: {
        fields: {
          keyType: {
            type: "PBSearchInventoryKeyType",
            id: 1
          },
          searchKey: {
            type: "string",
            id: 2
          },
          status: {
            type: "PBInventoryStatus",
            id: 3
          },
          contentSelectMode: {
            type: "PBInventoryContentSelectMode",
            id: 4
          },
          siteId: {
            type: "uint32",
            id: 5
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBSearchAdContentReq: {
        fields: {
          keyType: {
            type: "PBSearchAdContentKeyType",
            id: 1
          },
          searchKey: {
            type: "string",
            id: 2
          },
          type: {
            type: "PBAdContentType",
            id: 3
          },
          status: {
            type: "PBAdContentStatus",
            id: 4
          },
          adPartnerId: {
            type: "uint32",
            id: 9
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBSearchCampaignReq: {
        fields: {
          keyType: {
            type: "PBSearchCampaignKeyType",
            id: 1
          },
          searchKey: {
            type: "string",
            id: 2
          },
          status: {
            type: "PBCampaignStatus",
            id: 3
          },
          beginDate: {
            type: "uint64",
            id: 4
          },
          endDate: {
            type: "uint64",
            id: 5
          },
          "default": {
            type: "PBSearchCampaignType",
            id: 6
          },
          siteId: {
            type: "uint32",
            id: 7
          },
          contentId: {
            type: "uint32",
            id: 8
          },
          adPartnerId: {
            type: "uint32",
            id: 9
          },
          validStatus: {
            type: "PBCampaignValidStatus",
            id: 11
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBGetCampaignByInventoryIdReq: {
        fields: {
          inventoryId: {
            type: "uint32",
            id: 1
          },
          referer: {
            type: "string",
            id: 2
          },
          userAgent: {
            type: "string",
            id: 3
          }
        }
      },
      PBUpdateCampaignTimeReq: {
        fields: {
          campaignId: {
            type: "uint32",
            id: 1
          },
          beginDate: {
            type: "uint64",
            id: 2
          },
          endDate: {
            type: "uint64",
            id: 3
          },
          endDateType: {
            type: "PBCampaignEndDateType",
            id: 4
          },
          week: {
            rule: "repeated",
            type: "int32",
            id: 14
          },
          period: {
            rule: "repeated",
            type: "PBCampaignPeriod",
            id: 15
          }
        }
      },
      PBUpdateCampaignWeightReq: {
        fields: {
          campaignId: {
            type: "uint32",
            id: 1
          },
          campaignWeight: {
            type: "uint32",
            id: 2
          }
        }
      },
      PBSearchCampaignStatsListReq: {
        fields: {
          keyType: {
            type: "PBSearchCampaignStatsKeyType",
            id: 1
          },
          searchKey: {
            type: "string",
            id: 2
          },
          sortKey: {
            type: "PBCampaignStatsListSortKey",
            id: 3
          },
          sortType: {
            type: "PBCampaignStatsListSortType",
            id: 4
          },
          beginDate: {
            type: "uint64",
            id: 5
          },
          endDate: {
            type: "uint64",
            id: 6
          },
          status: {
            type: "PBCampaignStatus",
            id: 7
          },
          siteId: {
            type: "uint32",
            id: 8
          },
          adPartnerId: {
            type: "uint32",
            id: 9
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBGetCampaignStatsReq: {
        fields: {
          campaignId: {
            type: "uint32",
            id: 1
          },
          beginDate: {
            type: "uint64",
            id: 2
          },
          endDate: {
            type: "uint64",
            id: 3
          }
        }
      },
      PBGetSiteListByNameReq: {
        fields: {
          partnerId: {
            type: "uint32",
            id: 1
          },
          siteName: {
            type: "string",
            id: 2
          }
        }
      },
      PBGetInventoryListByNameReq: {
        fields: {
          siteId: {
            type: "uint32",
            id: 1
          },
          inventoryName: {
            type: "string",
            id: 2
          },
          status: {
            type: "PBInventoryStatus",
            id: 3
          }
        }
      },
      PBUpdateAdContentAndSyncCampaignReq: {
        fields: {
          content: {
            type: "PBAdContent",
            id: 1
          },
          campaignId: {
            rule: "repeated",
            type: "uint32",
            id: 2
          }
        }
      },
      PBSyncCampaignReq: {
        fields: {
          contentId: {
            type: "uint32",
            id: 1
          },
          campaignId: {
            rule: "repeated",
            type: "uint32",
            id: 2
          }
        }
      },
      PBSearchSiteKeyType: {
        values: {
          SSKT_SITE_NAME: 0,
          SSKT_SITE_PARTNER_NAME: 1,
          SSKT_SITE_ID: 2,
          SSKT_SITE_PARTNER_ID: 3
        }
      },
      PBSearchInventoryKeyType: {
        values: {
          SIKT_INVENTORY_NAME: 0,
          SIKT_INVENTORY_ID: 1,
          SIKT_SITE_NAME: 2,
          SIKT_SITE_PARTNER_NAME: 3
        }
      },
      PBSearchAdContentKeyType: {
        values: {
          SACKT_AD_NAME: 0,
          SACKT_AD_PARTNER_NAME: 1,
          SACKT_AD_ID: 2
        }
      },
      PBSearchCampaignKeyType: {
        values: {
          SCKT_AD_NAME: 0,
          SCKT_INVENTORY_NAME: 1,
          SCKT_SITE_NAME: 2,
          SCKT_INVENTORY_PARTNER_NAME: 3,
          SCKT_AD_PARTNER_NAME: 4,
          SCKT_CAMPAIGN_ID: 5
        }
      },
      PBSearchCampaignStatsKeyType: {
        values: {
          SCSKT_AD_NAME: 0,
          SCSKT_INVENTORY_NAME: 1,
          SCSKT_SITE_NAME: 2,
          SCSKT_CAMPAIGN_ID: 3
        }
      },
      PBCampaignStatsListSortKey: {
        values: {
          CSLSK_DEFAULT: 0,
          CSLSK_IMPRESSION_COUNT: 1,
          CSLSK_IMPRESSION_UV: 2,
          CSLSK_CLICK_COUNT: 3,
          CSLSK_CLICK_UV: 4,
          CSLSK_CTR: 5
        }
      },
      PBCampaignStatsListSortType: {
        values: {
          CSLST_DEFAULT: 0,
          CSLST_ASC: 1,
          CSLST_DESC: 2
        }
      },
      PBSearchCampaignType: {
        values: {
          SCT_ALL: 0,
          SCT_DEFAULT: 1,
          SCT_NOT_DEFAULT: 2
        }
      },
      PBCampaignValidStatus: {
        values: {
          CVS_DEFAULT: 0,
          CVS_VALID: 1,
          CVS_EXPIRING_SOON: 2,
          CVS_EXPIRED: 3
        }
      },
      PBEmptyMessage: {
        fields: {}
      },
      PBIntValue: {
        fields: {
          value: {
            type: "uint32",
            id: 1
          }
        }
      },
      PBIntList: {
        fields: {
          values: {
            rule: "repeated",
            type: "uint32",
            id: 1
          }
        }
      },
      PBLongValue: {
        fields: {
          value: {
            type: "uint64",
            id: 1
          }
        }
      },
      PBLongList: {
        fields: {
          values: {
            rule: "repeated",
            type: "uint64",
            id: 1
          }
        }
      },
      PBSIntValue: {
        fields: {
          value: {
            type: "int32",
            id: 1
          }
        }
      },
      PBSIntList: {
        fields: {
          values: {
            rule: "repeated",
            type: "int32",
            id: 1
          }
        }
      },
      PBSLongValue: {
        fields: {
          value: {
            type: "int64",
            id: 1
          }
        }
      },
      PBSLongList: {
        fields: {
          values: {
            rule: "repeated",
            type: "int64",
            id: 1
          }
        }
      },
      PBFloatValue: {
        fields: {
          value: {
            type: "float",
            id: 1
          }
        }
      },
      PBFloatList: {
        fields: {
          values: {
            rule: "repeated",
            type: "float",
            id: 1
          }
        }
      },
      PBDoubleValue: {
        fields: {
          value: {
            type: "double",
            id: 1
          }
        }
      },
      PBDoubleList: {
        fields: {
          values: {
            rule: "repeated",
            type: "double",
            id: 1
          }
        }
      },
      PBStrValue: {
        fields: {
          value: {
            type: "string",
            id: 1
          }
        }
      },
      PBStrList: {
        fields: {
          values: {
            rule: "repeated",
            type: "string",
            id: 1
          }
        }
      },
      PBBoolValueHolder: {
        fields: {
          value: {
            type: "bool",
            id: 1
          }
        }
      },
      PBBoolValue: {
        values: {
          BOOL_NONE: 0,
          BOOL_TRUE: 1,
          BOOL_FALSE: 2
        }
      },
      PBBytesList: {
        fields: {
          data: {
            rule: "repeated",
            type: "bytes",
            id: 1
          }
        }
      },
      PBKeyValue: {
        fields: {
          key: {
            type: "string",
            id: 1
          },
          value: {
            type: "string",
            id: 2
          }
        }
      },
      PBKeyValueList: {
        fields: {
          kv: {
            rule: "repeated",
            type: "PBKeyValue",
            id: 1
          }
        }
      },
      PBDeviceType: {
        values: {
          DEVICE_ANDROID: 0,
          DEVICE_IOS: 1,
          DEVICE_PC: 2
        }
      },
      PBDeviceScreenSize: {
        fields: {
          width: {
            type: "int32",
            id: 1
          },
          height: {
            type: "int32",
            id: 2
          }
        }
      },
      PBDevice: {
        fields: {
          deviceOs: {
            type: "string",
            id: 1
          },
          deviceModel: {
            type: "string",
            id: 2
          },
          deviceId: {
            type: "string",
            id: 3
          },
          deviceType: {
            type: "PBDeviceType",
            id: 4
          },
          screenSize: {
            type: "PBDeviceScreenSize",
            id: 5
          }
        }
      },
      PBNetworkType: {
        values: {
          NET_UNKNOWN: 0,
          NET_WIFI: 1,
          NET_2G: 2,
          NET_3G: 3,
          NET_4G: 4
        }
      },
      PBNetwork: {
        fields: {
          type: {
            type: "PBNetworkType",
            id: 1
          }
        }
      },
      PBPaymentChannel: {
        values: {
          PAY_ALI: 0,
          PAY_WECHAT: 1,
          PAY_APPSTORE_IAP: 2,
          PAY_WECHAT_JS: 3,
          PAY_STRIPE: 4
        }
      },
      PBPaymentResult: {
        values: {
          PAY_TO_BE_PAID: 0,
          PAY_SUC: 1,
          PAY_FAIL: 2,
          PAY_CLOSED: 3,
          PAY_NO_NEED_PAY: 4,
          PAY_REFUNDED: 100
        }
      },
      PBSex: {
        values: {
          SEX_NONE: 0,
          SEX_MALE: 1,
          SEX_FEMALE: 2
        }
      },
      PBSortType: {
        values: {
          SORT_ASCENDING: 0,
          SORT_DESCENDING: 1
        }
      },
      PBPagePara: {
        fields: {
          offset: {
            type: "uint32",
            id: 1
          },
          limit: {
            type: "uint32",
            id: 2
          }
        }
      },
      PBPageInfo: {
        fields: {
          total: {
            type: "uint32",
            id: 1
          },
          pageOffset: {
            type: "uint32",
            id: 2
          },
          pageSize: {
            type: "uint32",
            id: 3
          }
        }
      },
      PBUserLoginData: {
        fields: {
          userId: {
            type: "string",
            id: 1
          },
          userName: {
            type: "string",
            id: 2
          },
          lastLoginDevice: {
            type: "PBDevice",
            id: 3
          },
          lastLoginClientIp: {
            type: "string",
            id: 4
          },
          lastLoginLocation: {
            type: "string",
            id: 5
          },
          lastLoginDate: {
            type: "uint64",
            id: 6
          }
        }
      },
      PBRegisterSource: {
        fields: {
          sourceId: {
            type: "uint32",
            id: 1
          },
          sourceName: {
            type: "string",
            id: 2
          },
          sourceKey: {
            type: "string",
            id: 3
          },
          sortNum: {
            type: "uint32",
            id: 4
          }
        }
      },
      PBRegisterSourceList: {
        fields: {
          sources: {
            rule: "repeated",
            type: "PBRegisterSource",
            id: 1
          }
        }
      },
      PBRange: {
        fields: {
          max: {
            type: "uint32",
            id: 1
          },
          min: {
            type: "uint32",
            id: 2
          }
        }
      },
      PBPartnerType: {
        fields: {
          typeId: {
            type: "uint32",
            id: 1
          },
          typeName: {
            type: "string",
            id: 2
          },
          createDate: {
            type: "uint64",
            id: 3
          },
          modifyDate: {
            type: "uint64",
            id: 4
          },
          createAdmin: {
            type: "PBAdmin",
            id: 5
          },
          modifyAdmin: {
            type: "PBAdmin",
            id: 6
          },
          remarks: {
            type: "string",
            id: 7
          },
          status: {
            type: "PBPartnerTypeStatus",
            id: 8
          }
        }
      },
      PBPartnerTypeList: {
        fields: {
          typeList: {
            rule: "repeated",
            type: "PBPartnerType",
            id: 1
          }
        }
      },
      PBPartner: {
        fields: {
          partnerId: {
            type: "uint32",
            id: 1
          },
          partnerName: {
            type: "string",
            id: 2
          },
          partnerType: {
            type: "PBPartnerType",
            id: 3
          },
          cType: {
            type: "PBCooperationType",
            id: 4
          },
          createDate: {
            type: "uint64",
            id: 5
          },
          modifyDate: {
            type: "uint64",
            id: 6
          },
          remarks: {
            type: "string",
            id: 7
          },
          createAdmin: {
            type: "PBAdmin",
            id: 8
          },
          modifyAdmin: {
            type: "PBAdmin",
            id: 9
          },
          dictionaryRecord: {
            rule: "repeated",
            type: "PBDataDictionaryRecord",
            id: 10
          },
          contact: {
            rule: "repeated",
            type: "PBPartnerContact",
            id: 11
          },
          admin: {
            rule: "repeated",
            type: "PBPartnerAdmin",
            id: 12
          },
          status: {
            type: "PBPartnerStatus",
            id: 13
          }
        }
      },
      PBSimplePartner: {
        fields: {
          dictionaryRecord: {
            rule: "repeated",
            type: "PBDataDictionaryRecord",
            id: 1
          }
        }
      },
      PBPartnerList: {
        fields: {
          partners: {
            rule: "repeated",
            type: "PBPartner",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBPartnerContact: {
        fields: {
          contactId: {
            type: "uint32",
            id: 1
          },
          partnerId: {
            type: "uint32",
            id: 2
          },
          name: {
            type: "string",
            id: 3
          },
          type: {
            type: "PBPartnerContactType",
            id: 4
          },
          email: {
            type: "string",
            id: 5
          },
          mobile: {
            type: "string",
            id: 6
          },
          wechat: {
            type: "string",
            id: 7
          },
          qq: {
            type: "string",
            id: 8
          },
          remarks: {
            type: "string",
            id: 9
          },
          deleted: {
            type: "bool",
            id: 10
          }
        }
      },
      PBPartnerContactList: {
        fields: {
          contact: {
            rule: "repeated",
            type: "PBPartnerContact",
            id: 1
          }
        }
      },
      PBPartnerAdmin: {
        fields: {
          adminId: {
            type: "uint32",
            id: 1
          },
          partnerId: {
            type: "uint32",
            id: 2
          },
          name: {
            type: "string",
            id: 3
          },
          type: {
            type: "PBPartnerAdminType",
            id: 4
          },
          mobile: {
            type: "string",
            id: 5
          },
          password: {
            type: "string",
            id: 6
          },
          remarks: {
            type: "string",
            id: 7
          },
          passwordModifyDate: {
            type: "uint64",
            id: 8
          },
          deleted: {
            type: "bool",
            id: 9
          },
          accessToken: {
            type: "string",
            id: 10
          }
        }
      },
      PBPartnerAdminList: {
        fields: {
          admin: {
            rule: "repeated",
            type: "PBPartnerAdmin",
            id: 1
          }
        }
      },
      PBPartnerTypeStatus: {
        values: {
          PTS_DEFAULT: 0,
          PTS_ENABLE: 1,
          PTS_DISABLE: 2
        }
      },
      PBPartnerStatus: {
        values: {
          PS_DEFAULT: 0,
          PS_ENABLE: 1,
          PS_DISABLE: 2
        }
      },
      PBCooperationType: {
        values: {
          CT_SELF: 0,
          CT_PARTNER: 1
        }
      },
      PBPartnerContactType: {
        values: {
          PCT_PRIMARY: 0,
          PCT_GENERAL: 1
        }
      },
      PBPartnerAdminType: {
        values: {
          PAT_SUPER: 0,
          PAT_GENERAL: 1
        }
      },
      PBPartnerSearchReq: {
        fields: {
          partnerId: {
            type: "uint32",
            id: 1
          },
          partnerName: {
            type: "string",
            id: 2
          },
          typeId: {
            type: "uint32",
            id: 3
          },
          cType: {
            type: "PBCooperationType",
            id: 4
          },
          status: {
            type: "PBPartnerStatus",
            id: 5
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBPartnerAdminUpdatePasswordByUserReq: {
        fields: {
          adminId: {
            type: "uint32",
            id: 1
          },
          oldPassword: {
            type: "string",
            id: 2
          },
          newPassword: {
            type: "string",
            id: 3
          }
        }
      },
      PBPartnerAdminUpdatePasswordByAdminReq: {
        fields: {
          adminId: {
            type: "uint32",
            id: 1
          },
          newPassword: {
            type: "string",
            id: 3
          }
        }
      },
      PBPartnerAdminLoginRsp: {
        fields: {
          admin: {
            type: "PBPartnerAdmin",
            id: 1
          },
          partner: {
            type: "PBPartner",
            id: 2
          }
        }
      },
      PBAdmin: {
        fields: {
          adminId: {
            type: "uint32",
            id: 1
          },
          realName: {
            type: "string",
            id: 2
          },
          password: {
            type: "string",
            id: 3
          },
          mobile: {
            type: "string",
            id: 4
          },
          lastLoginDate: {
            type: "uint64",
            id: 5
          },
          roles: {
            rule: "repeated",
            type: "uint32",
            id: 6
          },
          locked: {
            type: "bool",
            id: 7
          },
          role: {
            type: "PBAdminRole",
            id: 9
          },
          createDate: {
            type: "uint64",
            id: 10
          },
          updateDate: {
            type: "uint64",
            id: 11
          },
          email: {
            type: "string",
            id: 12
          },
          adminAccessToken: {
            type: "string",
            id: 20
          }
        }
      },
      PBAdminRole: {
        fields: {
          roleId: {
            type: "uint32",
            id: 1
          },
          roleName: {
            type: "string",
            id: 2
          },
          permissions: {
            rule: "repeated",
            type: "string",
            id: 3
          },
          isSuperRole: {
            type: "bool",
            id: 4
          },
          createDate: {
            type: "uint64",
            id: 5
          },
          updateDate: {
            type: "uint64",
            id: 6
          }
        }
      },
      PBGetAdminRoleListReq: {
        fields: {
          searchKey: {
            type: "string",
            id: 1
          },
          page: {
            type: "PBPagePara",
            id: 2
          }
        }
      },
      PBAdminRoleList: {
        fields: {
          roles: {
            rule: "repeated",
            type: "PBAdminRole",
            id: 1
          },
          pageInfo: {
            type: "PBPageInfo",
            id: 2
          }
        }
      },
      PBAdminLog: {
        fields: {
          id: {
            type: "uint64",
            id: 1
          },
          adminId: {
            type: "uint32",
            id: 2
          },
          adminName: {
            type: "string",
            id: 3
          },
          event: {
            type: "string",
            id: 4
          },
          description: {
            type: "string",
            id: 5
          },
          createDate: {
            type: "uint64",
            id: 6
          },
          messageType: {
            type: "uint32",
            id: 7
          }
        }
      },
      PBGetAdminListReq: {
        fields: {
          roles: {
            rule: "repeated",
            type: "int32",
            id: 1
          },
          roleId: {
            type: "uint32",
            id: 90
          },
          locked: {
            type: "PBBoolValue",
            id: 2
          },
          searchKey: {
            type: "string",
            id: 3
          },
          page: {
            type: "PBPagePara",
            id: 4
          }
        }
      },
      PBAdminList: {
        fields: {
          admins: {
            rule: "repeated",
            type: "PBAdmin",
            id: 1
          },
          pageInfo: {
            type: "PBPageInfo",
            id: 2
          }
        }
      },
      PBResetAdminPasswordReq: {
        fields: {
          adminId: {
            type: "uint32",
            id: 1
          },
          originPassword: {
            type: "string",
            id: 2
          },
          newPassword: {
            type: "string",
            id: 3
          }
        }
      },
      PBGetAdminLogListReq: {
        fields: {
          keyword: {
            type: "string",
            id: 1
          },
          page: {
            type: "PBPagePara",
            id: 2
          }
        }
      },
      PBAdminLogList: {
        fields: {
          logs: {
            rule: "repeated",
            type: "PBAdminLog",
            id: 1
          },
          pageInfo: {
            type: "PBPageInfo",
            id: 2
          }
        }
      },
      PBGetAdminListByRoleReq: {
        fields: {
          roleId: {
            type: "uint32",
            id: 1
          },
          roleName: {
            type: "string",
            id: 2
          },
          page: {
            type: "PBPagePara",
            id: 10
          }
        }
      },
      PBDataDictionary: {
        fields: {
          dictionaryId: {
            type: "uint64",
            id: 1
          },
          module: {
            type: "PBModule",
            id: 2
          },
          name: {
            type: "string",
            id: 3
          },
          type: {
            type: "PBDataDictionaryType",
            id: 4
          },
          desc: {
            type: "string",
            id: 5
          },
          status: {
            type: "PBDataDictionaryStatus",
            id: 6
          },
          modifyDate: {
            type: "uint64",
            id: 11
          },
          modifyAdmin: {
            type: "framework.PBAdmin",
            id: 12
          }
        }
      },
      PBDataDictionaryList: {
        fields: {
          dictionary: {
            rule: "repeated",
            type: "PBDataDictionary",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBDataDictionaryRecord: {
        fields: {
          recordId: {
            type: "uint64",
            id: 1
          },
          modelName: {
            type: "string",
            id: 2
          },
          modelId: {
            type: "string",
            id: 3
          },
          dictionaryName: {
            type: "string",
            id: 4
          },
          dictionaryType: {
            type: "PBDataDictionaryType",
            id: 5
          },
          value: {
            type: "string",
            id: 6
          },
          desc: {
            type: "string",
            id: 7
          },
          deleted: {
            type: "bool",
            id: 8
          }
        }
      },
      PBDataDictionaryType: {
        values: {
          DDT_DEFAULT: 0,
          DDT_INT: 1,
          DDT_STRING: 2,
          DDT_BOOLEAN: 3
        }
      },
      PBDataDictionaryStatus: {
        values: {
          DDS_DEFAULT: 0,
          DDS_ENABLE: 1,
          DDS_DISABLE: 2
        }
      },
      PBSearchDataDictionaryReq: {
        fields: {
          moduleId: {
            type: "uint32",
            id: 1
          },
          keyType: {
            type: "PBSearchDataDictionaryKeyType",
            id: 2
          },
          searchKey: {
            type: "string",
            id: 3
          },
          type: {
            type: "PBDataDictionaryType",
            id: 4
          },
          status: {
            type: "PBDataDictionaryStatus",
            id: 5
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBSearchDataDictionaryKeyType: {
        values: {
          SDDKT_NAME: 0,
          SDDKT_ID: 1
        }
      },
      PBModule: {
        fields: {
          moduleId: {
            type: "uint32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          type: {
            type: "PBModuleType",
            id: 3
          },
          remark: {
            type: "string",
            id: 4
          },
          modifyDate: {
            type: "uint64",
            id: 11
          },
          modifyAdmin: {
            type: "framework.PBAdmin",
            id: 12
          }
        }
      },
      PBModuleList: {
        fields: {
          module: {
            rule: "repeated",
            type: "PBModule",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBModuleType: {
        values: {
          MT_DEFAULT: 0,
          MT_COMMON: 1,
          MT_BUSINESS: 2
        }
      },
      PBSearchModuleReq: {
        fields: {
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBArticleType: {
        fields: {
          typeId: {
            type: "int32",
            id: 1
          },
          typeName: {
            type: "string",
            id: 2
          },
          sortNumber: {
            type: "uint32",
            id: 3
          },
          createTime: {
            type: "uint64",
            id: 4
          },
          updateTime: {
            type: "uint64",
            id: 5
          },
          status: {
            type: "PBArticleStatus",
            id: 6
          },
          modifyAdmin: {
            type: "PBAdmin",
            id: 7
          },
          childType: {
            rule: "repeated",
            type: "PBArticleChildType",
            id: 8
          },
          site: {
            type: "string",
            id: 9
          }
        }
      },
      PBArticleChildType: {
        fields: {
          childTypeId: {
            type: "int32",
            id: 1
          },
          childTypeName: {
            type: "string",
            id: 2
          },
          typeId: {
            type: "uint32",
            id: 3
          },
          typeName: {
            type: "string",
            id: 9
          },
          sortNumber: {
            type: "uint32",
            id: 4
          },
          createTime: {
            type: "uint64",
            id: 5
          },
          updateTime: {
            type: "uint64",
            id: 6
          },
          status: {
            type: "PBArticleStatus",
            id: 7
          },
          modifyAdmin: {
            type: "PBAdmin",
            id: 8
          },
          site: {
            type: "string",
            id: 10
          }
        }
      },
      PBArticleSource: {
        fields: {
          sourceId: {
            type: "int32",
            id: 1
          },
          sourceName: {
            type: "string",
            id: 2
          },
          sourceUrl: {
            type: "string",
            id: 3
          },
          createTime: {
            type: "uint64",
            id: 4
          },
          updateTime: {
            type: "uint64",
            id: 5
          },
          sortNumber: {
            type: "uint32",
            id: 6
          },
          modifyAdmin: {
            type: "PBAdmin",
            id: 7
          }
        }
      },
      PBArticleReviewStatus: {
        values: {
          ARS_APPROVE: 0,
          ARS_PENDING: 1,
          ARS_REFUSE: 2,
          ARS_ALL: 99
        }
      },
      PBArticleStatus: {
        values: {
          AS_DEFAULT: 0,
          AS_SHOW: 1,
          AS_HIDE: 2
        }
      },
      PBArticleSortType: {
        values: {
          AST_CREATE: 0,
          AST_UPDATE: 1,
          AST_RELEASE: 2,
          AST_NUMBER: 3
        }
      },
      PBArticleTypeListReq: {
        fields: {
          site: {
            rule: "repeated",
            type: "string",
            id: 1
          }
        }
      },
      PBArticle: {
        fields: {
          articleId: {
            type: "uint32",
            id: 1
          },
          title: {
            type: "string",
            id: 2
          },
          content: {
            type: "string",
            id: 3
          },
          articleType: {
            type: "PBArticleType",
            id: 4
          },
          childType: {
            type: "PBArticleChildType",
            id: 5
          },
          articleSource: {
            type: "PBArticleSource",
            id: 6
          },
          tag: {
            type: "string",
            id: 7
          },
          keywords: {
            type: "string",
            id: 8
          },
          description: {
            type: "string",
            id: 9
          },
          coverImage: {
            type: "string",
            id: 10
          },
          status: {
            type: "PBArticleStatus",
            id: 11
          },
          createTime: {
            type: "uint64",
            id: 12
          },
          updateTime: {
            type: "uint64",
            id: 13
          },
          releaseTime: {
            type: "uint64",
            id: 24
          },
          readNum: {
            type: "uint32",
            id: 15
          },
          sortNumber: {
            type: "uint32",
            id: 16
          },
          isTop: {
            type: "bool",
            id: 17
          },
          isEssence: {
            type: "bool",
            id: 18
          },
          isDraft: {
            type: "bool",
            id: 19
          },
          createAdmin: {
            type: "PBAdmin",
            id: 21
          },
          modifyAdmin: {
            type: "PBAdmin",
            id: 20
          },
          site: {
            type: "string",
            id: 22
          },
          reviewStatus: {
            type: "PBArticleReviewStatus",
            id: 23
          }
        }
      },
      PBArticleTypeList: {
        fields: {
          types: {
            rule: "repeated",
            type: "PBArticleType",
            id: 1
          }
        }
      },
      PBArticleChildTypeList: {
        fields: {
          childTypes: {
            rule: "repeated",
            type: "PBArticleChildType",
            id: 1
          }
        }
      },
      PBArticleSourceList: {
        fields: {
          sources: {
            rule: "repeated",
            type: "PBArticleSource",
            id: 1
          }
        }
      },
      PBArticleList: {
        fields: {
          articles: {
            rule: "repeated",
            type: "PBArticle",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 2
          }
        }
      },
      PBArticleAndTypeList: {
        fields: {
          childTypeList: {
            rule: "repeated",
            type: "PBArticleChildType",
            id: 1
          },
          articleList: {
            rule: "repeated",
            type: "PBArticle",
            id: 2
          }
        }
      },
      PBArticleSearchReq: {
        fields: {
          articleId: {
            type: "uint32",
            id: 1
          },
          title: {
            type: "string",
            id: 2
          },
          articleType: {
            type: "PBArticleType",
            id: 3
          },
          articleSource: {
            type: "PBArticleSource",
            id: 4
          },
          childType: {
            type: "PBArticleChildType",
            id: 5
          },
          status: {
            type: "PBArticleStatus",
            id: 6
          },
          isDraft: {
            type: "bool",
            id: 7
          },
          sortType: {
            type: "PBArticleSortType",
            id: 8
          },
          isDescending: {
            type: "bool",
            id: 9
          },
          page: {
            type: "PBPagePara",
            id: 10
          },
          articleTypeId: {
            rule: "repeated",
            type: "uint32",
            id: 11
          },
          site: {
            rule: "repeated",
            type: "string",
            id: 12
          },
          reviewStatus: {
            type: "PBArticleReviewStatus",
            id: 13
          }
        }
      },
      PBArticleRecommendReq: {
        fields: {
          articleId: {
            type: "uint32",
            id: 1
          },
          replenishType: {
            type: "uint32",
            id: 2
          },
          sortType: {
            type: "PBArticleSortType",
            id: 3
          },
          isDescending: {
            type: "bool",
            id: 4
          },
          limit: {
            type: "uint32",
            id: 5
          }
        }
      },
      PBArticleRecommendListReq: {
        fields: {
          articleId: {
            type: "uint32",
            id: 1
          },
          site: {
            rule: "repeated",
            type: "string",
            id: 2
          }
        }
      },
      PBMessageType: {
        values: {
          DEFAULT: 0,
          SERVER_TIMESTAMP: 9,
          BASIC_CONFIG_GET: 1,
          SYSTEM_PARA_ADD: 2,
          SYSTEM_PARA_UPDATE: 3,
          SYSTEM_PARA_GET_LIST: 4,
          SYSTEM_PARA_GET_ONE: 5,
          SYSTEM_PARA_GET_ONE_DEFAULT: 6,
          FILE_CONFIG_GET: 7,
          FILE_CONFIG_UPDATE: 8,
          FEEDBACK_ADD: 31,
          FEEDBACK_GET_LIST: 32,
          FEEDBACK_DELETE: 33,
          FEEDBACK_UPDATE: 34,
          ADMIN_LOGIN: 41,
          ADMIN_ADD: 42,
          ADMIN_GET_LIST: 43,
          ADMIN_RESET_PASSWORD: 44,
          ADMIN_UPDATE: 45,
          ADMIN_MODIFY_PASSWORD: 46,
          ADMIN_GET_BY_ID: 47,
          ADMIN_LIST_BY_ROLE: 48,
          ADMIN_ROLE_GET_LIST: 131,
          ADMIN_ROLE_ADD: 132,
          ADMIN_ROLE_UPDATE: 133,
          ADMIN_ROLE_GET_BY_ID: 134,
          ADMIN_LOG_GET_LIST: 51,
          LOCATION_GET_ALL: 61,
          LOCATION_DETECT: 62,
          LOCATION_GET_PROVINCE: 64,
          LOCATION_GET_CITY_BY_PROVINCE: 65,
          LOCATION_GET_DISTRICT_BY_CITY: 66,
          LOCATION_GET_BY_ID: 67,
          LOCATION_HOT_CITIES: 68,
          LOCATION_SET_HOT_CITY: 69,
          LOCATION_UN_SET_HOT_CITY: 70,
          LOCATION_UPDATE_CITY_LEVEL: 72,
          LOCATION_GET_BY_CITY_LEVEL: 73,
          LOCATION_GET_LNG_LAT: 74,
          LOCATION_GET_BY_IP: 75,
          APP_PUSH_CREATE: 80,
          APP_PUSH_LIST: 81,
          APP_PUSH_RETRY: 82,
          APP_PUSH_CANCEL: 83,
          APP_PUSH_UPDATE: 84,
          APP_PUSH_GET_BY_ID: 85,
          APP_PUSH_REPORT_REGID: 86,
          APP_PUSH_SET_ALIAS: 87,
          APP_PUSH_UNSET_ALIAS: 88,
          APP_PUSH_SUBSCRIBE_TOPIC: 89,
          APP_PUSH_UNSUBSCRIBE_TOPIC: 99,
          APP_PUSH_CLICKED: 98,
          SMS_PUSH_CREATE: 90,
          SMS_PUSH_LIST: 91,
          SMS_PUSH_RETRY: 92,
          SMS_PUSH_CANCEL: 93,
          WECHAT_MP_PUSH_CREATE: 102,
          WECHAT_MP_PUSH_LIST: 103,
          WECHAT_MP_PUSH_RETRY: 104,
          WECHAT_MP_PUSH_CANCEL: 105,
          WECHAT_MP_ACCESS_TOKEN: 100,
          WECHAT_MP_JSAPI_TICKET: 106,
          WECHAT_MP_JSSDK_CONFIG: 107,
          WECHAT_MP_REPORT_FORMID: 101,
          WECHAT_MP_MINIPROGRAM_LOGIN: 108,
          SHARE_CREATE: 110,
          SHARE_SUCCEED: 111,
          SHARE_CLICK: 112,
          SPLASH_ADD: 120,
          SPLASH_UPDATE: 121,
          SPLASH_GET_BY_ID: 122,
          SPLASH_GET_LIST: 123,
          SPLASH_GET_BY_APP: 124,
          SPLASH_DELETE: 125,
          VERSION_CHECK: 140,
          VERSION_LIST: 141,
          VERSION_GET_BY_ID: 142,
          VERSION_CREATE: 143,
          VERSION_UPDATE: 144,
          VERSION_APPROVED: 145,
          VERSION_DELETE: 146,
          VERSION_GET_LATEST: 147,
          LINK_LIST: 160,
          LINK_GET_BY_ID: 161,
          LINK_ADD: 162,
          LINK_UPDATE: 163,
          LINK_DELETE: 164,
          LINK_GET_MAX_SORT_NUMBER: 165,
          LINK_STATISTIC_LIST: 166,
          LINK_CLICK_REPORT: 167,
          LINK_STATISTIC: 168,
          ARTICLE_TYPE_ADD: 170,
          ARTICLE_TYPE_UPDATE: 171,
          ARTICLE_TYPE_DELETE: 172,
          ARTICLE_TYPE_GET_LIST: 173,
          ARTICLE_TYPE_GET_LIST_SHOW: 193,
          ARTICLE_TYPE_GET_MAX_SORT_NUMBER: 174,
          ARTICLE_SOURCE_ADD: 175,
          ARTICLE_SOURCE_UPDATE: 176,
          ARTICLE_SOURCE_DELETE: 177,
          ARTICLE_SOURCE_GET_LIST: 178,
          ARTICLE_SOURCE_GET_MAX_SORT_NUMBER: 179,
          ARTICLE_ADD: 180,
          ARTICLE_UPDATE: 181,
          ARTICLE_DELETE: 182,
          ARTICLE_SEARCH_TO_LIST: 183,
          ARTICLE_GET_SHOW_LIST: 194,
          ARTICLE_GET_MAX_SORT_NUMBER: 184,
          ARTICLE_GET_INFO: 185,
          ARTICLE_RECOMMEND: 186,
          ARTICLE_LIST_BY_TYPE_ID: 195,
          ARTICLE_CHILD_TYPE_ADD: 187,
          ARTICLE_CHILD_TYPE_UPDATE: 188,
          ARTICLE_CHILD_TYPE_DELETE: 189,
          ARTICLE_CHILD_TYPE_GET_LIST: 190,
          ARTICLE_CHILD_TYPE_GET_MAX_SORT_NUMBER: 191,
          ARTICLE_GET_INFO_BG: 192,
          ARTICLE_LIST_BY_RECOMMEND: 196,
          PARTNER_TYPE_ADD: 200,
          PARTNER_TYPE_UPDATE: 201,
          PARTNER_TYPE_LIST: 202,
          PARTNER_ADD: 203,
          PARTNER_UPDATE: 204,
          PARTNER_LIST: 205,
          PARTNER_GET: 206,
          PARTNER_GET_FULL: 207,
          PARTNER_TYPE_ENABLE: 208,
          PARTNER_TYPE_DISABLE: 209,
          PARTNER_ENABLE: 210,
          PARTNER_DISABLE: 211,
          PARTNER_CONTACT_ADD: 212,
          PARTNER_CONTACT_UPDATE: 213,
          PARTNER_CONTACT_DELETE: 214,
          PARTNER_CONTACT_LIST: 216,
          PARTNER_CONTACT_GET: 217,
          PARTNER_ADMIN_ADD: 218,
          PARTNER_ADMIN_UPDATE: 219,
          PARTNER_ADMIN_DELETE: 220,
          PARTNER_ADMIN_LIST: 221,
          PARTNER_ADMIN_GET: 222,
          PARTNER_ADMIN_UPDATE_PASSWORD_BY_USER: 223,
          PARTNER_ADMIN_UPDATE_PASSWORD_BY_ADMIN: 224,
          PARTNER_ADMIN_RESET_INIT_PASSWORD: 225,
          PARTNER_ADMIN_LOGIN: 236,
          PARTNER_ADMIN_LOGOUT: 237,
          PARTNER_TYPE_LIST_BY_STATUS: 238,
          PARTNER_GET_BY_ADMIN_TOKEN: 239,
          TICKET_ADD: 300,
          TICKET_REPLY: 301,
          TICKET_LIST: 302,
          TICKET_GET_BY_ID: 303,
          TICKET_CLOSE: 304,
          TICKET_SEARCH: 305,
          TICKET_STATUS_MODIFY: 306,
          TICKET_TYPE_MODIFY: 307,
          TICKET_ASSIGN: 308,
          TICKET_REPLY_LIST: 309,
          TICKET_USER_UNREAD_COUNT: 310,
          TICKET_READ_BY_USER_ID: 311,
          TICKET_READ_BY_ADMIN_ID: 312,
          TICKET_GET_BY_CODE: 313,
          TICKET_ADMIN_UNREAD_COUNT: 314,
          TICKET_REMARK: 315,
          TICKET_PRIORITY_MODIFY: 316,
          TICKET_REPLY_MODIFY: 317,
          TICKET_TYPE_ADD: 320,
          TICKET_TYPE_UPDATE: 321,
          TICKET_TYPE_DELETE: 322,
          TICKET_TYPE_LIST: 323,
          TICKET_TYPE_SET_DEFAULT: 324,
          TICKET_ASSIGN_RULE_ADD: 330,
          TICKET_ASSIGN_RULE_DELETE: 331,
          TICKET_ASSIGN_RULE_LIST: 332,
          TICKET_OPERATION_HISTORY_LIST: 340,
          TICKET_COUNT_GET_BY_USER_ID: 360,
          SITE_SEARCH: 400,
          SITE_ADD: 401,
          SITE_GET: 402,
          SITE_UPDATE: 403,
          SITE_LIST_BY_NAME: 404,
          SITE_ENABLE: 405,
          SITE_DISABLE: 406,
          INVENTORY_SEARCH: 410,
          INVENTORY_ADD: 411,
          INVENTORY_GET: 412,
          INVENTORY_UPDATE: 413,
          INVENTORY_ENABLE: 414,
          INVENTORY_DISABLE: 415,
          INVENTORY_LIST: 416,
          INVENTORY_HAVE_CAMPAIGN_SEARCH: 417,
          AD_CONTENT_SEARCH: 420,
          AD_CONTENT_ADD: 421,
          AD_CONTENT_GET: 422,
          AD_CONTENT_UPDATE: 423,
          AD_CONTENT_ENABLE: 424,
          AD_CONTENT_DISABLE: 425,
          AD_CONTENT_UPDATE_AND_SYNC_CAMPAIGN: 426,
          AD_CONTENT_SYNC_CAMPAIGN: 427,
          CAMPAIGN_SEARCH: 430,
          CAMPAIGN_ADD: 431,
          CAMPAIGN_GET: 432,
          CAMPAIGN_ENABLE: 433,
          CAMPAIGN_DISABLE: 434,
          CAMPAIGN_UPDATE_TIME: 435,
          CAMPAIGN_GET_BY_INVENTORY_ID: 436,
          CAMPAIGN_STATS_SEARCH: 440,
          CAMPAIGN_STATS_GET: 441,
          CAMPAIGN_STATS_UPDATE: 442,
          CAMPAIGN_UPDATE_WEIGHT: 443,
          REG_SOURCE_UPDATE: 450,
          REG_SOURCE_LIST: 451,
          REG_SOURCE_DELETE: 452,
          EMAIL_PUSH_CREATE: 460,
          EMAIL_PUSH_LIST: 461,
          EMAIL_PUSH_RETRY: 462,
          EMAIL_PUSH_CANCEL: 463,
          MODULE_SEARCH: 500,
          MODULE_ADD: 501,
          MODULE_GET: 502,
          MODULE_UPDATE: 503,
          DATA_DICTIONARY_SEARCH: 510,
          DATA_DICTIONARY_ADD: 511,
          DATA_DICTIONARY_GET: 512,
          DATA_DICTIONARY_UPDATE: 513,
          DATA_DICTIONARY_DELETE: 514,
          DATA_DICTIONARY_ENABLE: 515,
          DATA_DICTIONARY_DISABLE: 516,
          PAGE_MANAGE_RECORD_SEARCH: 600,
          PAGE_MANAGE_RECORD_ADD: 601,
          PAGE_MANAGE_RECORD_GET: 602,
          PAGE_MANAGE_RECORD_UPDATE: 603,
          PAGE_MANAGE_RECORD_ENABLE: 604,
          PAGE_MANAGE_RECORD_DISABLE: 605,
          PAGE_MANAGE_RECORD_BEST: 606,
          DATA_ITEM_SEARCH_BG: 650,
          DATA_ITEM_ADD: 651,
          DATA_ITEM_CATEGORY_ADD: 652,
          DATA_ITEM_UPDATE: 653,
          DATA_ITEM_CATEGORY_UPDATE: 654,
          DATA_ITEM_SEARCH: 655,
          DATA_ITEM_UPDATE_ORDER: 656,
          SITEMAP_SEARCH: 700,
          SITEMAP_PUSH_TASK_SEARCH: 701,
          SITEMAP_PUSH: 702,
          BUSINESS_CASE_SEARCH: 750,
          BUSINESS_CASE_ADD: 751,
          BUSINESS_CASE_GET: 752,
          BUSINESS_CASE_UPDATE: 753,
          BUSINESS_CASE_DELETE: 754,
          BUSINESS_CASE_UPDATE_ENABLE: 755,
          BUSINESS_CASE_UPDATE_DISABLE: 756,
          BUSINESS_CASE_ORDER_RANGE: 757,
          FAQ_CATEGORY_SEARCH: 800,
          FAQ_CATEGORY_ADD: 801,
          FAQ_CATEGORY_GET_BG: 802,
          FAQ_CATEGORY_GET_PC: 803,
          FAQ_CATEGORY_UPDATE: 804,
          FAQ_CATEGORY_DELETE: 805,
          FAQ_CATEGORY_SHOW: 806,
          FAQ_CATEGORY_HIDE: 807,
          FAQ_CATEGORY_UPDATE_HOT: 808,
          FAQ_CATEGORY_GET_BY_PARENT_ID: 809,
          FAQ_CATEGORY_GET_ENABLE_ROOT_CATEGORY_PC: 810,
          FAQ_CATEGORY_HOT_RANGE: 811,
          FAQ_CATEGORY_TOTAL_HOT_RANGE: 812,
          FAQ_SEARCH: 820,
          FAQ_ADD: 821,
          FAQ_GET_PC: 822,
          FAQ_GET_BG: 823,
          FAQ_UPDATE: 824,
          FAQ_DELETE: 825,
          FAQ_SHOW: 826,
          FAQ_HIDE: 827,
          FAQ_UPDATE_HOT: 828,
          FAQ_GET_RELATED_FAQ: 829,
          FAQ_TOTAL_HOT_RANGE: 830,
          FAQ_HOT_RANG_IN_CATEGORY: 831,
          SOCKET_LOGIN: 9000,
          SOCKET_PING_PONG: 9001,
          SOCKET_SUBSCRIBE_TOPIC: 9002,
          SOCKET_UNSUBSCRIBE_TOPIC: 9003,
          SOCKET_MULTI_LOGIN: 95000
        }
      },
      PBMessageRequest: {
        fields: {
          encrypted: {
            type: "bool",
            id: 1
          },
          compressed: {
            type: "bool",
            id: 2
          },
          type: {
            type: "uint32",
            id: 3
          },
          messageData: {
            type: "bytes",
            id: 4
          },
          requestId: {
            type: "uint64",
            id: 5
          },
          timestamp: {
            type: "uint64",
            id: 7
          },
          qualifier: {
            type: "string",
            id: 10
          },
          device: {
            type: "PBDevice",
            id: 8
          },
          network: {
            type: "PBNetwork",
            id: 9
          },
          context: {
            type: "PBRequestContext",
            id: 11
          },
          clientType: {
            type: "uint32",
            id: 20
          },
          appChannelId: {
            type: "PBAppChannelId",
            id: 18
          },
          appVersionName: {
            type: "string",
            id: 12
          },
          appVersionCode: {
            type: "uint32",
            id: 19
          },
          appKey: {
            type: "string",
            id: 13
          },
          accessToken: {
            type: "string",
            id: 14
          },
          signature: {
            type: "string",
            id: 15
          },
          adminId: {
            type: "uint32",
            id: 16
          },
          adminAccessToken: {
            type: "string",
            id: 17
          },
          partnerAdminId: {
            type: "uint32",
            id: 23
          },
          partnerAdminAccessToken: {
            type: "string",
            id: 22
          },
          extra: {
            type: "bytes",
            id: 21
          }
        }
      },
      PBRequestContext: {
        fields: {
          currentPage: {
            type: "string",
            id: 1
          },
          previousPage: {
            type: "string",
            id: 2
          }
        }
      },
      PBMessageResponse: {
        fields: {
          encrypted: {
            type: "bool",
            id: 1
          },
          compressed: {
            type: "bool",
            id: 2
          },
          type: {
            type: "uint32",
            id: 3
          },
          messageData: {
            type: "bytes",
            id: 4
          },
          appKey: {
            type: "string",
            id: 8
          },
          requestId: {
            type: "uint64",
            id: 5
          },
          resultCode: {
            type: "uint32",
            id: 6
          },
          resultInfo: {
            type: "string",
            id: 7
          }
        }
      },
      PBSocketMessage: {
        fields: {
          encrypted: {
            type: "bool",
            id: 1
          },
          compressed: {
            type: "bool",
            id: 2
          },
          type: {
            type: "uint32",
            id: 3
          },
          messageData: {
            type: "bytes",
            id: 4
          },
          ack: {
            type: "bool",
            id: 5
          },
          requestId: {
            type: "uint64",
            id: 6
          },
          timestamp: {
            type: "uint64",
            id: 8
          },
          qualifier: {
            type: "string",
            id: 17
          },
          device: {
            type: "PBDevice",
            id: 9
          },
          network: {
            type: "PBNetwork",
            id: 10
          },
          context: {
            type: "PBRequestContext",
            id: 19
          },
          appChannelId: {
            type: "PBAppChannelId",
            id: 18
          },
          appVersionName: {
            type: "string",
            id: 11
          },
          appVersionCode: {
            type: "uint32",
            id: 20
          },
          appKey: {
            type: "string",
            id: 12
          },
          accessToken: {
            type: "string",
            id: 13
          },
          signature: {
            type: "string",
            id: 14
          },
          resultCode: {
            type: "uint32",
            id: 15
          },
          resultInfo: {
            type: "string",
            id: 16
          }
        }
      },
      PBVersion: {
        fields: {
          versionId: {
            type: "uint32",
            id: 1
          },
          channelId: {
            type: "PBAppChannelId",
            id: 2
          },
          versionName: {
            type: "string",
            id: 3
          },
          versionCode: {
            type: "uint32",
            id: 4
          },
          url: {
            type: "string",
            id: 5
          },
          md5: {
            type: "string",
            id: 6
          },
          updateTitle: {
            type: "string",
            id: 7
          },
          updateContents: {
            type: "string",
            id: 8
          },
          reviewing: {
            type: "bool",
            id: 9
          },
          latest: {
            type: "bool",
            id: 10
          },
          status: {
            type: "PBVersionStatus",
            id: 14
          },
          forceUpdate: {
            type: "bool",
            id: 11
          },
          lastModifyAdmin: {
            type: "PBAdmin",
            id: 12
          },
          lastModifyDate: {
            type: "uint64",
            id: 13
          }
        }
      },
      PBVersionStatus: {
        values: {
          VERSION_REVIEWING: 0,
          VERSION_LATEST: 1,
          VERSION_OLD: 2
        }
      },
      PBAppChannelId: {
        values: {
          APP_CHANNEL_NONE: 0,
          APP_CHANNEL_APP_STORE: 1,
          APP_CHANNEL_GOOGLE_PLAY: 2,
          APP_CHANNEL_OFFICIAL_DOWNLOAD: 3,
          APP_CHANNEL_TENCENT_APPS: 4,
          APP_CHANNEL_360: 5,
          APP_CHANNEL_VIVO: 6,
          APP_CHANNEL_OPPO: 7,
          APP_CHANNEL_XIAOMI: 8,
          APP_CHANNEL_HUAWEI: 9,
          APP_CHANNEL_ALIBABA: 10,
          APP_CHANNEL_SOGOU: 11,
          APP_CHANNEL_MEIZU: 12,
          APP_CHANNEL_BAIDU: 13,
          APP_CHANNEL_91: 14,
          APP_CHANNEL_HIMARKET: 15,
          APP_CHANNEL_ANZHI: 16,
          APP_CHANNEL_MOPO: 17,
          APP_CHANNEL_APPCHINA: 18,
          APP_CHANNEL_GFAN: 19,
          APP_CHANNEL_UNION: 20,
          APP_CHANNEL_MUMAYI: 21,
          APP_CHANNEL_LENOVO: 22,
          APP_CHANNEL_GINOEE: 23,
          APP_CHANNEL_SAMSUNG: 24,
          APP_CHANNEL_FENGBAO: 25,
          APP_CHANNEL_LIEBAO: 26,
          APP_CHANNEL_NUBIYA: 27,
          APP_CHANNEL_SMARTISAN: 28,
          APP_CHANNEL_YUNOS: 29,
          APP_CHANNEL_TONGBU: 30,
          APP_CHANNEL_BACKUP_1: 1001,
          APP_CHANNEL_BACKUP_2: 1002,
          APP_CHANNEL_BACKUP_3: 1003,
          APP_CHANNEL_BACKUP_4: 1004,
          APP_CHANNEL_BACKUP_5: 1005,
          APP_CHANNEL_BACKUP_6: 1006,
          APP_CHANNEL_BACKUP_7: 1007,
          APP_CHANNEL_BACKUP_8: 1008,
          APP_CHANNEL_BACKUP_9: 1009,
          APP_CHANNEL_BACKUP_10: 1010
        }
      },
      PBAppChannel: {
        fields: {
          channelId: {
            type: "PBAppChannelId",
            id: 1
          },
          latestVersion: {
            type: "PBVersion",
            id: 2
          },
          reviewingVersions: {
            rule: "repeated",
            type: "PBVersion",
            id: 3
          },
          allVersions: {
            rule: "repeated",
            type: "PBVersion",
            id: 4
          }
        }
      },
      PBCheckVersionRsp: {
        fields: {
          latestVersion: {
            type: "PBVersion",
            id: 1
          },
          newVersionAvailable: {
            type: "bool",
            id: 2
          },
          forceUpdate: {
            type: "bool",
            id: 3
          },
          reviewing: {
            type: "bool",
            id: 4
          }
        }
      },
      PBListVersionsReq: {
        fields: {
          channelIds: {
            rule: "repeated",
            type: "PBAppChannelId",
            id: 1
          },
          versionName: {
            type: "string",
            id: 2
          },
          status: {
            type: "int32",
            id: 3
          },
          page: {
            type: "PBPagePara",
            id: 9
          }
        }
      },
      PBVersionList: {
        fields: {
          versions: {
            rule: "repeated",
            type: "PBVersion",
            id: 1
          },
          pageInfo: {
            type: "PBPageInfo",
            id: 2
          }
        }
      },
      PBCreateVersionsReq: {
        fields: {
          channelIds: {
            rule: "repeated",
            type: "PBAppChannelId",
            id: 1
          },
          versionName: {
            type: "string",
            id: 2
          },
          versionCode: {
            type: "uint32",
            id: 3
          },
          url: {
            type: "string",
            id: 4
          },
          md5: {
            type: "string",
            id: 5
          },
          updateTitle: {
            type: "string",
            id: 6
          },
          updateContents: {
            type: "string",
            id: 7
          },
          forceUpdate: {
            type: "bool",
            id: 8
          }
        }
      },
      PBUpdateVersionReq: {
        fields: {
          versionId: {
            type: "uint32",
            id: 1
          },
          versionName: {
            type: "string",
            id: 2
          },
          versionCode: {
            type: "uint32",
            id: 3
          },
          url: {
            type: "string",
            id: 4
          },
          md5: {
            type: "string",
            id: 5
          },
          updateTitle: {
            type: "string",
            id: 6
          },
          updateContents: {
            type: "string",
            id: 7
          },
          forceUpdate: {
            type: "bool",
            id: 8
          }
        }
      },
      PBLocation: {
        fields: {
          locationId: {
            type: "uint32",
            id: 1
          },
          oversea: {
            type: "bool",
            id: 2
          },
          continentId: {
            type: "uint32",
            id: 3
          },
          countryId: {
            type: "uint32",
            id: 4
          },
          provinceId: {
            type: "uint32",
            id: 5
          },
          cityId: {
            type: "uint32",
            id: 6
          },
          districtId: {
            type: "uint32",
            id: 7
          },
          provinceName: {
            type: "string",
            id: 9
          },
          cityName: {
            type: "string",
            id: 10
          },
          districtName: {
            type: "string",
            id: 8
          },
          level: {
            type: "PBLocationLevel",
            id: 12
          },
          hot: {
            type: "bool",
            id: 11
          },
          sorted: {
            type: "uint32",
            id: 13
          },
          nameSpelling: {
            type: "string",
            id: 14
          },
          subLocations: {
            rule: "repeated",
            type: "PBLocation",
            id: 15
          },
          shortSpelling: {
            type: "string",
            id: 16
          },
          cityLevel: {
            type: "PBLocationCityLevel",
            id: 17
          }
        }
      },
      PBLocationLevel: {
        values: {
          PROVINCE: 0,
          CITY: 1,
          DISTRICT: 2
        }
      },
      PBLocationCityLevel: {
        values: {
          LOCATION_FIRST_LEVEL_CITY: 0,
          LOCATION_SECOND_LEVEL_CITY: 1,
          LOCATION_OTHER_CITY: 10,
          LOCATION_ALL_CITY: 99
        }
      },
      PBSearchLocationType: {
        values: {
          SEARCH_LOCATION_DISTRICT: 0,
          SEARCH_LOCATION_CITY: 1,
          SEARCH_LOCATION_PROVINCE: 2
        }
      },
      PBLocationQueryReq: {
        fields: {
          higherId: {
            type: "uint32",
            id: 1
          },
          locationName: {
            type: "string",
            id: 2
          }
        }
      },
      PBLocationList: {
        fields: {
          locations: {
            rule: "repeated",
            type: "PBLocation",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 2
          }
        }
      },
      PBUpdateLocationCityLevelReq: {
        fields: {
          cityName: {
            type: "string",
            id: 1
          },
          cityLevel: {
            type: "PBLocationCityLevel",
            id: 2
          }
        }
      },
      PBGetLocationByCityLevelReq: {
        fields: {
          cityLevel: {
            type: "PBLocationCityLevel",
            id: 1
          }
        }
      },
      PBLocationGetAllReq: {
        fields: {
          version: {
            type: "uint64",
            id: 1
          },
          returnType: {
            type: "PBLocationType",
            id: 2
          }
        }
      },
      PBLocationType: {
        values: {
          LOCATIONS_FLAT: 0,
          LOCATIONS_TREE: 1
        }
      },
      PBLocationData: {
        fields: {
          locations: {
            rule: "repeated",
            type: "PBLocation",
            id: 1
          },
          modifyTime: {
            type: "uint64",
            id: 2
          }
        }
      },
      PBLocationDetectReq: {
        fields: {
          longitude: {
            type: "double",
            id: 1
          },
          latitude: {
            type: "double",
            id: 2
          }
        }
      },
      PBGetLocationLntLat: {
        fields: {
          locationId: {
            type: "uint32",
            id: 1
          },
          address: {
            type: "string",
            id: 2
          }
        }
      },
      PBLocationLntLat: {
        fields: {
          longitude: {
            type: "double",
            id: 1
          },
          latitude: {
            type: "double",
            id: 2
          }
        }
      },
      PBCommonBusinessCase: {
        fields: {
          businessCaseId: {
            type: "uint32",
            id: 1
          },
          siteName: {
            type: "string",
            id: 2
          },
          category: {
            type: "string",
            id: 3
          },
          customerName: {
            type: "string",
            id: 4
          },
          customerDesc: {
            type: "string",
            id: 5
          },
          customerLogo: {
            type: "string",
            id: 6
          },
          picture: {
            type: "string",
            id: 7
          },
          order: {
            type: "uint32",
            id: 8
          },
          remarks: {
            type: "string",
            id: 9
          },
          visible: {
            type: "PBCommonBusinessCaseVisible",
            id: 10
          },
          dictionaryRecord: {
            rule: "repeated",
            type: "PBDataDictionaryRecord",
            id: 11
          },
          createDate: {
            type: "uint64",
            id: 12
          },
          modifyDate: {
            type: "uint64",
            id: 13
          },
          createAdmin: {
            type: "framework.PBAdmin",
            id: 14
          },
          modifyAdmin: {
            type: "framework.PBAdmin",
            id: 15
          }
        }
      },
      PBCommonBusinessCaseList: {
        fields: {
          businessCase: {
            rule: "repeated",
            type: "PBCommonBusinessCase",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBCommonBusinessCaseReq: {
        fields: {
          siteName: {
            type: "string",
            id: 1
          },
          category: {
            type: "string",
            id: 2
          },
          keyType: {
            type: "PBCommonBusinessCaseKeyType",
            id: 3
          },
          searchKey: {
            type: "string",
            id: 4
          },
          customerDescLength: {
            type: "uint32",
            id: 5
          },
          visible: {
            type: "PBCommonBusinessCaseVisible",
            id: 6
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBCommonBusinessCaseOrderRangeReq: {
        fields: {
          siteName: {
            type: "string",
            id: 1
          },
          category: {
            type: "string",
            id: 2
          }
        }
      },
      PBCommonBusinessCaseOrderRange: {
        fields: {
          minOrder: {
            type: "uint32",
            id: 1
          },
          maxOrder: {
            type: "uint32",
            id: 2
          }
        }
      },
      PBCommonBusinessCaseKeyType: {
        values: {
          BCKT_CUSTOMER_NAME: 0,
          BCKT_LINK: 1,
          BCKT_DESC: 2,
          BCKT_COMMENT: 3
        }
      },
      PBCommonBusinessCaseVisible: {
        values: {
          BCV_DEFAULT: 0,
          BCV_SHOW: 1,
          BCV_HIDE: 2
        }
      },
      PBBasicConfig: {
        fields: {
          iosSplash: {
            type: "string",
            id: 1
          },
          androidSplash: {
            type: "string",
            id: 2
          },
          iosVersion: {
            type: "PBIOSVersion",
            id: 3
          },
          androidVersion: {
            type: "PBAndroidVersion",
            id: 4
          },
          copyright: {
            type: "string",
            id: 5
          },
          shareConfig: {
            type: "PBShareConfig",
            id: 10
          },
          urlConfig: {
            type: "PBDynamicURLConfig",
            id: 11
          },
          socialConfig: {
            type: "PBSocialAppConfig",
            id: 12
          },
          qiniuHostTokens: {
            rule: "repeated",
            type: "PBQiniuTokenHost",
            id: 13
          },
          httpDnsAccount: {
            type: "string",
            id: 14
          },
          configFileUrl: {
            type: "string",
            id: 15
          },
          businessConfig: {
            type: "bytes",
            id: 30
          }
        }
      },
      PBDynamicURLConfig: {
        fields: {
          officialWebsite: {
            type: "string",
            id: 1
          },
          userAgreementUrl: {
            type: "string",
            id: 2
          },
          weexServerUrl: {
            type: "string",
            id: 3
          },
          officialMobileWebsite: {
            type: "string",
            id: 4
          }
        }
      },
      PBSocialAppConfig: {
        fields: {
          wechatAppKey: {
            type: "string",
            id: 1
          },
          wechatAppSecret: {
            type: "string",
            id: 2
          },
          wechatPublicAccount: {
            type: "string",
            id: 3
          },
          qqAppKey: {
            type: "string",
            id: 11
          },
          qqAppSecret: {
            type: "string",
            id: 12
          },
          qqGroupNumber: {
            type: "string",
            id: 13
          }
        }
      },
      PBQiniuTokenHost: {
        fields: {
          token: {
            type: "string",
            id: 1
          },
          host: {
            type: "string",
            id: 2
          },
          tag: {
            type: "uint32",
            id: 3
          },
          uploadDomain: {
            type: "string",
            id: 4
          }
        }
      },
      PBShareConfig: {
        fields: {
          appShareUrl: {
            type: "string",
            id: 1
          },
          appShareTitle: {
            type: "string",
            id: 2
          },
          appShareDescription: {
            type: "string",
            id: 3
          },
          appLogoUrl: {
            type: "string",
            id: 4
          }
        }
      },
      PBIOSVersion: {
        fields: {
          reviewVersion: {
            type: "string",
            id: 1
          },
          latestVersion: {
            type: "string",
            id: 2
          },
          url: {
            type: "string",
            id: 3
          },
          forceVersions: {
            rule: "repeated",
            type: "string",
            id: 4
          },
          title: {
            type: "string",
            id: 5
          },
          contents: {
            rule: "repeated",
            type: "string",
            id: 6
          }
        }
      },
      PBAndroidVersion: {
        fields: {
          versionCode: {
            type: "uint32",
            id: 1
          },
          versionName: {
            type: "string",
            id: 2
          },
          url: {
            type: "string",
            id: 3
          },
          md5: {
            type: "string",
            id: 4
          },
          title: {
            type: "string",
            id: 5
          },
          contents: {
            rule: "repeated",
            type: "string",
            id: 6
          },
          forceVersions: {
            rule: "repeated",
            type: "string",
            id: 7
          }
        }
      },
      PBLocationConfig: {
        fields: {
          hotCities: {
            rule: "repeated",
            type: "PBLocation",
            id: 1
          },
          others: {
            rule: "repeated",
            type: "PBLocation",
            id: 2
          }
        }
      },
      PBSystemParaConfig: {
        fields: {
          key: {
            type: "string",
            id: 1
          },
          value: {
            type: "string",
            id: 2
          },
          desc: {
            type: "string",
            id: 3
          },
          createTime: {
            type: "uint64",
            id: 4
          },
          modifyTime: {
            type: "uint64",
            id: 5
          }
        }
      },
      PBSystemParaConfigList: {
        fields: {
          configs: {
            rule: "repeated",
            type: "PBSystemParaConfig",
            id: 1
          }
        }
      },
      PBSystemParaReq: {
        fields: {
          key: {
            type: "string",
            id: 1
          },
          defaultValue: {
            type: "string",
            id: 2
          }
        }
      },
      PBFileConfig: {
        fields: {
          configs: {
            keyType: "string",
            type: "string",
            id: 1
          }
        }
      },
      PBDataItemStatus: {
        values: {
          DATA_ITEM_STATUS_NOT_USED: 0,
          DATA_ITEM_STATUS_USING: 1,
          DATA_ITEM_STATUS_BANNED: 2
        }
      },
      PBDataItem: {
        fields: {
          dataItemId: {
            type: "uint32",
            id: 1
          },
          parentId: {
            type: "uint32",
            id: 2
          },
          name: {
            type: "string",
            id: 3
          },
          categoryLabel: {
            type: "string",
            id: 4
          },
          destUrl: {
            type: "string",
            id: 5
          },
          imageUrl: {
            type: "string",
            id: 6
          },
          imageAlt: {
            type: "string",
            id: 7
          },
          children: {
            rule: "repeated",
            type: "PBDataItem",
            id: 8
          },
          status: {
            type: "PBDataItemStatus",
            id: 9
          },
          dictionaryRecord: {
            rule: "repeated",
            type: "PBDataDictionaryRecord",
            id: 10
          },
          siteId: {
            type: "uint32",
            id: 11
          },
          order: {
            type: "uint32",
            id: 12
          }
        }
      },
      PBDataItemAddCategoryReq: {
        fields: {
          name: {
            type: "string",
            id: 1
          },
          categoryLabel: {
            type: "string",
            id: 2
          },
          siteId: {
            type: "uint32",
            id: 3
          },
          status: {
            type: "PBDataItemStatus",
            id: 4
          }
        }
      },
      PBDataItemBGSearchReq: {
        fields: {
          status: {
            rule: "repeated",
            type: "PBDataItemStatus",
            id: 1
          },
          siteId: {
            type: "uint32",
            id: 2
          }
        }
      },
      PBDataItemList: {
        fields: {
          items: {
            rule: "repeated",
            type: "PBDataItem",
            id: 1
          }
        }
      },
      PBDataItemSearchReq: {
        fields: {
          siteId: {
            type: "uint32",
            id: 1
          },
          categoryLabels: {
            rule: "repeated",
            type: "string",
            id: 2
          }
        }
      },
      PBError: {
        values: {
          SUCCESS: 0,
          INTERNAL_ERROR: 10005,
          API_NOT_IMPLEMENTED: 10003,
          BAD_REQUEST: 10008,
          UNSUPPORTED_OPRATION: 10019,
          OBJECT_NOT_FOUND: 10021,
          USER_NOT_LOGIN_YET: 11006,
          USER_ACCESS_TOKEN_EXPIRED: 11007,
          USER_ACCESS_TOKEN_INVALID: 11008,
          ADMIN_ACCESS_TOKEN_EXPIRED: 12002,
          ADMIN_NOT_EXISTS: 12003,
          SITE_NOT_FOUND: 13001,
          INVENTORY_NOT_FOUND: 13002,
          AD_CONTENT_NOT_FOUND: 13003,
          CAMPAIGN_NOT_FOUND: 13004,
          ARTICLE_TYPE_DELETE_ERROR: 13005,
          MODULE_NOT_FOUND: 13006,
          DATA_DICTIONARY_NOT_FOUND: 13007,
          DEFAULT_CAMPAIGN_CAN_NOT_MODIFY_TIME: 13008,
          AD_CONTENT_IMAGE_HEIGHT_ERROR: 13009,
          AD_CONTENT_IMAGE_WIDTH_ERROR: 13010,
          CATRGORY_LABEL_EXIST: 13011,
          PARTNER_ADMIN_NOT_FOUND: 14001,
          PARTNER_ADMIN_PASSWORD_INCORRECT: 14002,
          PARTNER_ADMIN_MOBILE_EXIST: 14003,
          PARTNER_ADMIN_NOT_LOGIN_YET: 14004,
          PARTNER_ADMIN_ACCESS_TOKEN_EXPIRED: 14005,
          PARTNER_ADMIN_ACCESS_TOKEN_INVALID: 14006
        }
      },
      PBFaqCategory: {
        fields: {
          faqCategoryId: {
            type: "uint32",
            id: 1
          },
          parent: {
            type: "PBFaqCategory",
            id: 2
          },
          name: {
            type: "string",
            id: 3
          },
          hot: {
            type: "uint32",
            id: 5
          },
          status: {
            type: "PBFaqCategoryStatus",
            id: 6
          },
          faqNum: {
            type: "uint32",
            id: 7
          },
          isParent: {
            type: "bool",
            id: 8
          },
          faq: {
            type: "PBFaqList",
            id: 9
          },
          icon: {
            type: "string",
            id: 10
          },
          createDate: {
            type: "uint64",
            id: 11
          },
          modifyDate: {
            type: "uint64",
            id: 12
          },
          createAdmin: {
            type: "framework.PBAdmin",
            id: 13
          },
          modifyAdmin: {
            type: "framework.PBAdmin",
            id: 14
          }
        }
      },
      PBFaq: {
        fields: {
          faqId: {
            type: "uint32",
            id: 1
          },
          faqCategory: {
            type: "PBFaqCategory",
            id: 2
          },
          hot: {
            type: "uint32",
            id: 3
          },
          question: {
            type: "string",
            id: 4
          },
          tag: {
            rule: "repeated",
            type: "string",
            id: 5
          },
          queryKeywords: {
            rule: "repeated",
            type: "string",
            id: 6
          },
          title: {
            type: "string",
            id: 7
          },
          keywords: {
            type: "string",
            id: 8
          },
          description: {
            type: "string",
            id: 9
          },
          answer: {
            type: "string",
            id: 10
          },
          status: {
            type: "PBFaqStatus",
            id: 11
          },
          readNum: {
            type: "uint32",
            id: 12
          },
          createDate: {
            type: "uint64",
            id: 15
          },
          modifyDate: {
            type: "uint64",
            id: 16
          },
          createAdmin: {
            type: "framework.PBAdmin",
            id: 17
          },
          modifyAdmin: {
            type: "framework.PBAdmin",
            id: 18
          }
        }
      },
      PBFaqList: {
        fields: {
          faq: {
            rule: "repeated",
            type: "PBFaq",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBFaqCategoryList: {
        fields: {
          faqCategory: {
            rule: "repeated",
            type: "PBFaqCategory",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBRelatedFaqReq: {
        fields: {
          faqId: {
            type: "uint32",
            id: 1
          },
          size: {
            type: "uint32",
            id: 2
          },
          answerLength: {
            type: "uint32",
            id: 3
          }
        }
      },
      PBRootFaqCategoryReq: {
        fields: {
          faqNum: {
            type: "uint32",
            id: 1
          },
          answerLength: {
            type: "uint32",
            id: 2
          }
        }
      },
      PBFaqCategoryReq: {
        fields: {
          keyType: {
            type: "PBFaqCategoryKeyType",
            id: 1
          },
          searchKey: {
            type: "string",
            id: 2
          },
          status: {
            type: "PBFaqCategoryStatus",
            id: 3
          },
          isFillCategoryParent: {
            type: "bool",
            id: 4
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBFaqCategoryInfoReq: {
        fields: {
          faqCategoryId: {
            type: "uint32",
            id: 1
          },
          isFillCategoryParent: {
            type: "bool",
            id: 2
          },
          answerLength: {
            type: "uint32",
            id: 3
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBFaqReq: {
        fields: {
          faqCategoryId: {
            type: "uint32",
            id: 1
          },
          keyType: {
            type: "PBFaqKeyType",
            id: 2
          },
          searchKey: {
            type: "string",
            id: 3
          },
          status: {
            type: "PBFaqStatus",
            id: 4
          },
          orderType: {
            type: "PBFaqOrderType",
            id: 5
          },
          isDescending: {
            type: "bool",
            id: 6
          },
          answerLength: {
            type: "uint32",
            id: 7
          },
          isFillCategoryParent: {
            type: "bool",
            id: 8
          },
          isFillAdmin: {
            type: "bool",
            id: 9
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBFaqCategoryKeyType: {
        values: {
          FCKT_CATEGORY_NAME: 0
        }
      },
      PBFaqKeyType: {
        values: {
          FKT_CONTENT: 0,
          FKT_FAQ_ID: 1
        }
      },
      PBFaqOrderType: {
        values: {
          FOT_CREATE_TIME: 0,
          FOT_UPDATE_TIME: 1,
          FOT_HOT: 2,
          FOT_READ_NUM: 3,
          FOT_HOT_RELATION: 4,
          FOT_FAQ_ID_CUSTOMIZE: 5
        }
      },
      PBFaqStatus: {
        values: {
          FS_DEFAULT: 0,
          FS_SHOW: 1,
          FS_HIDE: 2
        }
      },
      PBFaqCategoryStatus: {
        values: {
          FCS_DEFAULT: 0,
          FCS_SHOW: 1,
          FCS_HIDE: 2
        }
      },
      PBFeedbackStatus: {
        values: {
          FEEDBACK_PENDING: 0,
          FEEDBACK_PROCESSED: 1,
          FEEDBACK_PROCESSING: 2,
          FEEDBACK_IGNORE: 3
        }
      },
      PBFeedback: {
        fields: {
          feedbackId: {
            type: "uint32",
            id: 1
          },
          userId: {
            type: "uint32",
            id: 6
          },
          content: {
            type: "string",
            id: 2
          },
          createDate: {
            type: "uint64",
            id: 3
          },
          deviceType: {
            type: "PBDeviceType",
            id: 4
          },
          appVersion: {
            type: "string",
            id: 5
          },
          remark: {
            type: "string",
            id: 7
          },
          status: {
            type: "PBFeedbackStatus",
            id: 9
          },
          pictures: {
            rule: "repeated",
            type: "string",
            id: 11
          },
          contactInfo: {
            type: "string",
            id: 12
          }
        }
      },
      PBFeedbackList: {
        fields: {
          feedBacks: {
            rule: "repeated",
            type: "PBFeedback",
            id: 1
          },
          pageInfo: {
            type: "PBPageInfo",
            id: 2
          }
        }
      },
      PBGetFeedBackListReq: {
        fields: {
          beginDate: {
            type: "uint64",
            id: 1
          },
          endDate: {
            type: "uint64",
            id: 2
          },
          keyword: {
            type: "string",
            id: 3
          },
          page: {
            type: "PBPagePara",
            id: 8
          }
        }
      },
      PBCreateFeedbackReq: {
        fields: {
          content: {
            type: "string",
            id: 2
          },
          userId: {
            type: "uint32",
            id: 6
          },
          pictures: {
            rule: "repeated",
            type: "string",
            id: 11
          },
          contactInfo: {
            type: "string",
            id: 12
          }
        }
      },
      PBLink: {
        fields: {
          linkId: {
            type: "uint32",
            id: 1
          },
          webName: {
            type: "string",
            id: 2
          },
          url: {
            type: "string",
            id: 3
          },
          order: {
            type: "uint32",
            id: 4
          },
          createDate: {
            type: "uint64",
            id: 5
          },
          updateDate: {
            type: "uint64",
            id: 6
          },
          modifyAdmin: {
            type: "PBAdmin",
            id: 7
          },
          site: {
            type: "string",
            id: 8
          },
          clickCount: {
            type: "int64",
            id: 9
          }
        }
      },
      PBLinkList: {
        fields: {
          links: {
            rule: "repeated",
            type: "PBLink",
            id: 1
          },
          totalClickCount: {
            type: "int64",
            id: 2
          },
          pageInfo: {
            type: "PBPageInfo",
            id: 10
          }
        }
      },
      PBGetLinkListReq: {
        fields: {
          orderType: {
            type: "PBSortType",
            id: 1
          },
          site: {
            rule: "repeated",
            type: "string",
            id: 2
          }
        }
      },
      PBGetLinksCountReq: {
        fields: {
          startDate: {
            type: "string",
            id: 1
          },
          endDate: {
            type: "string",
            id: 2
          },
          site: {
            rule: "repeated",
            type: "string",
            id: 3
          }
        }
      },
      PBGetLinkCountReq: {
        fields: {
          linkId: {
            type: "uint32",
            id: 1
          },
          startDate: {
            type: "string",
            id: 2
          },
          endDate: {
            type: "string",
            id: 3
          }
        }
      },
      PBGetLinkCountRsp: {
        fields: {
          link: {
            type: "PBLink",
            id: 1
          },
          statisticList: {
            rule: "repeated",
            type: "PBLinkClickStatistic",
            id: 2
          },
          dayCount: {
            type: "int32",
            id: 3
          },
          totalCount: {
            type: "int64",
            id: 4
          }
        }
      },
      PBLinkClickStatistic: {
        fields: {
          date: {
            type: "string",
            id: 1
          },
          count: {
            type: "int64",
            id: 2
          }
        }
      },
      PBLinkClickReport: {
        fields: {
          linkId: {
            type: "uint32",
            id: 1
          }
        }
      },
      PBAppPush: {
        fields: {
          pushId: {
            type: "uint64",
            id: 1
          },
          pushType: {
            type: "PBPushType",
            id: 3
          },
          targetType: {
            type: "PBAppPushTargetType",
            id: 4
          },
          targets: {
            rule: "repeated",
            type: "string",
            id: 5
          },
          title: {
            type: "string",
            id: 7
          },
          description: {
            type: "string",
            id: 8
          },
          params: {
            rule: "repeated",
            type: "PBKeyValue",
            id: 9
          },
          createDate: {
            type: "uint64",
            id: 10
          },
          sendDate: {
            type: "uint64",
            id: 11
          },
          status: {
            type: "PBPushStatus",
            id: 12
          },
          rawResult: {
            type: "string",
            id: 13
          },
          admin: {
            type: "PBAdmin",
            id: 15
          },
          sentCount: {
            type: "uint64",
            id: 20
          },
          receivedCount: {
            type: "uint64",
            id: 21
          },
          clickCount: {
            type: "uint64",
            id: 22
          }
        }
      },
      PBAppPushTargetType: {
        values: {
          TARGET_TYPE_DEVICE_ID: 0,
          TARGET_TYPE_ALIAS: 1,
          TARGET_TYPE_TOPIC: 3
        }
      },
      PBPushStatus: {
        values: {
          PUSH_STATUS_PENDING: 0,
          PUSH_STATUS_SUCCESS: 1,
          PUSH_STATUS_FAIL: 2,
          PUSH_STATUS_CANCELED: 3
        }
      },
      PBPushType: {
        values: {
          PUSH_IMMEDIATELY: 0,
          PUSH_SCHEDULED: 1
        }
      },
      PBAppPushProvider: {
        values: {
          PUSH_APPLE_APN: 0,
          PUSH_GOOGLE_GCM: 1,
          PUSH_XIAOMI_ANDROID: 2,
          PUSH_XIAOMI_IOS: 3,
          PUSH_HUAWEI: 4,
          PUSH_OPPO: 5,
          PUSH_VIVO: 6,
          PUSH_MEIZU: 7
        }
      },
      PBSmsPush: {
        fields: {
          pushId: {
            type: "uint64",
            id: 1
          },
          pushType: {
            type: "PBPushType",
            id: 2
          },
          mobile: {
            type: "string",
            id: 3
          },
          content: {
            type: "string",
            id: 4
          },
          createDate: {
            type: "uint64",
            id: 5
          },
          sendDate: {
            type: "uint64",
            id: 6
          },
          status: {
            type: "PBPushStatus",
            id: 7
          },
          errorMsg: {
            type: "string",
            id: 8
          },
          admin: {
            type: "PBAdmin",
            id: 9
          }
        }
      },
      PBWechatMpPush: {
        fields: {
          pushId: {
            type: "uint64",
            id: 1
          },
          pushType: {
            type: "PBPushType",
            id: 2
          },
          miniProgramName: {
            type: "string",
            id: 3
          },
          openId: {
            type: "string",
            id: 4
          },
          templateId: {
            type: "string",
            id: 5
          },
          page: {
            type: "string",
            id: 6
          },
          keywords: {
            rule: "repeated",
            type: "PBWechatMpPushKeyword",
            id: 7
          },
          emphasisKeyword: {
            type: "string",
            id: 8
          },
          createDate: {
            type: "uint64",
            id: 9
          },
          sendDate: {
            type: "uint64",
            id: 10
          },
          status: {
            type: "PBPushStatus",
            id: 11
          },
          result: {
            type: "string",
            id: 12
          },
          admin: {
            type: "PBAdmin",
            id: 13
          }
        }
      },
      PBWechatMpPushKeyword: {
        fields: {
          key: {
            type: "string",
            id: 1
          },
          value: {
            type: "string",
            id: 2
          },
          color: {
            type: "string",
            id: 3
          }
        }
      },
      PBEmailPush: {
        fields: {
          pushId: {
            type: "uint64",
            id: 1
          },
          pushType: {
            type: "PBPushType",
            id: 2
          },
          to: {
            type: "string",
            id: 3
          },
          subject: {
            type: "string",
            id: 4
          },
          content: {
            type: "string",
            id: 5
          },
          createDate: {
            type: "uint64",
            id: 6
          },
          sendDate: {
            type: "uint64",
            id: 7
          },
          status: {
            type: "PBPushStatus",
            id: 8
          },
          errorMsg: {
            type: "string",
            id: 9
          },
          admin: {
            type: "PBAdmin",
            id: 10
          }
        }
      },
      PBCreateAppPushReq: {
        fields: {
          pushType: {
            type: "PBPushType",
            id: 2
          },
          targetType: {
            type: "PBAppPushTargetType",
            id: 3
          },
          targets: {
            rule: "repeated",
            type: "string",
            id: 4
          },
          title: {
            type: "string",
            id: 6
          },
          description: {
            type: "string",
            id: 7
          },
          sendDate: {
            type: "uint64",
            id: 8
          },
          params: {
            rule: "repeated",
            type: "PBKeyValue",
            id: 9
          }
        }
      },
      PBGetAppPushListReq: {
        fields: {
          pushType: {
            type: "int32",
            id: 2
          },
          description: {
            type: "string",
            id: 3
          },
          status: {
            type: "int32",
            id: 4
          },
          beginDate: {
            type: "uint64",
            id: 5
          },
          endDate: {
            type: "uint64",
            id: 6
          },
          byAdminOnly: {
            type: "bool",
            id: 7
          },
          page: {
            type: "PBPagePara",
            id: 9
          }
        }
      },
      PBAppPushList: {
        fields: {
          pushes: {
            rule: "repeated",
            type: "PBAppPush",
            id: 1
          },
          pageInfo: {
            type: "PBPageInfo",
            id: 2
          }
        }
      },
      PBReportRegIdReq: {
        fields: {
          provider: {
            type: "PBAppPushProvider",
            id: 1
          },
          regId: {
            type: "string",
            id: 2
          }
        }
      },
      PBCreateSmsPushReq: {
        fields: {
          pushType: {
            type: "PBPushType",
            id: 1
          },
          mobile: {
            type: "string",
            id: 2
          },
          content: {
            type: "string",
            id: 3
          },
          sendDate: {
            type: "uint64",
            id: 4
          }
        }
      },
      PBGetSmsPushListReq: {
        fields: {
          pushType: {
            type: "int32",
            id: 1
          },
          mobile: {
            type: "string",
            id: 2
          },
          status: {
            type: "int32",
            id: 3
          },
          beginDate: {
            type: "uint64",
            id: 4
          },
          endDate: {
            type: "uint64",
            id: 5
          },
          byAdminOnly: {
            type: "bool",
            id: 6
          },
          page: {
            type: "PBPagePara",
            id: 9
          }
        }
      },
      PBSmsPushList: {
        fields: {
          pushes: {
            rule: "repeated",
            type: "PBSmsPush",
            id: 1
          },
          pageInfo: {
            type: "PBPageInfo",
            id: 2
          }
        }
      },
      PBCreateWechatMpPushReq: {
        fields: {
          pushType: {
            type: "PBPushType",
            id: 1
          },
          miniProgramName: {
            type: "string",
            id: 2
          },
          openId: {
            type: "string",
            id: 3
          },
          templateId: {
            type: "string",
            id: 4
          },
          page: {
            type: "string",
            id: 5
          },
          keywords: {
            rule: "repeated",
            type: "PBWechatMpPushKeyword",
            id: 6
          },
          emphasisKeyword: {
            type: "string",
            id: 7
          },
          sendDate: {
            type: "uint64",
            id: 8
          }
        }
      },
      PBGetWechatMpPushListReq: {
        fields: {
          pushType: {
            type: "int32",
            id: 1
          },
          miniProgramName: {
            type: "string",
            id: 2
          },
          openId: {
            type: "string",
            id: 3
          },
          status: {
            type: "int32",
            id: 4
          },
          beginDate: {
            type: "uint64",
            id: 5
          },
          endDate: {
            type: "uint64",
            id: 6
          },
          byAdminOnly: {
            type: "bool",
            id: 7
          },
          page: {
            type: "PBPagePara",
            id: 9
          }
        }
      },
      PBWechatMpPushList: {
        fields: {
          pushes: {
            rule: "repeated",
            type: "PBWechatMpPush",
            id: 1
          },
          pageInfo: {
            type: "PBPageInfo",
            id: 2
          }
        }
      },
      PBCreateEmailPushReq: {
        fields: {
          pushType: {
            type: "PBPushType",
            id: 1
          },
          to: {
            type: "string",
            id: 2
          },
          content: {
            type: "string",
            id: 3
          },
          subject: {
            type: "string",
            id: 4
          },
          sendDate: {
            type: "uint64",
            id: 5
          }
        }
      },
      PBGetEmailPushListReq: {
        fields: {
          pushType: {
            type: "int32",
            id: 1
          },
          to: {
            type: "string",
            id: 2
          },
          status: {
            type: "int32",
            id: 3
          },
          beginDate: {
            type: "uint64",
            id: 4
          },
          endDate: {
            type: "uint64",
            id: 5
          },
          byAdminOnly: {
            type: "bool",
            id: 6
          },
          page: {
            type: "PBPagePara",
            id: 9
          }
        }
      },
      PBEmailPushList: {
        fields: {
          pushes: {
            rule: "repeated",
            type: "PBEmailPush",
            id: 1
          },
          pageInfo: {
            type: "PBPageInfo",
            id: 2
          }
        }
      },
      PBPageManageRecord: {
        fields: {
          recordId: {
            type: "uint32",
            id: 1
          },
          pageStringId: {
            type: "string",
            id: 2
          },
          remark: {
            type: "string",
            id: 3
          },
          site: {
            type: "string",
            id: 4
          },
          status: {
            type: "PBPageManageRecordStatus",
            id: 5
          },
          title: {
            type: "string",
            id: 6
          },
          keywords: {
            type: "string",
            id: 7
          },
          description: {
            type: "string",
            id: 8
          },
          createDate: {
            type: "uint64",
            id: 10
          },
          modifyDate: {
            type: "uint64",
            id: 11
          },
          createAdmin: {
            type: "framework.PBAdmin",
            id: 12
          },
          modifyAdmin: {
            type: "framework.PBAdmin",
            id: 13
          }
        }
      },
      PBBasicPageManageRecord: {
        fields: {
          recordId: {
            type: "uint32",
            id: 1
          },
          pageStringId: {
            type: "string",
            id: 2
          },
          site: {
            type: "string",
            id: 4
          },
          title: {
            type: "string",
            id: 6
          },
          keywords: {
            type: "string",
            id: 7
          },
          description: {
            type: "string",
            id: 8
          }
        }
      },
      PBPageManageRecordList: {
        fields: {
          record: {
            rule: "repeated",
            type: "PBPageManageRecord",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBPageManageRecordStatus: {
        values: {
          PMRS_DEFAULT: 0,
          PMRS_ENABLE: 1,
          PMRS_DISABLE: 2
        }
      },
      PBSearchPageManageRecordReq: {
        fields: {
          site: {
            type: "string",
            id: 1
          },
          status: {
            type: "PBPageManageRecordStatus",
            id: 2
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBGetBestPageManageRecordReq: {
        fields: {
          pageStringId: {
            type: "string",
            id: 1
          },
          site: {
            type: "string",
            id: 2
          }
        }
      },
      PBShareEvent: {
        fields: {
          eventId: {
            type: "uint64",
            id: 1
          },
          type: {
            type: "uint32",
            id: 2
          },
          channel: {
            type: "PBShareChannel",
            id: 3
          },
          entityId: {
            type: "string",
            id: 4
          },
          extraParams: {
            type: "string",
            id: 5
          },
          device: {
            type: "PBDevice",
            id: 6
          },
          clientIp: {
            type: "string",
            id: 7
          },
          createDate: {
            type: "uint64",
            id: 8
          },
          succeed: {
            type: "bool",
            id: 9
          },
          clickCount: {
            type: "uint32",
            id: 10
          }
        }
      },
      PBShareChannel: {
        values: {
          SHARE_MANUAL: 0,
          SHARE_WECHAT_SESSION: 1,
          SHARE_WECHAT_MOMENT: 2,
          SHARE_QQ: 3,
          SHARE_QQ_ZONE: 4,
          SHARE_WEIBO: 5
        }
      },
      PBCreateShareReq: {
        fields: {
          type: {
            type: "uint32",
            id: 1
          },
          channel: {
            type: "PBShareChannel",
            id: 2
          },
          entityId: {
            type: "string",
            id: 3
          },
          extraParams: {
            type: "string",
            id: 4
          }
        }
      },
      PBShare: {
        fields: {
          eventId: {
            type: "uint64",
            id: 1
          },
          title: {
            type: "string",
            id: 2
          },
          content: {
            type: "string",
            id: 3
          },
          image: {
            type: "string",
            id: 4
          },
          link: {
            type: "string",
            id: 5
          }
        }
      },
      PBSitemap: {
        fields: {
          sitemapId: {
            type: "uint64",
            id: 1
          },
          site: {
            type: "string",
            id: 2
          },
          name: {
            type: "string",
            id: 3
          },
          itemCount: {
            type: "uint32",
            id: 4
          },
          path: {
            type: "string",
            id: 5
          },
          url: {
            type: "string",
            id: 6
          },
          createDate: {
            type: "uint64",
            id: 7
          },
          modifyDate: {
            type: "uint64",
            id: 8
          }
        }
      },
      PBSitemapList: {
        fields: {
          sitemaps: {
            rule: "repeated",
            type: "PBSitemap",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 2
          }
        }
      },
      PBSitemapPushTask: {
        fields: {
          taskId: {
            type: "uint64",
            id: 1
          },
          sitemap: {
            type: "PBSitemap",
            id: 2
          },
          status: {
            type: "PBSitemapPushStatus",
            id: 3
          },
          engineType: {
            type: "PBSearchEngineType",
            id: 4
          },
          pushCount: {
            type: "uint32",
            id: 5
          },
          successCount: {
            type: "uint32",
            id: 6
          },
          createDate: {
            type: "uint64",
            id: 7
          },
          modifyDate: {
            type: "uint64",
            id: 8
          }
        }
      },
      PBSitemapPushTaskList: {
        fields: {
          tasks: {
            rule: "repeated",
            type: "PBSitemapPushTask",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 2
          }
        }
      },
      PBSitemapChangeFreqType: {
        values: {
          SCFT_ALWAYS: 0,
          SCFT_HOURLY: 1,
          SCFT_DAILY: 2,
          SCFT_WEEKLY: 3,
          SCFT_MONTHLY: 4,
          SCFT_YEARLY: 5,
          SCFT_NEVER: 6
        }
      },
      PBSitemapPushStatus: {
        values: {
          SPS_PENDING: 0,
          SPS_PUSHED: 1,
          SPS_FAILURE: 2,
          SPS_ALL: 99
        }
      },
      PBSearchEngineType: {
        values: {
          SET_BAIDU: 0,
          SET_SHENMA: 1,
          SET_SOGOU: 2,
          SET_360: 3,
          SET_GOOGLE: 4,
          SET_ALL: 99
        }
      },
      PBSitemapPushReq: {
        fields: {
          sitemapId: {
            type: "uint64",
            id: 1
          },
          engineType: {
            type: "PBSearchEngineType",
            id: 2
          }
        }
      },
      PBSitemapSearchReq: {
        fields: {
          site: {
            type: "string",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          page: {
            type: "PBPagePara",
            id: 10
          }
        }
      },
      PBSitemapPushTaskSearchReq: {
        fields: {
          site: {
            type: "string",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          status: {
            type: "PBSitemapPushStatus",
            id: 3
          },
          engineType: {
            type: "PBSearchEngineType",
            id: 4
          },
          page: {
            type: "PBPagePara",
            id: 10
          }
        }
      },
      PBSplash: {
        fields: {
          splashId: {
            type: "uint32",
            id: 1
          },
          imageUrl: {
            type: "string",
            id: 2
          },
          image169: {
            type: "string",
            id: 3
          },
          image189: {
            type: "string",
            id: 4
          },
          openUrl: {
            type: "string",
            id: 6
          },
          countDown: {
            type: "uint32",
            id: 7
          },
          splashBeginDate: {
            type: "uint64",
            id: 8
          },
          splashEndDate: {
            type: "uint64",
            id: 9
          },
          visible: {
            type: "bool",
            id: 10
          },
          createDate: {
            type: "uint64",
            id: 11
          },
          updateDate: {
            type: "uint64",
            id: 12
          },
          modifyAdmin: {
            type: "framework.PBAdmin",
            id: 13
          },
          deviceType: {
            type: "PBSplashDeviceType",
            id: 14
          }
        }
      },
      PBGetSplashListReq: {
        fields: {
          beginDate: {
            type: "uint64",
            id: 1
          },
          endDate: {
            type: "uint64",
            id: 2
          },
          visible: {
            type: "PBBoolValue",
            id: 3
          },
          page: {
            type: "PBPagePara",
            id: 4
          },
          deviceType: {
            type: "PBSplashDeviceType",
            id: 5
          }
        }
      },
      PBSplashList: {
        fields: {
          splashes: {
            rule: "repeated",
            type: "PBSplash",
            id: 1
          },
          pageInfo: {
            type: "PBPageInfo",
            id: 2
          }
        }
      },
      PBGetSplashReq: {
        fields: {
          validScreenWidth: {
            type: "uint32",
            id: 1
          },
          validScreenHeight: {
            type: "uint32",
            id: 2
          }
        }
      },
      PBSplashDeviceType: {
        values: {
          SDT_ALL: 0,
          SDT_ANDROID: 1,
          SDT_IOS: 2
        }
      },
      PBTicket: {
        fields: {
          ticketId: {
            type: "uint64",
            id: 1
          },
          type: {
            type: "PBTicketType",
            id: 2
          },
          status: {
            type: "PBTicketStatus",
            id: 3
          },
          ticketUserId: {
            type: "uint64",
            id: 4
          },
          ticketUserName: {
            type: "string",
            id: 5
          },
          ticketUserEmail: {
            type: "string",
            id: 6
          },
          userIdType: {
            type: "PBTicketUserIdType",
            id: 7
          },
          content: {
            type: "string",
            id: 8
          },
          attachment: {
            rule: "repeated",
            type: "string",
            id: 9
          },
          admin: {
            type: "PBAdmin",
            id: 10
          },
          createDate: {
            type: "uint64",
            id: 11
          },
          ticketUserUnreadCount: {
            type: "uint32",
            id: 12
          },
          adminUnreadCount: {
            type: "uint32",
            id: 13
          },
          lastReplyDate: {
            type: "uint64",
            id: 16
          },
          closeReasonType: {
            type: "PBCloseReasonType",
            id: 17
          },
          urgency: {
            type: "PBTicketUrgency",
            id: 18
          },
          priority: {
            type: "PBTicketPriority",
            id: 19
          },
          extraData: {
            rule: "repeated",
            type: "PBTicketExtraData",
            id: 30
          },
          ticketCode: {
            type: "string",
            id: 31
          },
          referer: {
            type: "string",
            id: 40
          },
          ip: {
            type: "string",
            id: 41
          },
          ipRegion: {
            type: "string",
            id: 42
          },
          device: {
            type: "PBDevice",
            id: 43
          },
          browser: {
            type: "string",
            id: 44
          },
          userLastReplyIp: {
            type: "string",
            id: 45
          },
          userLastReplyIpRegion: {
            type: "string",
            id: 46
          },
          isAdminRead: {
            type: "bool",
            id: 50
          }
        }
      },
      PBTicketList: {
        fields: {
          ticket: {
            rule: "repeated",
            type: "PBTicket",
            id: 1
          },
          pageInfo: {
            type: "PBPageInfo",
            id: 20
          }
        }
      },
      PBTicketOperation: {
        fields: {
          operationId: {
            type: "uint64",
            id: 1
          },
          ticket: {
            type: "PBTicket",
            id: 2
          },
          operationType: {
            type: "PBTicketOperationType",
            id: 3
          },
          initiateParty: {
            type: "PBTicketInitiateParty",
            id: 4
          },
          admin: {
            type: "PBAdmin",
            id: 5
          },
          ticketUserId: {
            type: "uint64",
            id: 6
          },
          assignedAdmin: {
            type: "PBAdmin",
            id: 20
          },
          content: {
            type: "string",
            id: 31
          },
          attachment: {
            rule: "repeated",
            type: "string",
            id: 32
          },
          ticketStatus: {
            type: "PBTicketStatus",
            id: 41
          },
          closeReasonType: {
            type: "PBCloseReasonType",
            id: 42
          },
          remark: {
            type: "string",
            id: 43
          },
          ticketType: {
            type: "PBTicketType",
            id: 51
          },
          ticketPriority: {
            type: "PBTicketPriority",
            id: 52
          },
          ip: {
            type: "string",
            id: 53
          },
          ipRegion: {
            type: "string",
            id: 54
          },
          history: {
            type: "PBTicketHistory",
            id: 70
          },
          createDate: {
            type: "uint64",
            id: 60
          },
          modifiedOperation: {
            type: "PBTicketOperation",
            id: 80
          }
        }
      },
      PBTicketOperationList: {
        fields: {
          operation: {
            rule: "repeated",
            type: "PBTicketOperation",
            id: 1
          },
          pageInfo: {
            type: "PBPageInfo",
            id: 20
          }
        }
      },
      PBTicketReply: {
        fields: {
          operation: {
            type: "PBTicketOperation",
            id: 1
          },
          replierName: {
            type: "string",
            id: 2
          },
          content: {
            type: "string",
            id: 3
          },
          attachment: {
            rule: "repeated",
            type: "string",
            id: 4
          },
          isRead: {
            type: "bool",
            id: 5
          },
          initiateParty: {
            type: "PBTicketInitiateParty",
            id: 6
          },
          createDate: {
            type: "uint64",
            id: 10
          },
          admin: {
            type: "PBAdmin",
            id: 11
          },
          modifyDate: {
            type: "uint64",
            id: 12
          },
          modifyAdmin: {
            type: "PBAdmin",
            id: 13
          }
        }
      },
      PBTicketReplyList: {
        fields: {
          reply: {
            rule: "repeated",
            type: "PBTicketReply",
            id: 1
          },
          pageInfo: {
            type: "PBPageInfo",
            id: 20
          }
        }
      },
      PBTicketType: {
        fields: {
          typeId: {
            type: "uint64",
            id: 1
          },
          typeName: {
            type: "string",
            id: 2
          },
          desc: {
            type: "string",
            id: 3
          },
          typeReplyName: {
            type: "string",
            id: 4
          },
          isDefault: {
            type: "bool",
            id: 5
          },
          isDeleted: {
            type: "bool",
            id: 6
          }
        }
      },
      PBTicketExtraData: {
        fields: {
          key: {
            type: "string",
            id: 1
          },
          value: {
            type: "string",
            id: 2
          },
          displayName: {
            type: "string",
            id: 3
          },
          url: {
            type: "string",
            id: 4
          }
        }
      },
      PBTicketTypeList: {
        fields: {
          type: {
            rule: "repeated",
            type: "PBTicketType",
            id: 1
          }
        }
      },
      PBTicketHistory: {
        fields: {
          historyId: {
            type: "uint64",
            id: 1
          },
          operationType: {
            type: "PBTicketOperationType",
            id: 2
          },
          initiateParty: {
            type: "PBTicketInitiateParty",
            id: 3
          },
          beforeTicket: {
            type: "PBTicket",
            id: 4
          },
          ticket: {
            type: "PBTicket",
            id: 5
          },
          createDate: {
            type: "uint64",
            id: 6
          }
        }
      },
      PBTicketHistoryList: {
        fields: {
          history: {
            rule: "repeated",
            type: "PBTicketHistory",
            id: 1
          }
        }
      },
      PBTicketAssignRule: {
        fields: {
          ruleId: {
            type: "uint64",
            id: 1
          },
          admin: {
            type: "PBAdmin",
            id: 2
          },
          ticketType: {
            type: "PBTicketType",
            id: 3
          }
        }
      },
      PBTicketAssignRuleList: {
        fields: {
          rule: {
            rule: "repeated",
            type: "PBTicketAssignRule",
            id: 1
          }
        }
      },
      PBTicketStatus: {
        values: {
          TS_SUBMITTED: 0,
          TS_ASSIGNED: 1,
          TS_PROCESSING: 2,
          TS_RESOLVED: 3,
          TS_CLOSED: 4
        }
      },
      PBTicketUserIdType: {
        values: {
          TUIT_UNREGISTERED: 0,
          TUIT_REGISTERED: 1
        }
      },
      PBTicketInitiateParty: {
        values: {
          TIP_USER: 0,
          TIP_ADMIN: 1,
          TIP_SYSTEM: 2
        }
      },
      PBTicketOperationType: {
        values: {
          TOT_CREATE: 0,
          TOT_REPLY: 1,
          TOT_ASSIGN: 2,
          TOT_PROCESS: 3,
          TOT_RESOLVE: 4,
          TOT_CLOSE: 5,
          TOT_MODIFY_TYPE: 6,
          TOT_REMARK: 7,
          TOT_MODIFY_PRIORITY: 8,
          TOT_MODIFY_REPLY: 9
        }
      },
      PBCloseReasonType: {
        values: {
          CRT_RESOLVED: 0,
          CRT_UNABLE_RESOLVED: 1,
          CRT_INVALID_CONSULTING: 2,
          CRT_OTHER: 3
        }
      },
      PBTicketUrgency: {
        values: {
          TU_NONE: 0,
          TU_NORMAL: 1,
          TU_VERY_URGENT: 2
        }
      },
      PBTicketPriority: {
        values: {
          TP_NORMAL: 0,
          TP_IMPORTANT: 2
        }
      },
      PBTicketAddReq: {
        fields: {
          email: {
            type: "string",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          type: {
            type: "PBTicketType",
            id: 3
          },
          content: {
            type: "string",
            id: 4
          },
          attachment: {
            rule: "repeated",
            type: "string",
            id: 5
          },
          urgency: {
            type: "PBTicketUrgency",
            id: 6
          },
          extraData: {
            rule: "repeated",
            type: "PBTicketExtraData",
            id: 30
          },
          referer: {
            type: "string",
            id: 40
          },
          browser: {
            type: "string",
            id: 41
          }
        }
      },
      PBTicketReplyReq: {
        fields: {
          ticketId: {
            type: "uint64",
            id: 1
          },
          content: {
            type: "string",
            id: 2
          },
          attachment: {
            rule: "repeated",
            type: "string",
            id: 3
          },
          status: {
            type: "PBTicketStatus",
            id: 4
          },
          closeReasonType: {
            type: "PBCloseReasonType",
            id: 5
          },
          remark: {
            type: "string",
            id: 6
          }
        }
      },
      PBTicketReplyModifyReq: {
        fields: {
          operationId: {
            type: "uint64",
            id: 1
          },
          content: {
            type: "string",
            id: 2
          }
        }
      },
      PBTicketSearchReq: {
        fields: {
          dateType: {
            type: "PBTicketSearchDateType",
            id: 1
          },
          beginDate: {
            type: "uint64",
            id: 2
          },
          endDate: {
            type: "uint64",
            id: 3
          },
          keyType: {
            type: "PBTicketSearchKeyType",
            id: 4
          },
          searchKey: {
            type: "string",
            id: 5
          },
          status: {
            rule: "repeated",
            type: "PBTicketStatus",
            id: 6
          },
          ticketTypeId: {
            type: "int64",
            id: 7
          },
          adminId: {
            type: "int64",
            id: 8
          },
          urgency: {
            type: "int32",
            id: 9
          },
          priority: {
            type: "int32",
            id: 10
          },
          extraCondition: {
            rule: "repeated",
            type: "PBTicketExtraData",
            id: 19
          },
          page: {
            type: "PBPagePara",
            id: 20
          }
        }
      },
      PBTicketSearchItem: {
        fields: {
          ticket: {
            type: "PBTicket",
            id: 1
          },
          userFirstConsultDate: {
            type: "uint64",
            id: 2
          },
          userFirstConsultContent: {
            type: "string",
            id: 3
          },
          userLastReplyDate: {
            type: "uint64",
            id: 4
          },
          userLastReplyContent: {
            type: "string",
            id: 5
          },
          adminLastReplyDate: {
            type: "uint64",
            id: 6
          },
          adminLastReplyContent: {
            type: "string",
            id: 7
          },
          lastRemarkDate: {
            type: "uint64",
            id: 8
          },
          lastRemark: {
            type: "string",
            id: 9
          },
          lastRemarkAdmin: {
            type: "PBAdmin",
            id: 10
          },
          isReadUserLastReply: {
            type: "bool",
            id: 11
          },
          isReadAdminLastReply: {
            type: "bool",
            id: 12
          },
          isReadFirstConsult: {
            type: "bool",
            id: 13
          }
        }
      },
      PBTicketSearchList: {
        fields: {
          item: {
            rule: "repeated",
            type: "PBTicketSearchItem",
            id: 1
          },
          pageInfo: {
            type: "PBPageInfo",
            id: 20
          }
        }
      },
      PBTicketSearchDateType: {
        values: {
          TSDT_DEFAULT: 0,
          TSDT_CREATE_DATE: 1,
          TSDT_LAST_REPLY_DATE: 2
        }
      },
      PBTicketSearchKeyType: {
        values: {
          TSKT_DEFAULT: 0,
          TSKT_ADMIN_NAME: 1,
          TSKT_USER_NAME: 2,
          TSKT_USER_EMAIL: 3,
          TSKT_TICKET_ID: 4,
          TSKT_USER_ID: 5,
          TSKT_ADMIN_ID: 6
        }
      },
      PBTicketListReq: {
        fields: {
          page: {
            type: "PBPagePara",
            id: 20
          }
        }
      },
      PBTicketReplyListReq: {
        fields: {
          ticketId: {
            type: "uint64",
            id: 1
          },
          page: {
            type: "PBPagePara",
            id: 20
          }
        }
      },
      PBTicketStatusModifyReq: {
        fields: {
          ticketId: {
            type: "uint64",
            id: 1
          },
          targetStatus: {
            type: "PBTicketStatus",
            id: 2
          },
          closeReasonType: {
            type: "PBCloseReasonType",
            id: 3
          },
          remark: {
            type: "string",
            id: 4
          }
        }
      },
      PBTicketTypeModifyReq: {
        fields: {
          ticketId: {
            type: "uint64",
            id: 1
          },
          targetTypeId: {
            type: "uint64",
            id: 2
          }
        }
      },
      PBTicketAssignReq: {
        fields: {
          ticketId: {
            type: "uint64",
            id: 1
          },
          assignedAdminId: {
            type: "uint64",
            id: 2
          },
          remark: {
            type: "string",
            id: 3
          }
        }
      },
      PBTicketRemarkReq: {
        fields: {
          ticketId: {
            type: "uint64",
            id: 1
          },
          remark: {
            type: "string",
            id: 2
          }
        }
      },
      PBTicketPriorityModifyReq: {
        fields: {
          ticketId: {
            type: "uint64",
            id: 1
          },
          priority: {
            type: "PBTicketPriority",
            id: 2
          }
        }
      },
      PBTicketCount: {
        fields: {
          count: {
            type: "uint64",
            id: 1
          },
          userId: {
            type: "uint64",
            id: 2
          }
        }
      },
      PBTicketCountList: {
        fields: {
          item: {
            rule: "repeated",
            type: "PBTicketCount",
            id: 1
          }
        }
      },
      PBTicketCountReq: {
        fields: {
          userId: {
            rule: "repeated",
            type: "uint64",
            id: 1
          }
        }
      },
      PBGetWechatAccessTokenReq: {
        fields: {
          programName: {
            type: "string",
            id: 1
          },
          forceRefresh: {
            type: "bool",
            id: 2
          }
        }
      },
      PBGetWechatJsSdkConfigReq: {
        fields: {
          programName: {
            type: "string",
            id: 1
          },
          url: {
            type: "string",
            id: 2
          }
        }
      },
      PBWechatJsSdkConfig: {
        fields: {
          appId: {
            type: "string",
            id: 1
          },
          timestamp: {
            type: "uint64",
            id: 2
          },
          nonceStr: {
            type: "string",
            id: 3
          },
          signature: {
            type: "string",
            id: 4
          }
        }
      },
      PBReportFormIdReq: {
        fields: {
          programName: {
            type: "string",
            id: 1
          },
          openId: {
            type: "string",
            id: 2
          },
          formId: {
            type: "string",
            id: 3
          }
        }
      },
      PBMiniProgramLoginReq: {
        fields: {
          programName: {
            type: "string",
            id: 1
          },
          code: {
            type: "string",
            id: 2
          }
        }
      },
      PBWechatAccount: {
        fields: {
          unionId: {
            type: "string",
            id: 1
          },
          openId: {
            type: "string",
            id: 2
          },
          programName: {
            type: "string",
            id: 9
          },
          name: {
            type: "string",
            id: 3
          },
          avatar: {
            type: "string",
            id: 4
          },
          sex: {
            type: "PBSex",
            id: 5
          },
          province: {
            type: "string",
            id: 6
          },
          city: {
            type: "string",
            id: 7
          },
          country: {
            type: "string",
            id: 8
          }
        }
      }
    }
  },
  fwGame: {
    nested: {
      PBDataStatus: {
        values: {
          NORMAL: 0,
          ABNORMAL: 1,
          TRASH: 2,
          MAPPING_FAILED: 3,
          MERGE_FAILED: 4
        }
      },
      PBDataSource: {
        values: {
          DATA_DEFAULT: 0,
          VPGAME: 1,
          HLTV: 2,
          FAMULEI: 3,
          OURESPORTS: 4,
          DS_U_WIN_MAX: 5,
          DS_XX_DIAN_JING: 6,
          DS_ANG_GAME: 7,
          DS_LEIHUO: 8,
          DS_RAYBET: 9,
          DS_AVIAGAMING: 10,
          DS_UNIKRN: 11,
          DS_PANDA_SCORE: 12,
          DS_T2_SCORE: 13,
          DS_PUBG_8X: 14,
          DS_VK: 15,
          DS_HUPU: 16,
          DS_BET365: 17,
          DS_ESPORTS8: 18
        }
      },
      PBLeagueStatus: {
        values: {
          LS_WAITING: 0,
          LS_PROCESSING: 1,
          LS_FINISH: 2,
          LS_DELAY: 3,
          LS_DELETE: 4
        }
      },
      PBMatchStatus: {
        values: {
          MS_WAIT: 0,
          MS_START: 1,
          MS_END: 2,
          MS_DELAY: 3,
          MS_DELETE: 4
        }
      },
      PBBetSource: {
        values: {
          VP_GAME: 0,
          U_WIN_MAX: 1,
          OUR_SPORT: 2,
          DIAN_JING: 3,
          ANG_GAME: 4,
          LEIHUO: 5,
          RAYBET: 6,
          AVIAGAMING: 7,
          UNIKRN: 8,
          VK: 9,
          BET365: 10
        }
      },
      PBBetStatus: {
        values: {
          NO_START: 0,
          PLAYING: 1,
          FINISHED: 2,
          CANCEL: 3,
          LOCKED: 4
        }
      },
      PBCsgoBetType: {
        values: {
          CSGO_DEFAULT: 0,
          CSGO_GAME_WIN: 1,
          CSGO_ROUND_WIN: 2,
          CSGO_PISTOL_BOARD_WIN: 3,
          CSGO_GAME_HANDICAP: 4,
          CSGO_ROUND_HANDICAP: 5,
          CSGO_SIZE_POINT: 6,
          CSGO_HEAD_TOTAL_PARITY: 7,
          CSGO_ROUND_PARITY: 8,
          CSGO_FOURTH_ROUND_WINNER: 9,
          CSGO_SIX_ROUND_WINNER: 10,
          CSGO_EIGHT_ROUND_WINNER: 11,
          CSGO_TEN_ROUND_WINNER: 12,
          CSGO_IS_OVERTIME: 13,
          CSGO_BOMB_MAX_WIN: 14,
          CSGO_BOMB_WIN_SIZE: 15,
          CSGO_BOMB_WIN_TEAM: 16,
          CSGO_BOMB_REMOVE_PARITY: 17,
          CSGO_BOMB_REMOVE_SIZE: 18,
          CSGO_FIRST_ROUND_FIVE: 19,
          CSGO_FIRST_ROUND_TEN: 20,
          CSGO_CORRECT_SCORE: 21,
          CSGO_TOTAL_MAP_SIZE: 22
        }
      },
      PBLolBetType: {
        values: {
          LOL_DEFAULT: 0,
          LOL_GAME_WIN: 1,
          LOL_ROUND_WIN: 2,
          LOL_GAME_HANDICAP: 3,
          LOL_FIRST_KILL: 4,
          LOL_FIVE_KILL: 5,
          LOL_TEN_KILL: 6,
          LOL_FIRST_TOWER: 7,
          LOL_SMALL_DRAGON: 8,
          LOL_BIG_DRAGON: 9,
          LOL_HEAD_TOTAL_PARITY: 10,
          LOL_TOTAL_KILL: 11,
          LOL_MATCH_DURATION: 12,
          LOL_FIVE_M_FIRST_KILL: 13,
          LOL_KILL_MAX: 14,
          LOL_DRAGON_ELEMENT: 15,
          LOL_DRAGON_ELEMENT_WATER: 16,
          LOL_DRAGON_ELEMENT_EARTH: 17,
          LOL_DRAGON_ELEMENT_FIRE: 18,
          LOL_DRAGON_ELEMENT_WIND: 19,
          LOL_DRAGON_KILL_D_S: 20,
          LOL_FIRST_KILL_CANYON: 21,
          LOL_FIRST_TOWER_TIME: 22,
          LOL_TOWER_SIZE: 23,
          LOL_TOWER_PARITY: 24,
          LOL_CRYSTAL_BARRACKS: 25,
          LOL_TEN_M_KILL: 26,
          LOL_TWENTY_M_KILL: 27,
          LOL_CORRECT_SCORE: 28,
          LOL_TOTAL_MAP_SIZE: 29,
          LOL_ROUND_HANDICAP: 30,
          LOL_ROUND_TOTAL_KILL: 31
        }
      },
      PBDotaBetType: {
        values: {
          DOTA_DEFAULT: 0,
          DOTA_GAME_WIN: 1,
          DOTA_ROUND_WIN: 2,
          DOTA_GAME_HANDICAP: 3,
          DOTA_FIRST_KILL: 4,
          DOTA_FIVE_KILL: 5,
          DOTA_TEN_KILL: 6,
          DOTA_GAME_TIME_SIZE: 7,
          DOTA_HEAD_TOTAL_PARITY: 8,
          DOTA_FIRST_TOWER: 9,
          DOTA_FIRST_BARRACKS: 10,
          DOTA_FIRST_MEAT: 11,
          DOTA_FIFTEENTH_KILL: 12,
          DOTA_TWENTY_KILL: 13,
          DOTA_THIRTY_KILL: 14,
          DOTA_FORTY_KILL: 15,
          DOTA_FIFTY_KILL: 16,
          DOTA_FIRST_RUNE: 17,
          DOTA_EIGHT_M_RUNE: 18,
          DOTA_TEN_M_RUNE: 19,
          DOTA_TWELVE_RUNE: 20,
          DOTA_BOUNTY_RUNE: 21,
          DOTA_FEATURES_RUNE: 22,
          DOTA_JUMP_KNIFE: 23,
          DOTA_BLACK_KING: 24,
          DOTA_SINGLE_TIME: 25,
          DOTA_TEN_M_KILL_SIZE: 26,
          DOTA_TWENTY_M_KILL_SIZE: 27,
          DOTA_THIRTY_M_KILL_SIZE: 28,
          DOTA_CORRECT_SCORE: 29,
          DOTA_TOTAL_MAP_SIZE: 30,
          DOTA_ROUND_HANDICAP: 31,
          DOTA_ROUND_TOTAL_KILL: 32,
          DOTA_TOTAL_KILL: 33
        }
      },
      PBOwBetType: {
        values: {
          OW_DEFAULT: 0,
          OW_GAME_WIN: 1,
          OW_GAME_HANDICAP: 2
        }
      },
      PBKogBetType: {
        values: {
          KOG_DEFAULT: 0,
          KOG_GAME_WIN: 1,
          KOG_ROUND_WIN: 2,
          KOG_GAME_HANDICAP: 3,
          KOG_FIVE_KILL: 4,
          KOG_TEN_KILL: 5,
          KOG_HEAD_TOTAL_PARITY: 6
        }
      },
      PBPubgBetType: {
        values: {
          PUBG_DEFAULT: 0,
          PUBG_FIVE_KILL: 1,
          PUBG_FIRST_FIVE: 2,
          PUBG_TOTAL_KILL: 3,
          PUBG_MOST_KILL: 4
        }
      },
      PBLeagueStatsRangeType: {
        values: {
          LSRT_DEFAULT: 0,
          LSRT_FIVE_BATTLE: 1,
          LSRT_TEN_BATTLE: 2
        }
      },
      PBMatchAnalysisStatsRangeType: {
        values: {
          MASRT_DEFAULT: 0,
          MASRT_FIVE_BATTLE: 1,
          MASRT_FIFTEEN_BATTLE: 2,
          MASRT_TWENTY_BATTLE: 3,
          MASRT_THIRTY_BATTLE: 8,
          MASRT_FIVE_MATCH: 4,
          MASRT_TEN_MATCH: 5,
          MASRT_FIFTEEN_MATCH: 6,
          MASRT_TWENTY_MATCH: 7
        }
      },
      PBMatchCommentType: {
        values: {
          MCT_DEFAULT: 0,
          MCT_TEAM_A_ABANDONING: 1,
          MCT_TEAM_B_ABANDONING: 2
        }
      },
      PBRestartSpiderReq: {
        fields: {
          gameType: {
            type: "PBGameType",
            id: 1
          },
          tableType: {
            type: "PBTableType",
            id: 2
          },
          primaryKeyID: {
            type: "string",
            id: 3
          },
          source: {
            type: "string",
            id: 4
          }
        }
      },
      PBDataNormalReq: {
        fields: {
          tableType: {
            type: "PBTableType",
            id: 1
          },
          objectId: {
            type: "string",
            id: 2
          }
        }
      },
      PBActionType: {
        values: {
          ACTION_UPDATE: 0,
          ACTION_DELETE: 1
        }
      },
      PBGameType: {
        values: {
          ALL: 0,
          LOL: 1,
          DOTA: 2,
          CSGO: 3,
          KOG: 4,
          OW: 5,
          PUBG: 6,
          RAINBOW: 7,
          OW2: 8,
          ROCKET: 9,
          SC2: 10,
          HOS: 11,
          HS: 12,
          ESPORTS: 99
        }
      },
      PBParticipantType: {
        values: {
          TEAM: 0,
          PLAYER: 1
        }
      },
      PBTableType: {
        values: {
          TABLE_DEFAULT: 0,
          CSGO_BATTLE: 1000,
          CSGO_BATTLE_PLAYER_STATISTICS: 1001,
          CSGO_BATTLE_TEAM_STATISTICS: 1002,
          CSGO_BET: 1003,
          CSGO_ROLLING_BET: 1016,
          CSGO_LEAGUE: 1004,
          CSGO_LIVE_BATTLE: 1005,
          CSGO_LIVE_GAME_LOG_LIST: 1006,
          CSGO_MATCH: 1007,
          CSGO_MATCH_PLAYER_STATISTICS: 1008,
          CSGO_PLAYER: 1009,
          CSGO_PLAYER_STATISTICS: 1010,
          CSGO_TEAM: 1011,
          CSGO_TEAM_STATISTICS: 1012,
          CSGO_TOP_PLAYER: 1013,
          CSGO_TOP_TEAM: 1014,
          CSGO_TOP_WEAPON: 1015,
          CSGO_LIVE_SCORE: 1017,
          CSGO_MATCH_LIVE: 1018,
          CSGO_TEAM_RANK: 1019,
          CSGO_MATCH_ANALYSIS: 1020,
          DOTA_BATTLE: 2000,
          DOTA_BATTLE_PLAYER_STATISTICS: 2001,
          DOTA_BATTLE_TEAM_STATISTICS: 2002,
          DOTA_BET: 2003,
          DOTA_ROLLING_BET: 2021,
          DOTA_GAME_ITEM: 2004,
          DOTA_GAME_LOG: 2005,
          DOTA_GROUP: 2006,
          DOTA_GROUP_TEAM_RANK: 2007,
          DOTA_HERO: 2008,
          DOTA_LEAGUE: 2009,
          DOTA_MATCH: 2010,
          DOTA_PLAYER: 2011,
          DOTA_STAGE: 2012,
          DOTA_SUB_LEAGUE: 2013,
          DOTA_TEAM: 2014,
          DOTA_TEAM_HERO_STATISTICS: 2015,
          DOTA_TEAM_MATCH_STATISTICS: 2016,
          DOTA_TEAM_WIN_RATE_STATISTICS: 2017,
          DOTA_TI_LEAGUE_BOARD_TEAM: 2018,
          DOTA_TI_PLAYER_RANK: 2019,
          DOTA_TI_TEAM_RANK: 2020,
          DOTA_MATCH_PROSPECT: 2022,
          DOTA_MATCH_LIVE_VIDEO: 2023,
          DOTA_MATCH_ANALYSIS: 2024,
          DOTA_LEAGUE_TEAM_STATS: 2025,
          DOTA_LEAGUE_PLAYER_STATS: 2026,
          DOTA_LEAGUE_HERO_STATS: 2027,
          DOTA_LEAGUE_BOARD: 2028,
          DOTA_TEAM_RANK: 2029,
          DOTA_MATCH_LIVE: 2030,
          DOTA_TEAM_LEAGUE_AWARD: 2031,
          KOG_BATTLE: 3000,
          KOG_BATTLE_PLAYER_STATISTICS: 3001,
          KOG_BATTLE_TEAM_STATISTICS: 3002,
          KOG_BET: 3003,
          KOG_ROLLING_BET: 3018,
          KOG_GAME_ITEM: 3004,
          KOG_HERO: 3005,
          KOG_HERO_STATISTICS: 3006,
          KOG_LEAGUE: 3007,
          KOG_LEAGUE_BOARD: 3008,
          KOG_LEAGUE_PLAYER_STATISTICS: 3009,
          KOG_LEAGUE_TEAM_STATISTICS: 3010,
          KOG_MATCH: 3011,
          KOG_PLAYER: 3012,
          KOG_PLAYER_HERO_STATISTICS: 3013,
          KOG_PLAYER_STATISTICS: 3014,
          KOG_SKILL: 3015,
          KOG_TEAM: 3016,
          KOG_TEAM_STATISTICS: 3017,
          KOG_MATCH_LIVE_VIDEO: 3019,
          KOG_MATCH_LIVE: 3020,
          KOG_MATCH_ANALYSIS: 3021,
          LOL_BATTLE: 4000,
          LOL_BATTLE_PLAYER_STATISTICS: 4001,
          LOL_BATTLE_TEAM_STATISTICS: 4002,
          LOL_BET: 4003,
          LOL_ROLLING_BET: 4025,
          LOL_HERO: 4005,
          LOL_HERO_STATISTICS: 4006,
          LOL_LEAGUE: 4008,
          LOL_LEAGUE_BOARD: 4009,
          LOL_LEAGUE_PLAYER_STATISTICS: 4010,
          LOL_LEAGUE_TEAM_STATISTICS: 4011,
          LOL_LIVE_BATTLE: 4012,
          LOL_LIVE_BATTLE_PLAYER_STATISTICS: 4013,
          LOL_LIVE_BATTLE_TEAM_STATISTICS: 4014,
          LOL_MATCH: 4015,
          LOL_PLAYER: 4016,
          LOL_PLAYER_HERO_STATISTICS: 4017,
          LOL_PLAYER_STATISTICS: 4018,
          LOL_RUNE: 4019,
          LOL_SKILL: 4020,
          LOL_TEAM: 4021,
          LOL_TEAM_STATISTICS: 4022,
          LOL_MATCH_PROSPECT: 4023,
          LOL_GAME_ITEM: 4024,
          LOL_MATCH_LIVE_VIDEO: 4026,
          LOL_MATCH_ANALYSIS: 4027,
          LOL_LEAGUE_TEAM_STATS: 4028,
          LOL_LEAGUE_PLAYER_STATS: 4029,
          LOL_LEAGUE_HERO_STATS: 4030,
          LOL_TEAM_RANK: 4031,
          LOL_GAME_LOG: 4032,
          LOL_MATCH_LIVE: 4033,
          LOL_TEAM_LEAGUE_AWARD: 4034,
          OW_BET: 5000,
          OW_ROLLING_BET: 5004,
          OW_LEAGUE: 5001,
          OW_MATCH: 5002,
          OW_TEAM: 5003,
          ESPORTS_LEAGUE: 6000,
          ESPORTS_MATCH: 6001,
          ESPORTS_PLAYER: 6002,
          ESPORTS_TEAM: 6003,
          ESPORTS_PLAYER_RANK: 6004,
          ESPORTS_TEAM_RANK: 6005,
          ESPORTS_MATCH_TEAM_STATISTICS: 6007,
          ESPORTS_MATCH_PLAYER_STATISTICS: 6008,
          PUBG_BET: 6010,
          PUBG_ROLLING_BET: 6011,
          OW2_BET: 6020,
          OW2_ROLLING_BET: 6021,
          RAINBOW_BET: 6030,
          RAINBOW_ROLLING_BET: 6031,
          ROCKET_BET: 6040,
          ROCKET_ROLLING_BET: 6041,
          SC2_BET: 6050,
          SC2_ROLLING_BET: 6051,
          SC2_BATTLE: 6052,
          HOS_BET: 6060,
          HOS_ROLLING_BET: 6061,
          HOS_BATTLE: 6062,
          HS_BET: 6070,
          HS_ROLLING_BET: 6071,
          HS_BATTLE: 6072
        }
      },
      PBManualRecord: {
        fields: {
          recordId: {
            type: "int64",
            id: 1
          },
          gameType: {
            type: "PBGameType",
            id: 2
          },
          collectionName: {
            type: "string",
            id: 3
          },
          objectId: {
            type: "string",
            id: 4
          },
          primaryKeyValue: {
            type: "string",
            id: 5
          },
          keyName: {
            type: "string",
            id: 6
          },
          keyValue: {
            type: "string",
            id: 7
          },
          originalValue: {
            type: "string",
            id: 14
          },
          lastDate: {
            type: "int64",
            id: 8
          },
          createDate: {
            type: "int64",
            id: 9
          },
          actionType: {
            type: "PBActionType",
            id: 10
          },
          admin: {
            type: "framework.PBAdmin",
            id: 11
          },
          extendInfo: {
            type: "string",
            id: 12
          },
          originalId: {
            type: "string",
            id: 13
          },
          isImage: {
            type: "bool",
            id: 15
          },
          remarkInfo: {
            type: "string",
            id: 16
          },
          type: {
            type: "PBManualRecordType",
            id: 17
          }
        }
      },
      PBManualRecordList: {
        fields: {
          records: {
            rule: "repeated",
            type: "PBManualRecord",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBManualRecordReq: {
        fields: {
          tableType: {
            type: "PBTableType",
            id: 1
          },
          record: {
            type: "PBManualRecord",
            id: 2
          }
        }
      },
      PBManualRecordType: {
        values: {
          MRT_DEFAULT: 0,
          MRT_SYSTEM: 1,
          MRT_ADMIN: 2
        }
      },
      PBManualRecordSearchReq: {
        fields: {
          gameType: {
            type: "PBGameType",
            id: 1
          },
          startTime: {
            type: "int64",
            id: 2
          },
          endTime: {
            type: "int64",
            id: 3
          },
          actionType: {
            type: "int32",
            id: 4
          },
          adminId: {
            type: "int32",
            id: 5
          },
          recordType: {
            type: "PBManualRecordType",
            id: 6
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBGameTypeRsp: {
        fields: {
          typeId: {
            type: "int32",
            id: 1
          },
          typeName: {
            type: "string",
            id: 2
          }
        }
      },
      PBGameTypeList: {
        fields: {
          types: {
            rule: "repeated",
            type: "PBGameTypeRsp",
            id: 1
          }
        }
      },
      PBAdminBattle: {
        fields: {
          records: {
            rule: "repeated",
            type: "PBManualRecord",
            id: 1
          },
          battle: {
            type: "string",
            id: 2
          },
          teamIds: {
            rule: "repeated",
            type: "string",
            id: 3
          },
          playerIds: {
            rule: "repeated",
            type: "string",
            id: 4
          }
        }
      },
      PBAdminBattlePlayerStatistics: {
        fields: {
          records: {
            rule: "repeated",
            type: "PBManualRecord",
            id: 1
          },
          playerStats: {
            type: "string",
            id: 2
          }
        }
      },
      PBAdminBattleTeamStatistics: {
        fields: {
          records: {
            rule: "repeated",
            type: "PBManualRecord",
            id: 1
          },
          teamStats: {
            type: "string",
            id: 2
          }
        }
      },
      PBAdminBattleList: {
        fields: {
          battles: {
            rule: "repeated",
            type: "PBAdminBattle",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBAdminBattleInfoReq: {
        fields: {
          gameType: {
            type: "PBGameType",
            id: 1
          },
          battleId: {
            type: "string",
            id: 2
          },
          isLive: {
            type: "bool",
            id: 3
          }
        }
      },
      PBAdminBattleStatsReq: {
        fields: {
          gameType: {
            type: "PBGameType",
            id: 1
          },
          battleId: {
            type: "string",
            id: 2
          },
          searchId: {
            type: "string",
            id: 3
          },
          isLive: {
            type: "bool",
            id: 4
          }
        }
      },
      PBAdminBet: {
        fields: {
          records: {
            rule: "repeated",
            type: "PBManualRecord",
            id: 1
          },
          bet: {
            type: "string",
            id: 2
          }
        }
      },
      PBAdminBetList: {
        fields: {
          bets: {
            rule: "repeated",
            type: "PBAdminBet",
            id: 1
          },
          match: {
            type: "PBAdminMatch",
            id: 2
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBAdminBetSearchReq: {
        fields: {
          gameType: {
            type: "PBGameType",
            id: 1
          },
          source: {
            type: "int32",
            id: 2
          },
          matchId: {
            type: "string",
            id: 3
          },
          betId: {
            type: "string",
            id: 4
          },
          status: {
            type: "int32",
            id: 5
          },
          betType: {
            type: "int32",
            id: 6
          },
          isSource: {
            type: "bool",
            id: 7
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBAdminBetInfoReq: {
        fields: {
          gameType: {
            type: "PBGameType",
            id: 1
          },
          betId: {
            type: "string",
            id: 2
          }
        }
      },
      PBAdminMatch: {
        fields: {
          betDataTotal: {
            type: "int32",
            id: 1
          },
          records: {
            rule: "repeated",
            type: "PBManualRecord",
            id: 2
          },
          match: {
            type: "string",
            id: 3
          },
          isLive: {
            type: "bool",
            id: 4
          },
          battleIds: {
            rule: "repeated",
            type: "string",
            id: 5
          },
          teamAName: {
            type: "string",
            id: 6
          },
          teamBName: {
            type: "string",
            id: 7
          },
          leagueName: {
            type: "string",
            id: 8
          },
          alerts: {
            rule: "repeated",
            type: "PBDataAlert",
            id: 9
          }
        }
      },
      PBAdminMatchList: {
        fields: {
          matches: {
            rule: "repeated",
            type: "PBAdminMatch",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBAdminMatchSearchReq: {
        fields: {
          gameType: {
            type: "PBGameType",
            id: 1
          },
          startTime: {
            type: "int64",
            id: 2
          },
          endTime: {
            type: "int64",
            id: 3
          },
          leagueId: {
            type: "string",
            id: 9
          },
          leagueName: {
            type: "string",
            id: 4
          },
          matchId: {
            type: "string",
            id: 5
          },
          teamId: {
            type: "string",
            id: 6
          },
          teamName: {
            type: "string",
            id: 7
          },
          status: {
            rule: "repeated",
            type: "int32",
            id: 8
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          },
          isSource: {
            type: "bool",
            id: 11
          },
          isLive: {
            type: "framework.PBBoolValue",
            id: 12
          },
          playerId: {
            type: "string",
            id: 13
          },
          playerName: {
            type: "string",
            id: 14
          },
          isAlert: {
            type: "framework.PBBoolValue",
            id: 15
          }
        }
      },
      PBAdminMatchInfoReq: {
        fields: {
          gameType: {
            type: "PBGameType",
            id: 1
          },
          matchId: {
            type: "string",
            id: 2
          }
        }
      },
      PBDataAlertCount: {
        fields: {
          gameType: {
            type: "PBGameType",
            id: 1
          },
          dataType: {
            type: "PBDataType",
            id: 2
          },
          count: {
            type: "uint64",
            id: 3
          }
        }
      },
      PBDataAlertCountList: {
        fields: {
          list: {
            rule: "repeated",
            type: "PBDataAlertCount",
            id: 1
          }
        }
      },
      PBDataAlertStatus: {
        values: {
          DAS_DEFAULT: 0,
          DAS_TBD: 1,
          DAS_FIXED: 2,
          DAS_IGNORE: 3,
          DAS_LATER_PROCESS: 4
        }
      },
      PBDataAlertType: {
        values: {
          DAT_DEFAULT: 0,
          DAT_STATUS_EXCEPTION: 1
        }
      },
      PBDataAlert: {
        fields: {
          alertId: {
            type: "uint64",
            id: 1
          },
          gameType: {
            type: "PBGameType",
            id: 2
          },
          dataType: {
            type: "PBDataType",
            id: 3
          },
          systemId: {
            type: "string",
            id: 4
          },
          type: {
            type: "PBDataAlertType",
            id: 5
          },
          status: {
            type: "PBDataAlertStatus",
            id: 6
          },
          modifyAdmin: {
            type: "framework.PBAdmin",
            id: 11
          },
          createDate: {
            type: "uint64",
            id: 12
          },
          modifyDate: {
            type: "uint64",
            id: 13
          }
        }
      },
      PBProcessDataAlertReq: {
        fields: {
          alertId: {
            type: "uint64",
            id: 1
          },
          status: {
            type: "PBDataAlertStatus",
            id: 2
          },
          tableType: {
            type: "PBTableType",
            id: 3
          },
          record: {
            type: "PBManualRecord",
            id: 4
          }
        }
      },
      PBDataType: {
        values: {
          DT_DEFAULT: 0,
          DT_LEAGUE: 1,
          DT_MATCH: 2,
          DT_BATTLE: 3,
          DT_LIVE_BATTLE: 4,
          DT_TEAM: 5,
          DT_PLAYER: 6,
          DT_HERO: 7,
          DT_ITEM: 8,
          DT_SKILL: 9,
          DT_RUNE: 10,
          DT_BET: 11,
          DT_ROLLING_BET: 12,
          DT_MATCH_LIVE: 13
        }
      },
      PBMappingType: {
        values: {
          MT_DEFAULT: 0,
          MT_FAILURE_RECORD_ADD: 1,
          MS_ADMIN_ADD: 2
        }
      },
      PBMappingStatus: {
        values: {
          MS_DEFAULT: 0,
          MS_ENABLE: 1,
          MS_DISABLE: 2
        }
      },
      PBFailureRecordStatus: {
        values: {
          FRS_DEFAULT: 0,
          FRS_TBD: 1,
          FRS_FIXED: 2,
          FRS_SYSTEM_FIXED: 3,
          FRS_IGNORE: 4,
          FRS_LATER_PROCESS: 5
        }
      },
      PBFailureProcessType: {
        values: {
          FPT_MATCH: 0,
          FPT_NEW: 1,
          FPT_ALL: 99
        }
      },
      PBNameKeyMapping: {
        fields: {
          id: {
            type: "uint64",
            id: 1
          },
          gameType: {
            type: "PBGameType",
            id: 2
          },
          dataType: {
            type: "PBDataType",
            id: 3
          },
          nameKey: {
            type: "string",
            id: 4
          },
          systemId: {
            type: "string",
            id: 5
          },
          status: {
            type: "PBMappingStatus",
            id: 6
          },
          type: {
            type: "PBMappingType",
            id: 7
          },
          extra: {
            type: "string",
            id: 8
          },
          remark: {
            type: "string",
            id: 9
          },
          createAdmin: {
            type: "framework.PBAdmin",
            id: 10
          },
          modifyAdmin: {
            type: "framework.PBAdmin",
            id: 11
          },
          createDate: {
            type: "uint64",
            id: 12
          },
          modifyDate: {
            type: "uint64",
            id: 13
          }
        }
      },
      PBNameKeyMappingList: {
        fields: {
          mappings: {
            rule: "repeated",
            type: "PBNameKeyMapping",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBMatchingFailureRecord: {
        fields: {
          recordId: {
            type: "uint64",
            id: 1
          },
          gameType: {
            type: "PBGameType",
            id: 2
          },
          dataType: {
            type: "PBDataType",
            id: 3
          },
          nameKey: {
            type: "string",
            id: 4
          },
          systemId: {
            type: "string",
            id: 5
          },
          sourceType: {
            type: "PBDataSource",
            id: 6
          },
          sourceRecordId: {
            type: "string",
            id: 7
          },
          remark: {
            type: "string",
            id: 8
          },
          data: {
            type: "string",
            id: 9
          },
          status: {
            type: "PBFailureRecordStatus",
            id: 10
          },
          idMappingId: {
            type: "uint64",
            id: 11
          },
          nameKeyMappingId: {
            type: "uint64",
            id: 12
          },
          processType: {
            type: "PBFailureProcessType",
            id: 13
          },
          admin: {
            type: "framework.PBAdmin",
            id: 20
          },
          createDate: {
            type: "uint64",
            id: 21
          },
          modifyDate: {
            type: "uint64",
            id: 22
          },
          extendData: {
            type: "string",
            id: 23
          },
          extendNameMapping: {
            type: "string",
            id: 24
          },
          statusReason: {
            type: "string",
            id: 25
          }
        }
      },
      PBSystemIdMapping: {
        fields: {
          id: {
            type: "uint64",
            id: 1
          },
          collectionName: {
            type: "string",
            id: 2
          },
          systemId: {
            type: "string",
            id: 3
          },
          gameType: {
            type: "PBGameType",
            id: 4
          },
          sourceType: {
            type: "PBDataSource",
            id: 5
          },
          sourceRecordId: {
            type: "string",
            id: 6
          },
          dataType: {
            type: "PBDataType",
            id: 7
          },
          status: {
            type: "PBMappingStatus",
            id: 8
          },
          remark: {
            type: "string",
            id: 9
          },
          mappingType: {
            type: "PBMappingType",
            id: 10
          },
          createAdmin: {
            type: "framework.PBAdmin",
            id: 11
          },
          modifyAdmin: {
            type: "framework.PBAdmin",
            id: 12
          },
          createDate: {
            type: "uint64",
            id: 13
          },
          modifyDate: {
            type: "uint64",
            id: 14
          }
        }
      },
      PBMatchingFailureRecordList: {
        fields: {
          records: {
            rule: "repeated",
            type: "PBMatchingFailureRecord",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBSystemIdMappingList: {
        fields: {
          mappings: {
            rule: "repeated",
            type: "PBSystemIdMapping",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBQueryFailureRecordDateType: {
        values: {
          QFRDT_DEFAULT: 0,
          QFRDT_CREATE_DATE: 1,
          QFRDT_MODIFY_DATE: 2
        }
      },
      PBQueryFailureRecordReq: {
        fields: {
          status: {
            type: "PBFailureRecordStatus",
            id: 1
          },
          gameType: {
            type: "PBGameType",
            id: 2
          },
          dataType: {
            type: "PBDataType",
            id: 3
          },
          sourceType: {
            type: "PBDataSource",
            id: 4
          },
          dateType: {
            type: "PBQueryFailureRecordDateType",
            id: 5
          },
          startDate: {
            type: "uint64",
            id: 6
          },
          endDate: {
            type: "uint64",
            id: 7
          },
          recordId: {
            type: "uint64",
            id: 8
          },
          nameKey: {
            type: "string",
            id: 9
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          },
          processType: {
            type: "PBFailureProcessType",
            id: 11
          },
          statusReason: {
            type: "string",
            id: 12
          },
          beginRelatedTime: {
            type: "uint64",
            id: 13
          },
          endRelatedTime: {
            type: "uint64",
            id: 14
          },
          relatedName: {
            type: "string",
            id: 15
          }
        }
      },
      PBQueryNameKeyMappingReq: {
        fields: {
          status: {
            type: "PBMappingStatus",
            id: 1
          },
          gameType: {
            type: "PBGameType",
            id: 2
          },
          dataType: {
            type: "PBDataType",
            id: 3
          },
          nameKey: {
            type: "string",
            id: 4
          },
          systemId: {
            type: "string",
            id: 5
          },
          recordId: {
            type: "uint64",
            id: 6
          },
          type: {
            type: "PBMappingType",
            id: 7
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBQuerySystemIdMappingReq: {
        fields: {
          gameType: {
            type: "PBGameType",
            id: 1
          },
          dataType: {
            type: "PBDataType",
            id: 2
          },
          status: {
            type: "PBMappingStatus",
            id: 3
          },
          mappingType: {
            type: "PBMappingType",
            id: 4
          },
          sourceType: {
            type: "PBDataSource",
            id: 5
          },
          sourceId: {
            type: "string",
            id: 6
          },
          systemId: {
            type: "string",
            id: 7
          },
          recordId: {
            type: "uint64",
            id: 8
          },
          page: {
            type: "framework.PBPagePara",
            id: 9
          }
        }
      },
      PBProcessFailureRecordReq: {
        fields: {
          recordId: {
            type: "uint64",
            id: 1
          },
          systemId: {
            type: "string",
            id: 2
          },
          status: {
            type: "PBFailureRecordStatus",
            id: 3
          },
          statusReason: {
            type: "string",
            id: 8
          },
          remark: {
            type: "string",
            id: 4
          },
          addIdMapping: {
            type: "bool",
            id: 5
          },
          addNameKeyMapping: {
            type: "bool",
            id: 6
          },
          processType: {
            type: "PBFailureProcessType",
            id: 7
          }
        }
      },
      PBMappingFailureRecordReq: {
        fields: {
          recordId: {
            type: "uint64",
            id: 1
          },
          teamId: {
            type: "string",
            id: 2
          },
          teamName: {
            type: "string",
            id: 3
          },
          nameKeyMappingId: {
            type: "uint64",
            id: 4
          },
          isHome: {
            type: "bool",
            id: 5
          }
        }
      },
      PBFwGameMessageType: {
        values: {
          DEFAULT_TYPE: 0,
          MANUAL_RECORD_LIST: 1000,
          MANUAL_RECORD_ADD: 1001,
          MANUAL_RECORD_DELETE: 1002,
          MANUAL_RECORD_ADMIN_LIST: 1003,
          GAME_DATA_TRASH: 2000,
          GAME_DATA_NORMAL: 2001,
          GAME_DATA_RESTART_SPIDER: 2002,
          GAME_TYPE_LIST: 2003,
          GAME_MATCH_SEARCH_LIST: 2100,
          GAME_MATCH_INFO: 2101,
          GAME_BET_SEARCH_LIST: 2200,
          GAME_BET_INFO: 2201,
          GAME_BATTLE_INFO: 2300,
          GAME_BATTLE_TEAM_INFO: 2301,
          GAME_BATTLE_PLAYER_INFO: 2302,
          GAME_LEAGUE_SEARCH_LIST: 2400,
          GAME_LEAGUE_INFO: 2401,
          GAME_TEAM_SEARCH_LIST: 2500,
          GAME_TEAM_INFO: 2501,
          GAME_PLAYER_SEARCH_LIST: 2510,
          GAME_PLAYER_INFO: 2511,
          GAME_HERO_SEARCH_LIST: 2520,
          GAME_HERO_INFO: 2521,
          GAME_ITEM_SEARCH_LIST: 2530,
          GAME_ITEM_INFO: 2531,
          GAME_SKILL_SEARCH_LIST: 2540,
          GAME_SKILL_INFO: 2541,
          GAME_RUNE_SEARCH_LIST: 2550,
          GAME_RUNE_INFO: 2551,
          MAPPING_FAILURE_RECORD_LIST: 3000,
          MAPPING_FAILURE_RECORD_GET: 3001,
          MAPPING_FAILURE_RECORD_PROCESS: 3002,
          MAPPING_FAILURE_RECORD_COUNT: 3003,
          MAPPING_FAILURE_RECORD_AUTO_PROCESS: 3004,
          MAPPING_FAILURE_RECORD_REPEAL: 3005,
          MAPPING_FAILURE_RECORD_UPDATE_MAPPING: 3006,
          MAPPING_NAME_KEY_LIST: 3020,
          MAPPING_NAME_KEY_UPDATE: 3021,
          MAPPING_NAME_KEY_ADD: 3022,
          MAPPING_NAME_KEY_GET: 3023,
          MAPPING_SYSTEM_ID_LIST: 3030,
          MAPPING_SYSTEM_ID_ADD: 3032,
          MAPPING_SYSTEM_ID_UPDATE: 3031,
          MAPPING_SYSTEM_ID_UPDATE_REMARK: 3033,
          MAPPING_SYSTEM_ID_UPDATE_ENABLE: 3034,
          SPIDER_SOURCE_LIST: 4000,
          SPIDER_SOURCE_ADD: 4001,
          SPIDER_SOURCE_UPDATE: 4002,
          GAME_DATA_SOURCE_LIST: 4010,
          LEAGUE_DATA_SOURCE_LIST: 4020,
          LEAGUE_DATA_SOURCE_UPDATE: 4021,
          LIVE_SOURCE_ADD: 5100,
          LIVE_SOURCE_UPDATE: 5101,
          LIVE_SOURCE_UPDATE_ENABLE: 5102,
          LIVE_SOURCE_LIST: 5104,
          LIVE_MATCH_ADD: 5200,
          LIVE_MATCH_UPDATE_SORT: 5201,
          LIVE_MATCH_UPDATE_DESC: 5202,
          LIVE_MATCH_UPDATE_ENABLE: 5203,
          LIVE_MATCH_UPDATE_NAME: 5209,
          LIVE_MATCH_LIST: 5204,
          LIVE_MATCH_SORT_LIST: 5208,
          LIVE_MATCH_INFO: 5205,
          LIVE_MATCH_STATS_LIST: 5206,
          LIVE_MATCH_STATS_CLICK: 5207,
          LIVE_MATCH_UPDATE_NAME_EN: 5210,
          DATA_ALERT_COUNT_GET: 6000,
          DATA_ALERT_PROCESS: 6001
        }
      },
      PBAdminHero: {
        fields: {
          records: {
            rule: "repeated",
            type: "PBManualRecord",
            id: 1
          },
          hero: {
            type: "string",
            id: 2
          }
        }
      },
      PBAdminHeroList: {
        fields: {
          heroes: {
            rule: "repeated",
            type: "PBAdminHero",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBAdminHeroSearchReq: {
        fields: {
          gameType: {
            type: "PBGameType",
            id: 1
          },
          heroId: {
            type: "string",
            id: 2
          },
          heroName: {
            type: "string",
            id: 3
          },
          isSource: {
            type: "bool",
            id: 6
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBAdminHeroInfoReq: {
        fields: {
          gameType: {
            type: "PBGameType",
            id: 1
          },
          heroId: {
            type: "int64",
            id: 2
          }
        }
      },
      PBAdminItem: {
        fields: {
          records: {
            rule: "repeated",
            type: "PBManualRecord",
            id: 1
          },
          item: {
            type: "string",
            id: 2
          }
        }
      },
      PBAdminItemList: {
        fields: {
          items: {
            rule: "repeated",
            type: "PBAdminItem",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBAdminItemSearchReq: {
        fields: {
          gameType: {
            type: "PBGameType",
            id: 1
          },
          itemId: {
            type: "string",
            id: 2
          },
          itemName: {
            type: "string",
            id: 3
          },
          isSource: {
            type: "bool",
            id: 6
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBAdminItemInfoReq: {
        fields: {
          gameType: {
            type: "PBGameType",
            id: 1
          },
          itemId: {
            type: "int64",
            id: 2
          }
        }
      },
      PBAdminLeague: {
        fields: {
          records: {
            rule: "repeated",
            type: "PBManualRecord",
            id: 2
          },
          league: {
            type: "string",
            id: 3
          }
        }
      },
      PBAdminLeagueList: {
        fields: {
          leagues: {
            rule: "repeated",
            type: "PBAdminLeague",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBAdminLeagueSearchReq: {
        fields: {
          gameType: {
            type: "PBGameType",
            id: 1
          },
          startTime: {
            type: "int64",
            id: 2
          },
          endTime: {
            type: "int64",
            id: 3
          },
          leagueId: {
            type: "string",
            id: 9
          },
          leagueName: {
            type: "string",
            id: 4
          },
          status: {
            type: "int32",
            id: 8
          },
          isSource: {
            type: "bool",
            id: 11
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBAdminLeagueInfoReq: {
        fields: {
          gameType: {
            type: "PBGameType",
            id: 1
          },
          leagueId: {
            type: "string",
            id: 2
          }
        }
      },
      PBVideoType: {
        values: {
          VT_DEFAULT: 0,
          VT_OUTER_CHAIN: 1,
          VT_VIDEO_SOURCE: 2,
          VT_PULL_SOURCE: 3
        }
      },
      PBLivePullStatus: {
        values: {
          LPS_DEFAULT: 0,
          LPS_PULLING: 1,
          LPS_FAILURE: 2,
          LPS_END: 3
        }
      },
      PBLiveSource: {
        fields: {
          sourceId: {
            type: "uint64",
            id: 1
          },
          sourceName: {
            type: "string",
            id: 2
          },
          url: {
            type: "string",
            id: 3
          },
          partner: {
            type: "framework.PBPartner",
            id: 4
          },
          videoType: {
            type: "PBVideoType",
            id: 5
          },
          isEnable: {
            type: "bool",
            id: 6
          },
          createDate: {
            type: "uint64",
            id: 7
          },
          modifyDate: {
            type: "uint64",
            id: 8
          },
          matchDate: {
            rule: "repeated",
            type: "uint64",
            id: 11
          },
          remarks: {
            type: "string",
            id: 12
          },
          createAdmin: {
            type: "framework.PBAdmin",
            id: 13
          },
          modifyAdmin: {
            type: "framework.PBAdmin",
            id: 14
          },
          gameType: {
            rule: "repeated",
            type: "PBGameType",
            id: 15
          },
          channelId: {
            type: "string",
            id: 30
          },
          hlsUrl: {
            type: "string",
            id: 31
          },
          pullInfo: {
            type: "PBLiveSourcePullInfo",
            id: 32
          }
        }
      },
      PBLiveSourcePullInfo: {
        fields: {
          infoId: {
            type: "uint64",
            id: 1
          },
          partnerLiveId: {
            type: "string",
            id: 2
          },
          url: {
            type: "string",
            id: 3
          },
          matchDate: {
            type: "uint64",
            id: 4
          },
          matchTitle: {
            type: "string",
            id: 5
          },
          gameType: {
            type: "PBGameType",
            id: 6
          },
          processId: {
            type: "uint64",
            id: 7
          },
          extraInfo: {
            type: "string",
            id: 8
          },
          createDate: {
            type: "uint64",
            id: 9
          },
          modifyDate: {
            type: "uint64",
            id: 10
          },
          firstPullDate: {
            type: "uint64",
            id: 11
          },
          pullStartDate: {
            type: "uint64",
            id: 12
          },
          pullEndDate: {
            type: "uint64",
            id: 13
          },
          status: {
            type: "PBLivePullStatus",
            id: 14
          }
        }
      },
      PBLiveSourceType: {
        values: {
          LST_DEFAULT: 0,
          LST_ADMIN: 1,
          LST_SPIDER: 2,
          LST_PARTNER: 3
        }
      },
      PBLiveMatch: {
        fields: {
          liveId: {
            type: "uint64",
            id: 1
          },
          liveName: {
            type: "string",
            id: 17
          },
          liveType: {
            type: "PBLiveSourceType",
            id: 2
          },
          sortNumber: {
            type: "uint32",
            id: 3
          },
          isEnable: {
            type: "bool",
            id: 4
          },
          enableDate: {
            type: "uint64",
            id: 5
          },
          source: {
            type: "PBLiveSource",
            id: 6
          },
          matchId: {
            type: "string",
            id: 16
          },
          match: {
            type: "PBAdminMatch",
            id: 7
          },
          gameType: {
            type: "PBGameType",
            id: 8
          },
          createDate: {
            type: "uint64",
            id: 9
          },
          modifyDate: {
            type: "uint64",
            id: 10
          },
          createAdmin: {
            type: "framework.PBAdmin",
            id: 11
          },
          modifyAdmin: {
            type: "framework.PBAdmin",
            id: 12
          },
          remarks: {
            type: "string",
            id: 13
          },
          pvNum: {
            type: "uint64",
            id: 14
          },
          uvNum: {
            type: "uint64",
            id: 18
          },
          customerNum: {
            type: "uint64",
            id: 15
          },
          liveNameEn: {
            type: "string",
            id: 19
          }
        }
      },
      PBLiveMatchStats: {
        fields: {
          statsId: {
            type: "uint64",
            id: 1
          },
          live: {
            type: "PBLiveMatch",
            id: 2
          },
          customer: {
            type: "PBMixLiveCustomer",
            id: 3
          },
          link: {
            type: "string",
            id: 4
          },
          pvNum: {
            type: "uint64",
            id: 5
          },
          uvNum: {
            type: "uint64",
            id: 6
          },
          createDate: {
            type: "uint64",
            id: 9
          }
        }
      },
      PBMixLiveCustomer: {
        fields: {
          customerId: {
            type: "uint32",
            id: 1
          },
          customerName: {
            type: "string",
            id: 2
          },
          cooperationStatus: {
            type: "uint32",
            id: 3
          },
          userId: {
            type: "uint32",
            id: 4
          }
        }
      },
      PBLiveSourceList: {
        fields: {
          sources: {
            rule: "repeated",
            type: "PBLiveSource",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBLiveMatchStatsList: {
        fields: {
          stats: {
            rule: "repeated",
            type: "PBLiveMatchStats",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBLiveMatchList: {
        fields: {
          lives: {
            rule: "repeated",
            type: "PBLiveMatch",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBLiveMatchSortReq: {
        fields: {
          matchId: {
            type: "string",
            id: 1
          },
          gameType: {
            type: "PBGameType",
            id: 2
          },
          status: {
            type: "framework.PBBoolValue",
            id: 3
          }
        }
      },
      PBLiveMatchAddReq: {
        fields: {
          sourceIds: {
            rule: "repeated",
            type: "uint64",
            id: 1
          },
          liveMatch: {
            type: "PBLiveMatch",
            id: 2
          }
        }
      },
      PBLiveSourceSearchReq: {
        fields: {
          sourceId: {
            type: "uint64",
            id: 1
          },
          sourceName: {
            type: "string",
            id: 2
          },
          partner: {
            type: "string",
            id: 3
          },
          status: {
            type: "framework.PBBoolValue",
            id: 4
          },
          videoType: {
            type: "int32",
            id: 5
          },
          gameType: {
            type: "PBGameType",
            id: 6
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBLiveMatchSearchTimeType: {
        values: {
          MLT_DEFAULT: 0,
          MLT_ENABLE_DATE: 1,
          MLT_MATCH_DATE: 2
        }
      },
      PBLiveMatchSearchKeyType: {
        values: {
          MLK_DEFAULT: 0,
          MLK_LIVE_ID: 1,
          MLT_MATCH_ID: 2,
          MLT_SOURCE_ID: 3,
          MLK_TEAM_NAME: 4
        }
      },
      PBLiveMatchSearchReq: {
        fields: {
          timeType: {
            type: "PBLiveMatchSearchTimeType",
            id: 1
          },
          beginDate: {
            type: "uint64",
            id: 2
          },
          endDate: {
            type: "uint64",
            id: 3
          },
          keyType: {
            type: "PBLiveMatchSearchKeyType",
            id: 4
          },
          searchKey: {
            type: "string",
            id: 5
          },
          gameType: {
            type: "PBGameType",
            id: 6
          },
          liveType: {
            type: "PBLiveSourceType",
            id: 7
          },
          status: {
            type: "framework.PBBoolValue",
            id: 8
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBLiveMatchStatsSearchTimeType: {
        values: {
          MST_DEFAULT: 0,
          MST_STATS_DATE: 1,
          MST_CREATE_DATE: 2
        }
      },
      PBLiveMatchStatsSearchKeyType: {
        values: {
          MSK_DEFAULT: 0,
          MSK_CUSTOMER_ID: 1,
          MST_CUSTOMER_NAME: 5
        }
      },
      PBLiveMatchStatsSearchReq: {
        fields: {
          liveId: {
            type: "uint64",
            id: 7
          },
          timeType: {
            type: "PBLiveMatchStatsSearchTimeType",
            id: 1
          },
          beginDate: {
            type: "uint64",
            id: 2
          },
          endDate: {
            type: "uint64",
            id: 3
          },
          keyType: {
            type: "PBLiveMatchStatsSearchKeyType",
            id: 4
          },
          searchKey: {
            type: "string",
            id: 5
          },
          cooperationStatus: {
            type: "uint32",
            id: 6
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBAdminPlayer: {
        fields: {
          records: {
            rule: "repeated",
            type: "PBManualRecord",
            id: 1
          },
          player: {
            type: "string",
            id: 2
          },
          teamName: {
            type: "string",
            id: 3
          }
        }
      },
      PBAdminPlayerList: {
        fields: {
          players: {
            rule: "repeated",
            type: "PBAdminPlayer",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBAdminPlayerSearchReq: {
        fields: {
          gameType: {
            type: "PBGameType",
            id: 1
          },
          playerId: {
            type: "string",
            id: 2
          },
          playerName: {
            type: "string",
            id: 3
          },
          teamId: {
            type: "string",
            id: 4
          },
          teamName: {
            type: "string",
            id: 5
          },
          isSource: {
            type: "bool",
            id: 6
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBAdminPlayerInfoReq: {
        fields: {
          gameType: {
            type: "PBGameType",
            id: 1
          },
          playerId: {
            type: "string",
            id: 2
          }
        }
      },
      PBAdminRune: {
        fields: {
          records: {
            rule: "repeated",
            type: "PBManualRecord",
            id: 1
          },
          rune: {
            type: "string",
            id: 2
          }
        }
      },
      PBAdminRuneList: {
        fields: {
          runes: {
            rule: "repeated",
            type: "PBAdminRune",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBAdminRuneSearchReq: {
        fields: {
          gameType: {
            type: "PBGameType",
            id: 1
          },
          runeId: {
            type: "string",
            id: 2
          },
          runeName: {
            type: "string",
            id: 3
          },
          isSource: {
            type: "bool",
            id: 6
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBAdminRuneInfoReq: {
        fields: {
          gameType: {
            type: "PBGameType",
            id: 1
          },
          runeId: {
            type: "string",
            id: 2
          }
        }
      },
      PBAdminSkill: {
        fields: {
          records: {
            rule: "repeated",
            type: "PBManualRecord",
            id: 1
          },
          skill: {
            type: "string",
            id: 2
          }
        }
      },
      PBAdminSkillList: {
        fields: {
          skills: {
            rule: "repeated",
            type: "PBAdminSkill",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBAdminSkillSearchReq: {
        fields: {
          gameType: {
            type: "PBGameType",
            id: 1
          },
          skillId: {
            type: "string",
            id: 2
          },
          skillName: {
            type: "string",
            id: 3
          },
          isSource: {
            type: "bool",
            id: 6
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBAdminSkillInfoReq: {
        fields: {
          gameType: {
            type: "PBGameType",
            id: 1
          },
          skillId: {
            type: "string",
            id: 2
          }
        }
      },
      PBLeagueSourceUseType: {
        values: {
          LSUT_NOT_USE: 0,
          LSUT_USE_DEFAULT: 1,
          LSUT_USE_SCORE: 2,
          LSUT_USE_SCORE_DETAIL: 3,
          LSUT_USE_STATISTIC: 4,
          LSUT_USE_PROSPECT: 5,
          LSUT_USE_LEAGUE_TEAM_STATS: 6,
          LSUT_USE_LEAGUE_PLAYER_STATS: 7,
          LSUT_USE_LEAGUE_HERO_STATS: 8,
          LSUT_USE_LEAGUE_BOARD: 9
        }
      },
      PBSpiderSourceStatus: {
        values: {
          ESS_DEFAULT: 0,
          ESS_ENABLE: 1,
          ESS_DISABLE: 2
        }
      },
      PBSpiderSource: {
        fields: {
          sourceId: {
            type: "uint32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          url: {
            type: "string",
            id: 3
          },
          desc: {
            type: "string",
            id: 4
          },
          status: {
            type: "PBSpiderSourceStatus",
            id: 5
          }
        }
      },
      PBGameDataSource: {
        fields: {
          recordId: {
            type: "uint32",
            id: 1
          },
          gameType: {
            type: "PBGameType",
            id: 2
          },
          mainSource: {
            type: "PBSpiderSource",
            id: 3
          },
          backupSources: {
            rule: "repeated",
            type: "PBSpiderSource",
            id: 4
          }
        }
      },
      PBLeagueDataSource: {
        fields: {
          recordId: {
            type: "uint64",
            id: 1
          },
          leagueName: {
            type: "string",
            id: 2
          },
          gameType: {
            type: "PBGameType",
            id: 3
          },
          leagueSystemId: {
            type: "string",
            id: 4
          },
          useSource: {
            rule: "repeated",
            type: "PBLeagueSpiderSource",
            id: 5
          },
          failureRecord: {
            type: "PBMatchingFailureRecord",
            id: 6
          },
          spiderName: {
            type: "string",
            id: 7
          },
          createDate: {
            type: "uint64",
            id: 8
          },
          modifyDate: {
            type: "uint64",
            id: 9
          },
          leagueDate: {
            type: "uint64",
            id: 10
          },
          admin: {
            type: "framework.PBAdmin",
            id: 20
          }
        }
      },
      PBLeagueSpiderSource: {
        fields: {
          source: {
            type: "PBSpiderSource",
            id: 1
          },
          useType: {
            rule: "repeated",
            type: "PBLeagueSourceUseType",
            id: 2
          }
        }
      },
      PBSpiderSourceReq: {
        fields: {
          sourceId: {
            type: "uint32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          status: {
            type: "PBSpiderSourceStatus",
            id: 3
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBSpiderSourceList: {
        fields: {
          sources: {
            rule: "repeated",
            type: "PBSpiderSource",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBGameDataSourceList: {
        fields: {
          sources: {
            rule: "repeated",
            type: "PBGameDataSource",
            id: 1
          }
        }
      },
      PBLeagueDataSourceReq: {
        fields: {
          leagueSystemId: {
            type: "string",
            id: 1
          },
          leagueName: {
            type: "string",
            id: 2
          },
          spiderName: {
            type: "string",
            id: 3
          },
          gameType: {
            type: "PBGameType",
            id: 4
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBLeagueDataSourceList: {
        fields: {
          sources: {
            rule: "repeated",
            type: "PBLeagueDataSource",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBAdminTeam: {
        fields: {
          records: {
            rule: "repeated",
            type: "PBManualRecord",
            id: 1
          },
          team: {
            type: "string",
            id: 2
          },
          playerNum: {
            type: "int32",
            id: 3
          }
        }
      },
      PBAdminTeamList: {
        fields: {
          team: {
            rule: "repeated",
            type: "PBAdminTeam",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBAdminTeamSearchReq: {
        fields: {
          gameType: {
            type: "PBGameType",
            id: 1
          },
          leagueId: {
            type: "string",
            id: 2
          },
          teamId: {
            type: "string",
            id: 3
          },
          teamName: {
            type: "string",
            id: 4
          },
          isSource: {
            type: "bool",
            id: 5
          },
          leagueName: {
            type: "string",
            id: 6
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBAdminTeamInfoReq: {
        fields: {
          gameType: {
            type: "PBGameType",
            id: 1
          },
          teamId: {
            type: "string",
            id: 2
          }
        }
      }
    }
  },
  fw: {
    nested: {
      PBAdvisoryActionType: {
        values: {
          AAT_PENDING: 0,
          AAT_CONNECTED: 1,
          AAT_IGNORED: 2
        }
      },
      PBAdvisory: {
        fields: {
          advisoryId: {
            type: "int32",
            id: 1
          },
          categoryIds: {
            rule: "repeated",
            type: "PBProductCategory",
            id: 2
          },
          subTypes: {
            rule: "repeated",
            type: "PBProductSubType",
            id: 3
          },
          companyName: {
            type: "string",
            id: 4
          },
          contact: {
            type: "string",
            id: 5
          },
          phone: {
            type: "string",
            id: 6
          },
          qq: {
            type: "string",
            id: 7
          },
          weChat: {
            type: "string",
            id: 8
          },
          user: {
            type: "PBUser",
            id: 9
          },
          actionType: {
            type: "PBAdvisoryActionType",
            id: 10
          },
          remark: {
            type: "string",
            id: 11
          },
          createTime: {
            type: "uint64",
            id: 12
          },
          updateTime: {
            type: "uint64",
            id: 13
          },
          admin: {
            type: "framework.PBAdmin",
            id: 14
          },
          source: {
            type: "string",
            id: 15
          },
          ip: {
            type: "string",
            id: 16
          },
          ipAddress: {
            type: "string",
            id: 17
          },
          sameIpUserCount: {
            type: "int32",
            id: 18
          },
          statusDesc: {
            type: "string",
            id: 19
          }
        }
      },
      PBAdvisoryList: {
        fields: {
          list: {
            rule: "repeated",
            type: "PBAdvisory",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 5
          }
        }
      },
      PBAdvisorySearchType: {
        values: {
          AST_NAME: 0,
          AST_CONTACT: 1,
          AST_QQ: 2,
          AST_REG_IP: 3,
          AST_USER_ID: 4,
          AST_SUB_IP: 5
        }
      },
      PBAdvisorySearchReq: {
        fields: {
          searchType: {
            type: "PBAdvisorySearchType",
            id: 1
          },
          keyValue: {
            type: "string",
            id: 2
          },
          beginTime: {
            type: "uint64",
            id: 3
          },
          endTime: {
            type: "uint64",
            id: 4
          },
          actionType: {
            type: "int32",
            id: 5
          },
          categoryIds: {
            rule: "repeated",
            type: "int32",
            id: 6
          },
          subType: {
            type: "int32",
            id: 7
          },
          regSource: {
            type: "string",
            id: 8
          },
          isUser: {
            type: "framework.PBBoolValue",
            id: 9
          },
          userType: {
            type: "PBSearchUserType",
            id: 10
          },
          page: {
            type: "framework.PBPagePara",
            id: 11
          }
        }
      },
      PBServiceType: {
        values: {
          SERVICE_SPORTS: 0,
          SERVICE_ELECTRONIC_SPORTS: 1
        }
      },
      PBProductType: {
        values: {
          PT_FOOTBALL: 0,
          PT_BASKETBALL: 1,
          PT_ODDS: 2,
          PT_TENNIS: 3,
          PT_AMERICAN_FOOTBALL: 4,
          PT_EG_SPORTS: 5
        }
      },
      PBProductSubType: {
        values: {
          PST_DEFAULT: 0,
          PST_SCORE: 1,
          PST_INDEX: 2,
          PST_BETTING: 3,
          PST_ANIMATION: 4,
          PST_DATABASE: 5,
          PST_DATA_ANALYSIS: 6
        }
      },
      PBDocFormatType: {
        values: {
          DF_DEFAULT: 0,
          DF_XML: 1,
          DF_JSON: 2,
          DF_XML_OR_JSON: 3
        }
      },
      PBReturnParamType: {
        values: {
          RPT_XML: 0,
          RPT_TXT: 1,
          RPT_JSON: 2,
          RPT_PDF: 4,
          RPT_CUSTOMIZE: 5
        }
      },
      PBProductCategory: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          productType: {
            type: "PBProductType",
            id: 3
          },
          lastModifyAdmin: {
            type: "framework.PBAdmin",
            id: 4
          },
          lastAdminModifyDate: {
            type: "uint64",
            id: 5
          },
          products: {
            rule: "repeated",
            type: "PBProduct",
            id: 6
          },
          visible: {
            type: "bool",
            id: 7
          },
          serviceType: {
            type: "PBServiceType",
            id: 8
          },
          shortName: {
            type: "string",
            id: 9
          },
          order: {
            type: "int32",
            id: 10
          },
          nameEn: {
            type: "string",
            id: 11
          }
        }
      },
      PBProductPriceType: {
        values: {
          PPT_PER_MONTH: 0,
          PPT_PER_YEAR: 1
        }
      },
      PBProduct: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          briefDesc: {
            type: "string",
            id: 3
          },
          desc: {
            type: "string",
            id: 4
          },
          logo: {
            type: "string",
            id: 5
          },
          unitPrice: {
            type: "uint64",
            id: 6
          },
          order: {
            type: "uint32",
            id: 7
          },
          visible: {
            type: "bool",
            id: 8
          },
          categories: {
            rule: "repeated",
            type: "PBProductCategory",
            id: 9
          },
          mainPoints: {
            rule: "repeated",
            type: "PBProductMainPoint",
            id: 10
          },
          lastAdminModifyDate: {
            type: "uint64",
            id: 11
          },
          lastModifyAdmin: {
            type: "framework.PBAdmin",
            id: 12
          },
          unitType: {
            type: "PBProductPriceType",
            id: 13
          },
          dbProduct: {
            type: "bool",
            id: 14
          },
          marketPrice: {
            type: "uint64",
            id: 15
          },
          virtualProduct: {
            type: "bool",
            id: 16
          },
          serviceType: {
            type: "PBServiceType",
            id: 17
          },
          tkd: {
            type: "PBProductTKD",
            id: 18
          },
          guidanceOrder: {
            type: "uint32",
            id: 19
          },
          tag: {
            type: "PBProductTag",
            id: 20
          },
          nameEn: {
            type: "string",
            id: 21
          }
        }
      },
      PBProductMainPoint: {
        fields: {
          mainPointId: {
            type: "uint32",
            id: 7
          },
          productId: {
            type: "uint32",
            id: 8
          },
          name: {
            type: "string",
            id: 1
          },
          desc: {
            type: "string",
            id: 2
          },
          icon: {
            type: "string",
            id: 3
          },
          samplePicture: {
            type: "string",
            id: 4
          },
          demoPictures: {
            rule: "repeated",
            type: "PBProductMainPicture",
            id: 5
          },
          demoUrl: {
            type: "string",
            id: 6
          },
          demoPicturesH5: {
            rule: "repeated",
            type: "PBProductMainPicture",
            id: 9
          }
        }
      },
      PBProductMainPicture: {
        fields: {
          demoName: {
            type: "string",
            id: 1
          },
          demoPicture: {
            type: "string",
            id: 2
          },
          quoteUrl: {
            type: "string",
            id: 3
          }
        }
      },
      PBConfigType: {
        values: {
          UCT_IP: 0,
          UCT_DOMAIN: 1,
          UCT_KEY: 2,
          UCT_FOOTBALL_ANIM: 3
        }
      },
      PBProductConfig: {
        fields: {
          configId: {
            type: "uint32",
            id: 1
          },
          configName: {
            type: "string",
            id: 2
          },
          tryCategories: {
            rule: "repeated",
            type: "PBProductCategory",
            id: 3
          },
          categories: {
            rule: "repeated",
            type: "PBProductCategory",
            id: 4
          },
          desc: {
            type: "string",
            id: 5
          },
          serviceType: {
            type: "PBServiceType",
            id: 6
          },
          configType: {
            type: "PBConfigType",
            id: 7
          }
        }
      },
      PBProductConfigList: {
        fields: {
          configList: {
            rule: "repeated",
            type: "PBProductConfig",
            id: 1
          }
        }
      },
      PBSearchProductReq: {
        fields: {
          serviceType: {
            type: "PBServiceType",
            id: 1
          },
          categoryId: {
            type: "int32",
            id: 2
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBProductList: {
        fields: {
          products: {
            rule: "repeated",
            type: "PBProduct",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBSearchProductCategoryReq: {
        fields: {
          visible: {
            type: "framework.PBBoolValue",
            id: 1
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBProductCategoryList: {
        fields: {
          categories: {
            rule: "repeated",
            type: "PBProductCategory",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBGetProductListReq: {
        fields: {
          categoryIds: {
            rule: "repeated",
            type: "int32",
            id: 1
          },
          serviceType: {
            type: "PBServiceType",
            id: 2
          },
          userId: {
            type: "uint32",
            id: 3
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBProductConfigSetReq: {
        fields: {
          configId: {
            type: "uint32",
            id: 1
          },
          products: {
            rule: "repeated",
            type: "PBProduct",
            id: 2
          },
          isTry: {
            type: "bool",
            id: 3
          }
        }
      },
      PBProductTKD: {
        fields: {
          productId: {
            type: "uint32",
            id: 1
          },
          title: {
            type: "string",
            id: 2
          },
          keywords: {
            type: "string",
            id: 3
          },
          description: {
            type: "string",
            id: 4
          }
        }
      },
      PBProductTag: {
        values: {
          PRODUCT_TAG_NONE: 0,
          PRODUCT_TAG_NEW: 1,
          PRODUCT_TAG_HOT: 2
        }
      },
      PBUserProductStatus: {
        values: {
          UPS_IN_USE: 0,
          UPS_TO_BE_EXPIRE: 1,
          UPS_EXPIRED: 2
        }
      },
      PBUserProductTag: {
        values: {
          UPT_TRIAL_EXPIRED: 0,
          UPT_HISTORY_BOUGHT: 1,
          UPT_IN_USE: 2,
          UPT_TRIAL_IN_USE: 3
        }
      },
      PBProductBuyStatus: {
        values: {
          PPS_UN_BUY: 0,
          PPS_IN_TRIAL: 1,
          PPS_TRIAL_END: 2,
          PPS_PURCHASE: 3,
          PPS_HISTORY_BUY: 4
        }
      },
      PBPurchaseIntentionStatus: {
        values: {
          PIS_UN_COMMIT: 0,
          PIS_UN_PROCESS: 1,
          PIS_PROCESSED: 2,
          PIS_IGNORE: 3
        }
      },
      PBBusinessContactStatus: {
        values: {
          UCS_UN_COMMIT: 0,
          UCS_UN_PROCESS: 1,
          UCS_CONTACTED: 2,
          UCS_IGNORE: 3
        }
      },
      PBUserConfigStatus: {
        values: {
          UCS_TO_BE_CONFIG: 0,
          UCS_TO_BE_OPEN: 1,
          UCS_IN_USE: 2,
          UCS_DISABLED: 3
        }
      },
      PBMixUser: {
        fields: {
          user: {
            type: "PBUser",
            id: 1
          },
          enterpriseAuth: {
            type: "PBEnterpriseAuth",
            id: 100
          },
          intentions: {
            type: "PBPurchaseIntentionList",
            id: 101
          },
          name: {
            type: "string",
            id: 102
          },
          configs: {
            rule: "repeated",
            type: "PBUserConfig",
            id: 103
          },
          productNum: {
            type: "uint32",
            id: 104
          },
          existsDoubtIp: {
            type: "bool",
            id: 105
          },
          cooperationDesc: {
            type: "string",
            id: 16
          },
          tryDesc: {
            type: "string",
            id: 17
          }
        }
      },
      PBBusinessContact: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          user: {
            type: "PBUser",
            id: 2
          },
          enterpriseName: {
            type: "string",
            id: 3
          },
          contact: {
            type: "string",
            id: 4
          },
          telephone: {
            type: "string",
            id: 5
          },
          qq: {
            type: "string",
            id: 6
          },
          wechat: {
            type: "string",
            id: 7
          },
          buyIntention: {
            type: "string",
            id: 8
          },
          contactStatus: {
            type: "PBBusinessContactStatus",
            id: 9
          },
          lastCommitDate: {
            type: "uint64",
            id: 10
          },
          remark: {
            type: "string",
            id: 11
          },
          lastAdminModifyDate: {
            type: "uint64",
            id: 12
          },
          lastModifyAdmin: {
            type: "framework.PBAdmin",
            id: 13
          }
        }
      },
      PBUserConfig: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          user: {
            type: "PBUser",
            id: 2
          },
          configCount: {
            type: "uint32",
            id: 3
          },
          originAddresses: {
            rule: "repeated",
            type: "string",
            id: 4
          },
          currentAddresses: {
            rule: "repeated",
            type: "string",
            id: 5
          },
          configStatus: {
            type: "PBUserConfigStatus",
            id: 6
          },
          lastModifyDate: {
            type: "uint64",
            id: 7
          },
          lastAdminModifyDate: {
            type: "uint64",
            id: 8
          },
          lastModifyAdmin: {
            type: "framework.PBAdmin",
            id: 9
          },
          configType: {
            type: "PBConfigType",
            id: 11
          },
          configDesc: {
            type: "string",
            id: 10
          },
          remark: {
            type: "string",
            id: 12
          }
        }
      },
      PBUserProduct: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          user: {
            type: "PBUser",
            id: 2
          },
          buyStatus: {
            type: "PBProductBuyStatus",
            id: 3
          },
          product: {
            type: "PBProduct",
            id: 4
          },
          status: {
            type: "PBUserProductStatus",
            id: 5
          },
          createDate: {
            type: "uint64",
            id: 6
          },
          lastRenewDate: {
            type: "uint64",
            id: 7
          },
          effectiveDate: {
            type: "uint64",
            id: 8
          },
          renewDuration: {
            type: "uint32",
            id: 9
          },
          unitPrice: {
            type: "uint64",
            id: 10
          },
          lastAdminModifyDate: {
            type: "uint64",
            id: 11
          },
          lastModifyAdmin: {
            type: "framework.PBAdmin",
            id: 12
          },
          unitType: {
            type: "PBProductPriceType",
            id: 13
          },
          totalRenewDuration: {
            type: "uint32",
            id: 14
          },
          tags: {
            rule: "repeated",
            type: "PBUserProductTag",
            id: 15
          },
          renewable: {
            type: "bool",
            id: 16
          },
          newIncome: {
            type: "bool",
            id: 100
          },
          renewalStr: {
            type: "string",
            id: 101
          },
          docFormat: {
            type: "PBDocFormatType",
            id: 17
          }
        }
      },
      PBPurchaseIntention: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          userId: {
            type: "uint32",
            id: 2
          },
          renewProducts: {
            rule: "repeated",
            type: "PBProduct",
            id: 3
          },
          buyProducts: {
            rule: "repeated",
            type: "PBProduct",
            id: 4
          },
          remark: {
            type: "string",
            id: 5
          },
          adminRemark: {
            type: "string",
            id: 6
          },
          status: {
            type: "PBPurchaseIntentionStatus",
            id: 7
          },
          canModify: {
            type: "bool",
            id: 8
          },
          createDate: {
            type: "uint64",
            id: 9
          },
          lastAdminModifyDate: {
            type: "uint64",
            id: 10
          },
          lastModifyAdmin: {
            type: "framework.PBAdmin",
            id: 11
          },
          serviceType: {
            type: "PBServiceType",
            id: 12
          },
          modifyDate: {
            type: "uint64",
            id: 13
          },
          enterpriseAuth: {
            type: "PBEnterpriseAuth",
            id: 20
          }
        }
      },
      PBUserLoginRecord: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          user: {
            type: "PBUser",
            id: 2
          },
          loginIp: {
            type: "string",
            id: 3
          },
          loginDate: {
            type: "uint64",
            id: 4
          },
          doubtable: {
            type: "bool",
            id: 5
          },
          registerIp: {
            type: "bool",
            id: 6
          },
          address: {
            type: "string",
            id: 7
          }
        }
      },
      PBDocFormat: {
        fields: {
          interfaceId: {
            type: "uint32",
            id: 1
          },
          interfaceName: {
            type: "string",
            id: 2
          },
          paramType: {
            type: "PBReturnParamType",
            id: 3
          },
          check: {
            type: "bool",
            id: 4
          }
        }
      },
      PBDocFormatReq: {
        fields: {
          buyId: {
            type: "uint32",
            id: 1
          },
          docs: {
            rule: "repeated",
            type: "PBDocFormat",
            id: 2
          }
        }
      },
      PBDocFormatList: {
        fields: {
          docs: {
            rule: "repeated",
            type: "PBDocFormat",
            id: 1
          }
        }
      },
      PBUserConfigList: {
        fields: {
          configs: {
            rule: "repeated",
            type: "PBUserConfig",
            id: 1
          }
        }
      },
      PBGetUserPurchaseIntentionListReq: {
        fields: {
          userId: {
            type: "uint32",
            id: 1
          },
          serviceType: {
            type: "PBServiceType",
            id: 2
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBPurchaseIntentionList: {
        fields: {
          intentions: {
            rule: "repeated",
            type: "PBPurchaseIntention",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBProcessPurchaseIntentionReq: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          status: {
            type: "PBPurchaseIntentionStatus",
            id: 2
          },
          remark: {
            type: "string",
            id: 3
          }
        }
      },
      PBBoughtProduct: {
        fields: {
          product: {
            type: "PBProduct",
            id: 1
          },
          buyStatus: {
            type: "PBProductBuyStatus",
            id: 2
          },
          canTry: {
            type: "bool",
            id: 3
          },
          effectiveDate: {
            type: "uint64",
            id: 4
          },
          hasDoc: {
            type: "bool",
            id: 5
          },
          pdfUrl: {
            type: "string",
            id: 6
          },
          renewalStatus: {
            type: "uint32",
            id: 7
          },
          renewalId: {
            type: "uint64",
            id: 8
          },
          renewalStr: {
            type: "string",
            id: 9
          }
        }
      },
      PBBoughtUserProduct: {
        fields: {
          userProduct: {
            type: "PBUserProduct",
            id: 1
          },
          hasDoc: {
            type: "bool",
            id: 2
          },
          pdfUrl: {
            type: "string",
            id: 3
          }
        }
      },
      PBBoughtProductList: {
        fields: {
          list: {
            rule: "repeated",
            type: "PBBoughtProduct",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBBoughtUserProductList: {
        fields: {
          list: {
            rule: "repeated",
            type: "PBBoughtUserProduct",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBTryProductReq: {
        fields: {
          productId: {
            type: "uint32",
            id: 1
          }
        }
      },
      PBUserProductList: {
        fields: {
          userProducts: {
            rule: "repeated",
            type: "PBUserProduct",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBGetPurchaseProductListReq: {
        fields: {
          serviceType: {
            type: "PBServiceType",
            id: 1
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBGetBusinessContactListReq: {
        fields: {
          contactStatus: {
            type: "int32",
            id: 1
          },
          page: {
            type: "framework.PBPagePara",
            id: 5
          }
        }
      },
      PBBusinessContactList: {
        fields: {
          contacts: {
            rule: "repeated",
            type: "PBBusinessContact",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 5
          }
        }
      },
      PBGetEnterpriseAuthListReq: {
        fields: {
          authStatus: {
            type: "int32",
            id: 1
          },
          searchType: {
            type: "PBUserSearchType",
            id: 2
          },
          searchKey: {
            type: "string",
            id: 3
          },
          categoryTypes: {
            rule: "repeated",
            type: "uint32",
            id: 4
          },
          refererUrl: {
            type: "string",
            id: 5
          },
          beginDate: {
            type: "uint64",
            id: 6
          },
          endDate: {
            type: "uint64",
            id: 7
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBGetUserConfigListReq: {
        fields: {
          configStatus: {
            type: "PBUserConfigStatus",
            id: 1
          },
          configType: {
            type: "PBConfigType",
            id: 2
          },
          customerName: {
            type: "string",
            id: 3
          },
          ipAddress: {
            type: "string",
            id: 4
          },
          domainAddress: {
            type: "string",
            id: 5
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBIpConfigList: {
        fields: {
          configList: {
            rule: "repeated",
            type: "PBUserConfig",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBIncConfigCountReq: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          count: {
            type: "uint32",
            id: 2
          }
        }
      },
      PBRenewUserProductReq: {
        fields: {
          userProductId: {
            type: "uint32",
            id: 1
          },
          unitPrice: {
            type: "uint64",
            id: 3
          },
          renewDuration: {
            type: "uint32",
            id: 4
          },
          unitType: {
            type: "PBProductPriceType",
            id: 5
          }
        }
      },
      PBRepurchaseUserProductReq: {
        fields: {
          userProductId: {
            type: "uint32",
            id: 1
          },
          effectiveDate: {
            type: "uint64",
            id: 2
          },
          unitPrice: {
            type: "uint64",
            id: 3
          },
          renewDuration: {
            type: "uint32",
            id: 4
          },
          unitType: {
            type: "PBProductPriceType",
            id: 5
          }
        }
      },
      PBHandlePendingConfigReq: {
        fields: {
          configId: {
            type: "uint32",
            id: 1
          },
          remark: {
            type: "string",
            id: 2
          },
          isProcessed: {
            type: "bool",
            id: 3
          }
        }
      },
      PBConfigAddRemarkReq: {
        fields: {
          configId: {
            type: "uint32",
            id: 1
          },
          remark: {
            type: "string",
            id: 2
          }
        }
      },
      PBSearchUserTime: {
        values: {
          SUT_REG: 0,
          SUT_LOGIN: 1
        }
      },
      PBSearchUserKey: {
        values: {
          SUK_USER_ID: 0,
          SUK_EMAIL: 1,
          SUK_MOBILE: 2,
          SUK_LOGIN_IP: 3,
          SUK_REG_IP: 4
        }
      },
      PBSearchUserReq: {
        fields: {
          userTime: {
            type: "PBSearchUserTime",
            id: 1
          },
          beginDate: {
            type: "uint64",
            id: 2
          },
          endDate: {
            type: "uint64",
            id: 3
          },
          userKey: {
            type: "PBSearchUserKey",
            id: 4
          },
          keyValue: {
            type: "string",
            id: 5
          },
          userType: {
            type: "PBSearchUserType",
            id: 7
          },
          refererUrl: {
            type: "string",
            id: 8
          },
          isAdvisory: {
            type: "framework.PBBoolValue",
            id: 9
          },
          isCustomer: {
            type: "framework.PBBoolValue",
            id: 10
          },
          tryStatus: {
            type: "int32",
            id: 11
          },
          cooperationStatus: {
            type: "int32",
            id: 12
          },
          authStatus: {
            type: "int32",
            id: 13
          },
          page: {
            type: "framework.PBPagePara",
            id: 20
          }
        }
      },
      PBSearchUserType: {
        values: {
          SEARCH_ALL: 0,
          SEARCH_REAL: 1,
          SEARCH_TEST: 2
        }
      },
      PBUserList: {
        fields: {
          users: {
            rule: "repeated",
            type: "PBUser",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBUserConfigProduct: {
        fields: {
          config: {
            type: "PBUserConfig",
            id: 1
          },
          products: {
            rule: "repeated",
            type: "PBUserProduct",
            id: 2
          },
          customerName: {
            type: "string",
            id: 3
          }
        }
      },
      PBUserConfigProductList: {
        fields: {
          ipProducts: {
            rule: "repeated",
            type: "PBUserConfigProduct",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBUserSearchType: {
        values: {
          UST_COMPANY_NAME: 0,
          UST_USER_ID: 1,
          UST_CONTACT: 2,
          UST_MOBILE: 3,
          UST_QQ: 4,
          UST_IP: 5
        }
      },
      PBSearchIntentionListReq: {
        fields: {
          status: {
            type: "int32",
            id: 1
          },
          searchType: {
            type: "PBUserSearchType",
            id: 2
          },
          searchKey: {
            type: "string",
            id: 3
          },
          serviceType: {
            type: "PBServiceType",
            id: 4
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBAllUserProductList: {
        fields: {
          productList: {
            keyType: "uint32",
            type: "PBBoughtProductList",
            id: 1
          }
        }
      },
      PBSearchUserLoginType: {
        values: {
          SUT_USER_ID: 0,
          SUT_IP: 1
        }
      },
      PBSearchUserLoginRecordReq: {
        fields: {
          isDoubt: {
            type: "int32",
            id: 1
          },
          searchType: {
            type: "PBSearchUserLoginType",
            id: 2
          },
          searchKey: {
            type: "string",
            id: 3
          },
          distinctRecord: {
            type: "bool",
            id: 4
          },
          platform: {
            type: "PBPlatformType",
            id: 5
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBUserLoginRecordList: {
        fields: {
          records: {
            rule: "repeated",
            type: "PBUserLoginRecord",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBBatchAddBoughtProductsReq: {
        fields: {
          userProducts: {
            rule: "repeated",
            type: "PBUserProduct",
            id: 1
          },
          arrivalDate: {
            type: "uint64",
            id: 2
          },
          totalPrice: {
            type: "uint64",
            id: 3
          },
          newCustomer: {
            type: "bool",
            id: 4
          },
          userId: {
            type: "uint32",
            id: 5
          },
          accountId: {
            type: "int32",
            id: 8
          },
          remitterName: {
            type: "string",
            id: 6
          },
          serviceType: {
            type: "PBServiceType",
            id: 7
          }
        }
      },
      PBMixUserList: {
        fields: {
          users: {
            rule: "repeated",
            type: "PBMixUser",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBModifyTesterReq: {
        fields: {
          userId: {
            type: "uint32",
            id: 1
          },
          tester: {
            type: "bool",
            id: 2
          }
        }
      },
      PBUserKeyRsp: {
        fields: {
          accessKey: {
            type: "string",
            id: 1
          },
          secretKey: {
            type: "string",
            id: 2
          },
          configDesc: {
            type: "string",
            id: 3
          }
        }
      },
      PBUserConfigRsp: {
        fields: {
          configList: {
            rule: "repeated",
            type: "PBUserConfig",
            id: 1
          },
          userKey: {
            type: "PBUserKeyRsp",
            id: 2
          }
        }
      },
      PBUserRegisterSource: {
        values: {
          URS_SELF: 0,
          URS_7MOOR: 1,
          URS_QIUTAN: 2,
          URS_QQ: 3,
          URS_OTHER: 4
        }
      },
      PBUserCooperationStatus: {
        values: {
          UCS_NOT_CUSTOMER: 0,
          UCS_NOT_COOPERATION: 1,
          UCS_IN_COOPERATION: 2,
          UCS_INTERFACE_EXPIRED: 3,
          UCS_LOST: 4
        }
      },
      PBUserTryStatus: {
        values: {
          UTS_NOT_TRY: 0,
          UTS_TRYING: 1,
          UTS_TRY_END: 2
        }
      },
      PBUser: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          password: {
            type: "string",
            id: 2
          },
          registerDate: {
            type: "uint64",
            id: 3
          },
          registerIp: {
            type: "string",
            id: 4
          },
          regAddress: {
            type: "string",
            id: 17
          },
          lastLoginDate: {
            type: "uint64",
            id: 5
          },
          lastLoginIp: {
            type: "string",
            id: 6
          },
          loginAddress: {
            type: "string",
            id: 18
          },
          mobile: {
            type: "string",
            id: 7
          },
          mobileCode: {
            type: "string",
            id: 8
          },
          email: {
            type: "string",
            id: 9
          },
          lastModifyPasswordDate: {
            type: "uint64",
            id: 10
          },
          source: {
            type: "PBUserRegisterSource",
            id: 11
          },
          locked: {
            type: "bool",
            id: 12
          },
          cooperationStatus: {
            type: "PBUserCooperationStatus",
            id: 13
          },
          tryStatus: {
            type: "PBUserTryStatus",
            id: 26
          },
          platformType: {
            type: "PBPlatformType",
            id: 14
          },
          registerUrl: {
            type: "string",
            id: 15
          },
          refererUrl: {
            type: "string",
            id: 16
          },
          accessToken: {
            type: "string",
            id: 19
          },
          token: {
            type: "string",
            id: 20
          },
          accessKey: {
            type: "string",
            id: 21
          },
          secretKey: {
            type: "string",
            id: 22
          },
          tester: {
            type: "bool",
            id: 23
          },
          spAccessKey: {
            type: "string",
            id: 24
          },
          spSecretKey: {
            type: "string",
            id: 25
          },
          sameIpUserCount: {
            type: "int32",
            id: 27
          },
          advisoryNum: {
            type: "int32",
            id: 28
          },
          autoAuth: {
            type: "bool",
            id: 29
          },
          invitationCode: {
            type: "string",
            id: 30
          }
        }
      },
      PBMobileValidCodeReq: {
        fields: {
          mobileCode: {
            type: "string",
            id: 1
          },
          mobile: {
            type: "string",
            id: 2
          },
          validCodeType: {
            type: "PBValidCodeType",
            id: 3
          }
        }
      },
      PBEmailValidCodeReq: {
        fields: {
          email: {
            type: "string",
            id: 1
          },
          validCodeType: {
            type: "PBValidCodeType",
            id: 2
          }
        }
      },
      PBUserMobileRegisterReq: {
        fields: {
          mobile: {
            type: "string",
            id: 1
          },
          mobileCode: {
            type: "string",
            id: 2
          },
          validCode: {
            type: "string",
            id: 3
          },
          password: {
            type: "string",
            id: 4
          },
          registerUrl: {
            type: "string",
            id: 5
          },
          refererUrl: {
            type: "string",
            id: 6
          }
        }
      },
      PBUserEmailRegisterReq: {
        fields: {
          email: {
            type: "string",
            id: 1
          },
          validCode: {
            type: "string",
            id: 2
          },
          password: {
            type: "string",
            id: 3
          },
          registerUrl: {
            type: "string",
            id: 5
          },
          refererUrl: {
            type: "string",
            id: 6
          }
        }
      },
      PBUserMobileRegisterAndAuthReq: {
        fields: {
          mobile: {
            type: "string",
            id: 1
          },
          mobileCode: {
            type: "string",
            id: 2
          },
          validCode: {
            type: "string",
            id: 3
          },
          password: {
            type: "string",
            id: 4
          },
          registerUrl: {
            type: "string",
            id: 5
          },
          refererUrl: {
            type: "string",
            id: 6
          },
          qq: {
            type: "string",
            id: 7
          },
          enterpriseName: {
            type: "string",
            id: 8
          },
          invitationCode: {
            type: "string",
            id: 9
          }
        }
      },
      PBUserEmailRegisterAndAuthReq: {
        fields: {
          email: {
            type: "string",
            id: 1
          },
          validCode: {
            type: "string",
            id: 2
          },
          password: {
            type: "string",
            id: 3
          },
          registerUrl: {
            type: "string",
            id: 5
          },
          refererUrl: {
            type: "string",
            id: 6
          },
          qq: {
            type: "string",
            id: 7
          },
          enterpriseName: {
            type: "string",
            id: 8
          },
          invitationCode: {
            type: "string",
            id: 9
          }
        }
      },
      PBUserLoginReq: {
        fields: {
          account: {
            type: "string",
            id: 1
          },
          mobileCode: {
            type: "string",
            id: 2
          },
          password: {
            type: "string",
            id: 3
          },
          validCode: {
            type: "string",
            id: 4
          }
        }
      },
      PBUserMobileResetPasswordReq: {
        fields: {
          mobileCode: {
            type: "string",
            id: 1
          },
          mobile: {
            type: "string",
            id: 2
          },
          password: {
            type: "string",
            id: 3
          },
          validCode: {
            type: "string",
            id: 4
          }
        }
      },
      PBUserEmailResetPasswordReq: {
        fields: {
          email: {
            type: "string",
            id: 1
          },
          password: {
            type: "string",
            id: 2
          },
          validCode: {
            type: "string",
            id: 3
          }
        }
      },
      PBUserBindMobileReq: {
        fields: {
          userId: {
            type: "uint32",
            id: 1
          },
          validCode: {
            type: "string",
            id: 2
          },
          mobile: {
            type: "string",
            id: 3
          },
          mobileCode: {
            type: "string",
            id: 4
          }
        }
      },
      PBUserBindEmailReq: {
        fields: {
          userId: {
            type: "uint32",
            id: 1
          },
          validCode: {
            type: "string",
            id: 2
          },
          email: {
            type: "string",
            id: 3
          }
        }
      },
      PBUserValidPasswordReq: {
        fields: {
          password: {
            type: "string",
            id: 1
          }
        }
      },
      PBModifyUserRegisterSourceReq: {
        fields: {
          userId: {
            type: "uint32",
            id: 1
          },
          source: {
            type: "PBUserRegisterSource",
            id: 2
          }
        }
      },
      PBAccountExistsReq: {
        fields: {
          account: {
            type: "string",
            id: 1
          },
          mobileCode: {
            type: "string",
            id: 2
          },
          platform: {
            type: "PBPlatformType",
            id: 3
          }
        }
      },
      PBGetUserListByIpReq: {
        fields: {
          ip: {
            type: "string",
            id: 1
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBOrderType: {
        values: {
          OTP_ASC: 0,
          OTP_DESC: 1
        }
      },
      PBStringList: {
        fields: {
          values: {
            rule: "repeated",
            type: "string",
            id: 1
          }
        }
      },
      PBLongList: {
        fields: {
          values: {
            rule: "repeated",
            type: "int64",
            id: 2
          }
        }
      },
      PBIntList: {
        fields: {
          values: {
            rule: "repeated",
            type: "int32",
            id: 2
          }
        }
      },
      PBValidCodeType: {
        values: {
          VALID_REGISTER: 0,
          VALID_RESET_PASSWORD: 1,
          VALID_LOGIN: 2,
          VALID_BIND_MOBILE: 3,
          VALID_BIND_EMAIL: 4,
          VALID_MODIFY_TOKEN: 5
        }
      },
      PBTransferType: {
        values: {
          TRANSFER_TYPE_PUBLIC: 0,
          TRANSFER_TYPE_PRIVATE: 1
        }
      },
      PBInvoiceType: {
        values: {
          INVOICE_TYPE_NOT_CONFIG: 0,
          INVOICE_TYPE_NOT_NEED: 1,
          INVOICE_TYPE_ORDINARY_PAPER: 2,
          INVOICE_TYPE_ORDINARY_ELECTRONIC: 3,
          INVOICE_TYPE_SPECIAL: 4,
          INVOICE_TYPE_RECEIPT: 5
        }
      },
      PBPlatformType: {
        values: {
          PLATFORM_TYPE_FLYWHALE: 0,
          PLATFORM_TYPE_LOTTERY: 1
        }
      },
      PBAccountType: {
        values: {
          ACCOUNT_TYPE_PUBLIC: 0,
          ACCOUNT_TYPE_ALIPAY: 1,
          ACCOUNT_TYPE_PRIVATE: 2
        }
      },
      PBReceiveAccount: {
        fields: {
          accountId: {
            type: "int32",
            id: 4
          },
          payee: {
            type: "string",
            id: 1
          },
          bank: {
            type: "string",
            id: 2
          },
          account: {
            type: "string",
            id: 3
          },
          accountType: {
            type: "PBAccountType",
            id: 5
          },
          bankNo: {
            type: "string",
            id: 6
          },
          sampleImage: {
            type: "string",
            id: 7
          }
        }
      },
      PBReceiveAccountList: {
        fields: {
          accounts: {
            rule: "repeated",
            type: "PBReceiveAccount",
            id: 1
          }
        }
      },
      PBEnterpriseAuthStatus: {
        values: {
          EAS_UN_COMMIT: 0,
          EAS_CHECK_PENDING: 1,
          EAS_PASS: 2,
          EAS_FAIL: 3,
          EAS_IGNORE: 4
        }
      },
      PBEnterpriseAuth: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          user: {
            type: "PBUser",
            id: 2
          },
          appName: {
            type: "string",
            id: 3
          },
          enterpriseName: {
            type: "string",
            id: 4
          },
          websiteInfo: {
            type: "string",
            id: 5
          },
          businessLicenses: {
            rule: "repeated",
            type: "string",
            id: 6
          },
          contact: {
            type: "string",
            id: 7
          },
          telephone: {
            type: "string",
            id: 8
          },
          qq: {
            type: "string",
            id: 9
          },
          wechat: {
            type: "string",
            id: 10
          },
          authStatus: {
            type: "PBEnterpriseAuthStatus",
            id: 11
          },
          lastCommitDate: {
            type: "uint64",
            id: 12
          },
          remark: {
            type: "string",
            id: 13
          },
          lastAdminModifyDate: {
            type: "uint64",
            id: 14
          },
          lastModifyAdmin: {
            type: "framework.PBAdmin",
            id: 15
          },
          legalIdCardFront: {
            type: "string",
            id: 16
          },
          legalIdCardBack: {
            type: "string",
            id: 17
          },
          commitIp: {
            type: "string",
            id: 18
          },
          ipAddress: {
            type: "string",
            id: 25
          },
          doubtIp: {
            type: "bool",
            id: 19
          },
          optRemark: {
            type: "string",
            id: 20
          },
          sameIpUserCount: {
            type: "uint32",
            id: 21
          },
          remarkModifyDate: {
            type: "uint64",
            id: 22
          },
          remarkModifyAdmin: {
            type: "framework.PBAdmin",
            id: 23
          },
          categoryTypes: {
            rule: "repeated",
            type: "PBProductCategory",
            id: 26
          },
          serviceTypes: {
            rule: "repeated",
            type: "int32",
            id: 27
          },
          forceUploadIDCard: {
            type: "bool",
            id: 28
          },
          existsDoubtIp: {
            type: "bool",
            id: 100
          }
        }
      },
      PBEnterpriseAuthList: {
        fields: {
          auths: {
            rule: "repeated",
            type: "PBEnterpriseAuth",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 5
          }
        }
      },
      PBMaterialType: {
        values: {
          MT_GRANDSTAND: 0,
          MT_SITE: 1,
          MT_FENCE: 2,
          MT_MID_LINE: 3
        }
      },
      PBMaterial: {
        fields: {
          materialId: {
            type: "uint32",
            id: 1
          },
          materialName: {
            type: "string",
            id: 2
          },
          materialPath: {
            type: "string",
            id: 3
          },
          type: {
            type: "PBMaterialType",
            id: 4
          },
          sortNumber: {
            type: "uint32",
            id: 5
          }
        }
      },
      PBAnimUser: {
        fields: {
          configId: {
            type: "uint32",
            id: 1
          },
          user: {
            type: "PBUser",
            id: 2
          },
          description: {
            type: "string",
            id: 3
          },
          material: {
            type: "PBMaterial",
            id: 5
          },
          showPath: {
            type: "string",
            id: 4
          }
        }
      },
      PBAnimUserList: {
        fields: {
          animMap: {
            keyType: "uint32",
            type: "PBAnimUser",
            id: 1
          },
          domains: {
            rule: "repeated",
            type: "string",
            id: 2
          },
          configDesc: {
            type: "string",
            id: 3
          },
          enable: {
            type: "bool",
            id: 4
          },
          show: {
            type: "bool",
            id: 5
          }
        }
      },
      PBMaterialList: {
        fields: {
          materials: {
            rule: "repeated",
            type: "PBMaterial",
            id: 1
          }
        }
      },
      PBMaterialListRsp: {
        fields: {
          materialMap: {
            keyType: "uint32",
            type: "PBMaterialList",
            id: 1
          }
        }
      },
      PBApiDocument: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          product: {
            type: "PBProduct",
            id: 3
          },
          category: {
            rule: "repeated",
            type: "PBInterfaceCategory",
            id: 4
          },
          pdfUrl: {
            type: "string",
            id: 5
          },
          serviceType: {
            type: "PBServiceType",
            id: 6
          }
        }
      },
      PBInterfaceCategory: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          descs: {
            rule: "repeated",
            type: "PBInterfaceDesc",
            id: 3
          },
          order: {
            type: "uint32",
            id: 4
          },
          docId: {
            type: "uint32",
            id: 5
          }
        }
      },
      PBInterfaceDesc: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          requestInfo: {
            type: "PBRequestInfo",
            id: 3
          },
          requestParams: {
            rule: "repeated",
            type: "PBRequestParam",
            id: 4
          },
          returnParams: {
            rule: "repeated",
            type: "PBReturnParam",
            id: 5
          },
          returnParamType: {
            type: "PBReturnParamType",
            id: 6
          },
          categoryIds: {
            rule: "repeated",
            type: "uint32",
            id: 7
          },
          order: {
            type: "uint32",
            id: 8
          },
          changeLogs: {
            rule: "repeated",
            type: "PBInterfaceChangeLog",
            id: 10
          },
          updateDate: {
            type: "uint64",
            id: 11
          },
          status: {
            type: "PBInterfaceStatus",
            id: 12
          },
          logUpdateDate: {
            type: "uint64",
            id: 13
          },
          fileUrl: {
            type: "string",
            id: 9
          },
          serviceType: {
            type: "PBServiceType",
            id: 14
          },
          relatedId: {
            type: "uint32",
            id: 15
          },
          textContent: {
            type: "string",
            id: 16
          }
        }
      },
      PBRequestInfo: {
        fields: {
          description: {
            type: "string",
            id: 1
          },
          requestUrl: {
            type: "string",
            id: 2
          },
          frequencyLimit: {
            type: "string",
            id: 3
          },
          updateFrequency: {
            type: "string",
            id: 4
          },
          requestMethod: {
            type: "string",
            id: 5
          },
          demoUrl: {
            type: "string",
            id: 6
          },
          frequency: {
            type: "PBRequestFrequency",
            id: 8
          },
          limit: {
            type: "uint32",
            id: 9
          }
        }
      },
      PBRequestFrequency: {
        values: {
          FREQUENCY_SECOND: 0,
          FREQUENCY_MINUTE: 1,
          FREQUENCY_HOUR: 2,
          FREQUENCY_DAY: 3,
          FREQUENCY_NOT_LIMIT: 4
        }
      },
      PBRequestParam: {
        fields: {
          name: {
            type: "string",
            id: 1
          },
          meaning: {
            type: "string",
            id: 2
          },
          type: {
            type: "string",
            id: 3
          },
          required: {
            type: "bool",
            id: 4
          }
        }
      },
      PBReturnParam: {
        fields: {
          name: {
            type: "string",
            id: 1
          },
          meaning: {
            type: "string",
            id: 2
          },
          fields: {
            rule: "repeated",
            type: "PBParamField",
            id: 3
          },
          separator: {
            type: "string",
            id: 4
          },
          type: {
            type: "string",
            id: 5
          },
          introduction: {
            type: "string",
            id: 6
          },
          returnParams: {
            rule: "repeated",
            type: "PBReturnParam",
            id: 7
          }
        }
      },
      PBParamField: {
        fields: {
          name: {
            type: "string",
            id: 1
          },
          value: {
            type: "string",
            id: 2
          }
        }
      },
      PBInterfaceChangeLog: {
        fields: {
          id: {
            type: "uint64",
            id: 1
          },
          interfaceId: {
            type: "uint32",
            id: 2
          },
          categoryId: {
            type: "uint32",
            id: 6
          },
          createAdmin: {
            type: "framework.PBAdmin",
            id: 3
          },
          createDate: {
            type: "uint64",
            id: 4
          },
          content: {
            type: "string",
            id: 5
          }
        }
      },
      PBInterfaceStatus: {
        values: {
          INTERFACE_STATUS_NONE: 0,
          INTERFACE_STATUS_NEW: 1,
          INTERFACE_STATUS_DEPRECATED: 2,
          INTERFACE_STATUS_UPDATE: 3
        }
      },
      PBUserApiDocument: {
        fields: {
          apiDoc: {
            type: "PBApiDocument",
            id: 1
          },
          userProduct: {
            type: "PBUserProduct",
            id: 2
          }
        }
      },
      PBInterfafeOptType: {
        values: {
          INTERFACE_OPT_TYPE_ADD: 0,
          INTERFACE_OPT_TYPE_UPDATE: 1,
          INTERFACE_OPT_TYPE_DEPRECATED: 2
        }
      },
      PBApiDocumentList: {
        fields: {
          documents: {
            rule: "repeated",
            type: "PBApiDocument",
            id: 1
          }
        }
      },
      PBUserApiDocumentList: {
        fields: {
          documents: {
            rule: "repeated",
            type: "PBUserApiDocument",
            id: 1
          },
          token: {
            type: "string",
            id: 2
          }
        }
      },
      PBRequestApi: {
        fields: {
          url: {
            type: "string",
            id: 1
          },
          token: {
            type: "string",
            id: 2
          },
          documentId: {
            type: "uint32",
            id: 3
          },
          serviceType: {
            type: "PBServiceType",
            id: 4
          }
        }
      },
      PBApiResponse: {
        fields: {
          message: {
            type: "string",
            id: 1
          },
          mediaType: {
            type: "string",
            id: 2
          },
          content: {
            type: "string",
            id: 3
          }
        }
      },
      PBInterfaceDescList: {
        fields: {
          descList: {
            rule: "repeated",
            type: "PBInterfaceDesc",
            id: 1
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBGetInterfaceChangeLogListReq: {
        fields: {
          interfaceId: {
            type: "uint32",
            id: 1
          },
          categoryId: {
            type: "uint32",
            id: 2
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBInterfaceChangeLogList: {
        fields: {
          changeLogs: {
            rule: "repeated",
            type: "PBInterfaceChangeLog",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBModifyInterfaceReq: {
        fields: {
          interfaceDesc: {
            type: "PBInterfaceDesc",
            id: 1
          },
          logContent: {
            type: "string",
            id: 2
          },
          addLogAndNotify: {
            type: "bool",
            id: 3
          }
        }
      },
      PBAddInterfaceDescReq: {
        fields: {
          interfaceDesc: {
            type: "PBInterfaceDesc",
            id: 1
          },
          notify: {
            type: "bool",
            id: 4
          }
        }
      },
      PBGetDocumentListReq: {
        fields: {
          token: {
            type: "string",
            id: 1
          },
          serviceType: {
            type: "PBServiceType",
            id: 2
          },
          paramType: {
            type: "PBReturnParamType",
            id: 3
          }
        }
      },
      PBInterfaceCategoryList: {
        fields: {
          categories: {
            rule: "repeated",
            type: "PBInterfaceCategory",
            id: 1
          }
        }
      },
      PBAuthReq: {
        fields: {
          type: {
            type: "uint32",
            id: 1
          },
          accessKey: {
            type: "string",
            id: 2
          },
          timestamp: {
            type: "uint64",
            id: 3
          },
          host: {
            type: "string",
            id: 4
          },
          auth: {
            type: "string",
            id: 5
          }
        }
      },
      PBAuthRsp: {
        fields: {
          anim: {
            type: "PBAnimUserList",
            id: 1
          }
        }
      },
      PBBillInfoStatus: {
        values: {
          BILL_INFO_DEFAULT: 0,
          BILL_INFO_PENDING: 1,
          BILL_INFO_IGNORE: 2,
          BILL_INFO_REJECT: 3,
          BILL_INFO_PASS: 4
        }
      },
      PBBillInfo: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          userId: {
            type: "uint32",
            id: 2
          },
          status: {
            type: "PBBillInfoStatus",
            id: 3
          },
          transferType: {
            type: "PBTransferType",
            id: 4
          },
          invoiceType: {
            type: "uint32",
            id: 5
          },
          taxpayerName: {
            type: "string",
            id: 6
          },
          taxpayerNo: {
            type: "string",
            id: 7
          },
          address: {
            type: "string",
            id: 8
          },
          mobile: {
            type: "string",
            id: 9
          },
          bank: {
            type: "string",
            id: 10
          },
          accountNo: {
            type: "string",
            id: 11
          },
          businessLicense: {
            type: "string",
            id: 12
          },
          taxpayerProof: {
            type: "string",
            id: 13
          },
          email: {
            type: "string",
            id: 14
          },
          submitDate: {
            type: "uint64",
            id: 15
          },
          firstSubmit: {
            type: "bool",
            id: 16
          },
          deliveryAddress: {
            type: "PBDeliveryAddress",
            id: 17
          },
          transfers: {
            rule: "repeated",
            type: "PBBillTransfer",
            id: 18
          },
          modifyInfo: {
            type: "PBBillInfo",
            id: 20
          },
          adminRemark: {
            type: "string",
            id: 21
          },
          updateAdmin: {
            type: "framework.PBAdmin",
            id: 22
          },
          adminUpdateDate: {
            type: "uint64",
            id: 23
          },
          rejectReason: {
            type: "string",
            id: 24
          },
          authStatus: {
            type: "uint32",
            id: 30
          },
          historyInvoiceCount: {
            type: "uint32",
            id: 31
          }
        }
      },
      PBSearchBillInfoListReq: {
        fields: {
          status: {
            type: "PBBillInfoStatus",
            id: 1
          },
          taxpayerName: {
            type: "string",
            id: 2
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBBillInfoList: {
        fields: {
          billList: {
            rule: "repeated",
            type: "PBBillInfo",
            id: 1
          },
          pendingCount: {
            type: "uint32",
            id: 2
          },
          rejectCount: {
            type: "uint32",
            id: 3
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBBillCheckReq: {
        fields: {
          billInfoId: {
            type: "uint32",
            id: 1
          },
          status: {
            type: "PBBillInfoStatus",
            id: 2
          },
          remark: {
            type: "string",
            id: 3
          },
          rejectReason: {
            type: "string",
            id: 4
          }
        }
      },
      PBBillInfoIgnoreReq: {
        fields: {
          billInfoId: {
            type: "uint32",
            id: 1
          },
          status: {
            type: "PBBillInfoStatus",
            id: 2
          },
          remark: {
            type: "string",
            id: 3
          }
        }
      },
      PBBillTransfer: {
        fields: {
          serviceType: {
            type: "int32",
            id: 1
          },
          account: {
            type: "PBReceiveAccount",
            id: 2
          }
        }
      },
      PBDeliveryAddress: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          userId: {
            type: "uint32",
            id: 2
          },
          name: {
            type: "string",
            id: 3
          },
          mobile: {
            type: "string",
            id: 4
          },
          address: {
            type: "string",
            id: 5
          }
        }
      },
      PBContactDuty: {
        values: {
          CONTACT_DUTY_TECHNIQUE: 0,
          CONTACT_DUTY_BUSINESS: 1,
          CONTACT_DUTY_FINANCE: 2
        }
      },
      PBContact: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          userId: {
            type: "uint32",
            id: 2
          },
          dutys: {
            rule: "repeated",
            type: "PBContactDuty",
            id: 3
          },
          mobile: {
            type: "string",
            id: 4
          },
          email: {
            type: "string",
            id: 5
          },
          wechat: {
            type: "string",
            id: 6
          },
          qq: {
            type: "string",
            id: 7
          },
          qqGroup: {
            type: "string",
            id: 8
          },
          name: {
            type: "string",
            id: 9
          },
          primary: {
            type: "bool",
            id: 10
          }
        }
      },
      PBContactList: {
        fields: {
          contacts: {
            rule: "repeated",
            type: "PBContact",
            id: 1
          }
        }
      },
      PBReturnVisitRecord: {
        fields: {
          id: {
            type: "uint64",
            id: 1
          },
          userId: {
            type: "uint32",
            id: 2
          },
          visitName: {
            type: "string",
            id: 3
          },
          summary: {
            type: "string",
            id: 4
          },
          visitDate: {
            type: "uint64",
            id: 5
          },
          createAdmin: {
            type: "framework.PBAdmin",
            id: 6
          },
          updateDate: {
            type: "uint64",
            id: 7
          },
          modifyAdmin: {
            type: "framework.PBAdmin",
            id: 8
          },
          contacts: {
            rule: "repeated",
            type: "PBContact",
            id: 9
          }
        }
      },
      PBReturnVisitRecordList: {
        fields: {
          records: {
            rule: "repeated",
            type: "PBReturnVisitRecord",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBGetReturnVisitRecordListReq: {
        fields: {
          userId: {
            type: "uint32",
            id: 1
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBCharge: {
        fields: {
          totalPrice: {
            type: "uint64",
            id: 2
          },
          renewalDuration: {
            type: "uint32",
            id: 3
          },
          perMonthPrice: {
            type: "uint64",
            id: 4
          },
          remitterName: {
            type: "string",
            id: 5
          },
          arriveDate: {
            type: "uint64",
            id: 6
          }
        }
      },
      PBChurnReason: {
        values: {
          CR_DEFAULT: 0,
          CR_BUSINESS_CHANGE: 1,
          CR_DATA_QUALITY: 2,
          CR_NOT_CONTACT: 3,
          CR_FUNDING: 4,
          CR_OTHER: 5
        }
      },
      PBChurnRecord: {
        fields: {
          recordId: {
            type: "uint32",
            id: 1
          },
          customer: {
            type: "PBCustomer",
            id: 2
          },
          followUp: {
            type: "bool",
            id: 3
          },
          grandTotal: {
            type: "uint32",
            id: 4
          },
          buyProduct: {
            type: "string",
            id: 5
          },
          beginDate: {
            type: "uint64",
            id: 6
          },
          endDate: {
            type: "uint64",
            id: 7
          },
          cooperationDuration: {
            type: "string",
            id: 8
          },
          reason: {
            type: "PBChurnReason",
            id: 9
          },
          reasonDesc: {
            type: "string",
            id: 10
          },
          remark: {
            type: "string",
            id: 11
          },
          serviceType: {
            type: "PBServiceType",
            id: 12
          },
          updateTime: {
            type: "uint64",
            id: 13
          },
          admin: {
            type: "framework.PBAdmin",
            id: 14
          }
        }
      },
      PBChurnRecordList: {
        fields: {
          list: {
            rule: "repeated",
            type: "PBChurnRecord",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 5
          }
        }
      },
      PBChurnRecordSearchType: {
        values: {
          CRS_CUSTOMER_NAME: 0,
          CRS_PRODUCT_NAME: 1,
          CRS_RECORD_ID: 2
        }
      },
      PBChurnRecordTimeType: {
        values: {
          CRT_CHURN_TIME: 0,
          CRT_COOPERATION_TIME: 1
        }
      },
      PBChurnRecordSearchReq: {
        fields: {
          serviceType: {
            type: "PBServiceType",
            id: 1
          },
          searchType: {
            type: "PBChurnRecordSearchType",
            id: 2
          },
          keyValue: {
            type: "string",
            id: 3
          },
          timeType: {
            type: "PBChurnRecordTimeType",
            id: 4
          },
          beginTime: {
            type: "uint64",
            id: 5
          },
          endTime: {
            type: "uint64",
            id: 6
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBCustomerBusinessType: {
        values: {
          CUSTOMER_BT_LOTTERY: 0,
          CUSTOMER_BT_INFORMATION: 1,
          CUSTOMER_BT_LIVE: 2,
          CUSTOMER_BT_DATA: 3,
          CUSTOMER_BT_QUIZ: 4,
          CUSTOMER_BT_RECOMMEND: 5,
          CUSTOMER_BT_GAME: 6
        }
      },
      PBCustomerProductForm: {
        values: {
          CUSTOMER_PF_PC: 0,
          CUSTOMER_PF_APP: 1,
          CUSTOMER_PF_MINI_PROGRAM: 2,
          CUSTOMER_PF_H5: 3
        }
      },
      PBContributionDegree: {
        values: {
          CUSTOMER_CB_DEGREE_LOW: 0,
          CUSTOMER_CB_DEGREE_MEDIUM: 1,
          CUSTOMER_CB_DEGREE_HIGH: 2
        }
      },
      PBCustomerTechLevel: {
        values: {
          CUSTOMER_TL_LEVEL_LOW: 0,
          CUSTOMER_TL_LEVEL_MEDIUM: 1,
          CUSTOMER_TL_LEVEL_HIGH: 2
        }
      },
      PBCustomerPopularity: {
        values: {
          CUSTOMER_POPULARITY_LOW: 0,
          CUSTOMER_POPULARITY_MEDIUM: 1,
          CUSTOMER_POPULARITY_HIGH: 2
        }
      },
      PBContractStatus: {
        values: {
          CONTRACT_STATUS_EXPIRED: 0,
          CONTRACT_STATUS_TO_BE_EXPIRE: 1,
          CONTRACT_STATUS_EFFECTIVE: 2
        }
      },
      PBContractType: {
        values: {
          CT_DEFAULT: 0,
          CT_ONLINE: 1,
          CT_PAPER: 2
        }
      },
      PBContractCirculationStatus: {
        values: {
          CONTRACT_CS_FINISH: 0,
          CONTRACT_CS_IN_CIRCULATION: 1
        }
      },
      PBContractCirculationInfoType: {
        values: {
          CONTRACT_CIRCULATION_C_GZ: 0,
          CONTRACT_CIRCULATION_GZ_ZQ: 1,
          CONTRACT_CIRCULATION_ZQ_C: 2
        }
      },
      PBCustomer: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          user: {
            type: "PBUser",
            id: 2
          },
          name: {
            type: "string",
            id: 3
          },
          initialCpDate: {
            type: "uint64",
            id: 4
          },
          location: {
            type: "framework.PBLocation",
            id: 5
          },
          businessTypes: {
            rule: "repeated",
            type: "PBCustomerBusinessType",
            id: 6
          },
          productForms: {
            rule: "repeated",
            type: "PBCustomerProductForm",
            id: 7
          },
          productName: {
            type: "string",
            id: 8
          },
          websiteInfo: {
            type: "string",
            id: 9
          },
          contributeDegree: {
            type: "PBContributionDegree",
            id: 10
          },
          techLevel: {
            type: "PBCustomerTechLevel",
            id: 11
          },
          popularity: {
            type: "PBCustomerPopularity",
            id: 12
          }
        }
      },
      PBContractCirculationInfo: {
        fields: {
          title: {
            type: "string",
            id: 1
          },
          finished: {
            type: "bool",
            id: 2
          },
          sendDate: {
            type: "uint64",
            id: 3
          },
          remark: {
            type: "string",
            id: 4
          },
          type: {
            type: "PBContractCirculationInfoType",
            id: 5
          }
        }
      },
      PBContract: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          userId: {
            type: "uint32",
            id: 2
          },
          contractNo: {
            type: "string",
            id: 3
          },
          createDate: {
            type: "uint64",
            id: 4
          },
          createAdmin: {
            type: "framework.PBAdmin",
            id: 5
          },
          updateDate: {
            type: "uint64",
            id: 6
          },
          modifyAdmin: {
            type: "framework.PBAdmin",
            id: 7
          },
          effectiveBeginDate: {
            type: "uint64",
            id: 8
          },
          effectiveEndDate: {
            type: "uint64",
            id: 9
          },
          extraUrls: {
            rule: "repeated",
            type: "string",
            id: 10
          },
          products: {
            rule: "repeated",
            type: "PBProduct",
            id: 11
          },
          status: {
            type: "PBContractStatus",
            id: 12
          },
          supplemental: {
            type: "bool",
            id: 13
          },
          latest: {
            type: "bool",
            id: 14
          },
          circulationStatus: {
            type: "PBContractCirculationStatus",
            id: 15
          },
          circulationInfos: {
            rule: "repeated",
            type: "PBContractCirculationInfo",
            id: 16
          },
          contractType: {
            type: "PBContractType",
            id: 17
          }
        }
      },
      PBCustomerDetail: {
        fields: {
          customer: {
            type: "PBCustomer",
            id: 1
          },
          configs: {
            rule: "repeated",
            type: "PBUserConfig",
            id: 2
          },
          sptInfo: {
            type: "PBCustomerDetailExpand",
            id: 3
          },
          egInfo: {
            type: "PBCustomerDetailExpand",
            id: 4
          },
          contracts: {
            rule: "repeated",
            type: "PBContract",
            id: 7
          },
          billInfo: {
            type: "PBBillInfo",
            id: 8
          },
          contacts: {
            rule: "repeated",
            type: "PBContact",
            id: 9
          },
          deliveryAddress: {
            type: "PBDeliveryAddress",
            id: 10
          },
          visitRecords: {
            rule: "repeated",
            type: "PBReturnVisitRecord",
            id: 11
          },
          newCustomer: {
            type: "bool",
            id: 12
          },
          auth: {
            type: "PBEnterpriseAuth",
            id: 13
          }
        }
      },
      PBCustomerDetailExpand: {
        fields: {
          cooperationDuration: {
            type: "string",
            id: 1
          },
          cooperationEnd: {
            type: "bool",
            id: 2
          },
          boughtProducts: {
            rule: "repeated",
            type: "PBUserProduct",
            id: 3
          },
          historyBoughtProducts: {
            rule: "repeated",
            type: "PBUserProduct",
            id: 4
          },
          trialProducts: {
            rule: "repeated",
            type: "PBUserProduct",
            id: 5
          },
          historyTrialProducts: {
            rule: "repeated",
            type: "PBUserProduct",
            id: 6
          }
        }
      },
      PBMixCustomer: {
        fields: {
          customerId: {
            type: "uint32",
            id: 1
          },
          userId: {
            type: "uint32",
            id: 2
          },
          name: {
            type: "string",
            id: 3
          },
          cooperationStatus: {
            type: "PBUserCooperationStatus",
            id: 4
          },
          cooperationDesc: {
            type: "string",
            id: 16
          },
          tryStatus: {
            type: "PBUserTryStatus",
            id: 15
          },
          tryDesc: {
            type: "string",
            id: 17
          },
          qq: {
            type: "string",
            id: 5
          },
          contracts: {
            rule: "repeated",
            type: "PBContract",
            id: 6
          },
          renewalFrequency: {
            rule: "repeated",
            type: "uint32",
            id: 7
          },
          invoiceType: {
            type: "int32",
            id: 8
          },
          transferType: {
            type: "int32",
            id: 9
          },
          configs: {
            rule: "repeated",
            type: "PBUserConfig",
            id: 11
          },
          historyTrialProducts: {
            keyType: "uint32",
            type: "PBUserProductList",
            id: 14
          },
          tester: {
            type: "bool",
            id: 13
          },
          sptExpand: {
            type: "PBMixCustomerExpand",
            id: 18
          },
          egExpand: {
            type: "PBMixCustomerExpand",
            id: 19
          },
          transfers: {
            rule: "repeated",
            type: "PBBillTransfer",
            id: 20
          },
          usedNames: {
            rule: "repeated",
            type: "string",
            id: 21
          },
          autoAuth: {
            type: "bool",
            id: 22
          },
          invitationCode: {
            type: "string",
            id: 23
          }
        }
      },
      PBMixCustomerExpand: {
        fields: {
          cooperationDuration: {
            type: "string",
            id: 1
          },
          cooperationEnd: {
            type: "bool",
            id: 2
          },
          boughtProducts: {
            keyType: "uint64",
            type: "PBUserProductList",
            id: 10
          }
        }
      },
      PBCooperationRecord: {
        fields: {
          serviceType: {
            type: "PBServiceType",
            id: 1
          },
          beginDate: {
            type: "uint64",
            id: 2
          },
          endDate: {
            type: "uint64",
            id: 3
          },
          cooperationDuration: {
            type: "string",
            id: 4
          },
          cooperationEnd: {
            type: "bool",
            id: 5
          },
          bugProduct: {
            type: "string",
            id: 6
          }
        }
      },
      PBGetUserContractListReq: {
        fields: {
          userId: {
            type: "uint32",
            id: 1
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBContractList: {
        fields: {
          contracts: {
            rule: "repeated",
            type: "PBContract",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBCustomerSearchKeyType: {
        values: {
          CUSTOMER_SEARCH_KEY_COMPANY_NAME: 0,
          CUSTOMER_SEARCH_KEY_USER_ID: 1
        }
      },
      PBCustomerSearchDateType: {
        values: {
          CUSTOMER_SEARCH_DATE_PRODUCT: 0,
          CUSTOMER_SEARCH_DATE_CONTRACT_BEGIN: 1,
          CUSTOMER_SEARCH_DATE_CONTRACT_END: 2
        }
      },
      PBSearchCustomerListReq: {
        fields: {
          searchKeyType: {
            type: "PBCustomerSearchKeyType",
            id: 1
          },
          searchKey: {
            type: "string",
            id: 2
          },
          searchDateType: {
            type: "PBCustomerSearchDateType",
            id: 3
          },
          beginDate: {
            type: "uint64",
            id: 4
          },
          endDate: {
            type: "uint64",
            id: 5
          },
          invoiceTypes: {
            rule: "repeated",
            type: "uint32",
            id: 6
          },
          cooperationStatuses: {
            rule: "repeated",
            type: "PBUserCooperationStatus",
            id: 7
          },
          agreementType: {
            type: "int32",
            id: 16
          },
          contractStatuses: {
            rule: "repeated",
            type: "PBContractStatus",
            id: 8
          },
          cirStatuses: {
            rule: "repeated",
            type: "PBContractCirculationStatus",
            id: 9
          },
          productTypes: {
            rule: "repeated",
            type: "PBProductType",
            id: 10
          },
          userType: {
            type: "PBSearchUserType",
            id: 12
          },
          trialProductType: {
            type: "string",
            id: 13
          },
          tryStatus: {
            type: "int32",
            id: 14
          },
          serviceType: {
            type: "int32",
            id: 15
          },
          page: {
            type: "framework.PBPagePara",
            id: 20
          }
        }
      },
      PBCustomerList: {
        fields: {
          customers: {
            rule: "repeated",
            type: "PBCustomer",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBMixCustomerList: {
        fields: {
          customers: {
            rule: "repeated",
            type: "PBMixCustomer",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBCooperationRecordList: {
        fields: {
          list: {
            rule: "repeated",
            type: "PBCooperationRecord",
            id: 1
          }
        }
      },
      PBFinanceResult: {
        fields: {
          finance: {
            type: "PBFinance",
            id: 1
          },
          invoice: {
            type: "PBInvoice",
            id: 2
          }
        }
      },
      PBFinanceResultList: {
        fields: {
          result: {
            rule: "repeated",
            type: "PBFinanceResult",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBFinanceType: {
        values: {
          FINANCE_TYPE_NEW_INCREASE: 0,
          FINANCE_TYPE_OLD_INCREASE: 1,
          FINANCE_TYPE_RENEWAL: 2
        }
      },
      PBArriveStatus: {
        values: {
          ARRIVE_STATUS_NOT_ARRIVED: 0,
          ARRIVE_STATUS_ARRIVED: 1,
          ARRIVE_STATUS_LOST: 2
        }
      },
      PBFinance: {
        fields: {
          id: {
            type: "uint64",
            id: 1
          },
          customer: {
            type: "PBCustomer",
            id: 2
          },
          createDate: {
            type: "uint64",
            id: 3
          },
          financeType: {
            type: "PBFinanceType",
            id: 4
          },
          totalIncome: {
            type: "uint64",
            id: 5
          },
          serviceType: {
            type: "PBServiceType",
            id: 6
          },
          arriveStatus: {
            type: "PBArriveStatus",
            id: 10
          },
          arriveDate: {
            type: "uint64",
            id: 11
          },
          invoiceId: {
            type: "uint64",
            id: 12
          },
          products: {
            rule: "repeated",
            type: "PBUserProduct",
            id: 13
          },
          contract: {
            type: "PBContract",
            id: 14
          },
          billInfo: {
            type: "PBBillInfo",
            id: 15
          },
          remark: {
            type: "string",
            id: 20
          },
          updateDate: {
            type: "uint64",
            id: 21
          },
          modifyAdmin: {
            type: "framework.PBAdmin",
            id: 22
          },
          charge: {
            type: "PBCharge",
            id: 23
          },
          productMap: {
            keyType: "uint64",
            type: "PBUserProductList",
            id: 100
          },
          renewal: {
            type: "PBRenewal",
            id: 101
          },
          account: {
            type: "PBReceiveAccount",
            id: 24
          }
        }
      },
      PBFinanceSortType: {
        values: {
          FINANCE_SORT_EFFECTIVE_DATE: 0,
          FINANCE_SORT_ARRIVE_DATE: 1,
          FINANCE_SORT_CONTRACT_DATE: 2
        }
      },
      PBSearchFinanceListReq: {
        fields: {
          sortType: {
            type: "PBFinanceSortType",
            id: 1
          },
          orderType: {
            type: "PBOrderType",
            id: 2
          },
          companyName: {
            type: "string",
            id: 3
          },
          financeTypes: {
            rule: "repeated",
            type: "PBFinanceType",
            id: 4
          },
          arriveStatuses: {
            rule: "repeated",
            type: "PBArriveStatus",
            id: 5
          },
          invoiceTypes: {
            rule: "repeated",
            type: "uint32",
            id: 6
          },
          invoiceStatuses: {
            rule: "repeated",
            type: "uint32",
            id: 7
          },
          hasContracts: {
            rule: "repeated",
            type: "bool",
            id: 8
          },
          beginDate: {
            type: "uint64",
            id: 9
          },
          endDate: {
            type: "uint64",
            id: 10
          },
          serviceType: {
            type: "PBServiceType",
            id: 11
          },
          accountId: {
            type: "int32",
            id: 14
          },
          extraStatuses: {
            rule: "repeated",
            type: "PBRenewalExtraStatus",
            id: 12
          },
          page: {
            type: "framework.PBPagePara",
            id: 20
          }
        }
      },
      PBFinanceList: {
        fields: {
          finances: {
            rule: "repeated",
            type: "PBFinance",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBFinanceProgress: {
        fields: {
          id: {
            type: "uint64",
            id: 1
          },
          renewIncomeItem: {
            type: "PBFinanceProgressItem",
            id: 2
          },
          renewItem: {
            type: "PBFinanceProgressItem",
            id: 3
          },
          incCustomerItem: {
            type: "PBFinanceProgressItem",
            id: 4
          },
          incIncomeItem: {
            type: "PBFinanceProgressItem",
            id: 5
          },
          totalIncomeItem: {
            type: "PBFinanceProgressItem",
            id: 6
          },
          date: {
            type: "uint64",
            id: 7
          },
          serviceType: {
            type: "PBServiceType",
            id: 8
          }
        }
      },
      PBFinanceProgressItem: {
        fields: {
          target: {
            type: "string",
            id: 1
          },
          targetSnapshot: {
            type: "string",
            id: 2
          },
          progress: {
            type: "uint64",
            id: 3
          },
          ratio: {
            type: "string",
            id: 4
          },
          remain: {
            type: "string",
            id: 5
          },
          lost: {
            type: "string",
            id: 6
          },
          preLost: {
            type: "string",
            id: 7
          }
        }
      },
      PBGetFinanceProgressReq: {
        fields: {
          date: {
            type: "uint64",
            id: 1
          },
          serviceType: {
            type: "PBServiceType",
            id: 2
          }
        }
      },
      PBRenewalStatus: {
        values: {
          RENEWAL_STATUS_TO_BE: 0,
          RENEWAL_STATUS_PENDING: 1,
          RENEWAL_STATUS_FAIL: 2,
          RENEWAL_STATUS_SUCCESS: 3
        }
      },
      PBRenewalInfo: {
        fields: {
          userProducts: {
            rule: "repeated",
            type: "PBUserProduct",
            id: 1
          },
          charge: {
            type: "PBCharge",
            id: 2
          },
          beforeEffectiveDate: {
            type: "uint64",
            id: 20
          },
          afterEffectiveDate: {
            type: "uint64",
            id: 21
          },
          lostPrice: {
            type: "uint64",
            id: 22
          }
        }
      },
      PBRenewal: {
        fields: {
          id: {
            type: "uint64",
            id: 1
          },
          createDate: {
            type: "uint64",
            id: 2
          },
          status: {
            type: "PBRenewalStatus",
            id: 3
          },
          customer: {
            type: "PBCustomer",
            id: 4
          },
          contact: {
            type: "PBContact",
            id: 5
          },
          voucher: {
            type: "PBRemittanceVoucher",
            id: 6
          },
          invoiceType: {
            type: "uint32",
            id: 7
          },
          billInfo: {
            type: "PBBillInfo",
            id: 8
          },
          serviceType: {
            type: "PBServiceType",
            id: 9
          },
          planInfo: {
            type: "PBRenewalInfo",
            id: 15
          },
          changeInfo: {
            type: "PBRenewalInfo",
            id: 16
          },
          actualInfo: {
            type: "PBRenewalInfo",
            id: 17
          },
          renewChange: {
            type: "bool",
            id: 18
          },
          preLost: {
            type: "bool",
            id: 19
          },
          isNumChange: {
            type: "bool",
            id: 20
          },
          reviewDate: {
            type: "uint64",
            id: 25
          },
          reviewAdmin: {
            type: "framework.PBAdmin",
            id: 26
          },
          remark: {
            type: "string",
            id: 30
          },
          remarkUpdateDate: {
            type: "uint64",
            id: 31
          },
          remarkModifyAdmin: {
            type: "framework.PBAdmin",
            id: 32
          },
          failType: {
            type: "PBRenewalFailType",
            id: 35
          },
          failReason: {
            type: "string",
            id: 36
          },
          nextRemindDate: {
            type: "uint64",
            id: 40
          },
          remindFrequency: {
            rule: "repeated",
            type: "uint32",
            id: 41
          },
          smsContent: {
            type: "string",
            id: 42
          },
          smsSendStatus: {
            type: "framework.PBBoolValue",
            id: 43
          },
          smsSendDate: {
            type: "uint64",
            id: 44
          },
          emailContent: {
            type: "string",
            id: 45
          },
          emailSendStatus: {
            type: "framework.PBBoolValue",
            id: 46
          },
          emailSendDate: {
            type: "uint64",
            id: 47
          },
          closed: {
            type: "bool",
            id: 50
          },
          taskDate: {
            type: "uint64",
            id: 51
          },
          churnId: {
            type: "int32",
            id: 52
          },
          delayApiTime: {
            type: "uint64",
            id: 53
          },
          account: {
            type: "PBReceiveAccount",
            id: 100
          },
          advanceRenew: {
            type: "framework.PBBoolValue",
            id: 102
          },
          delayRenew: {
            type: "framework.PBBoolValue",
            id: 103
          },
          batchIds: {
            rule: "repeated",
            type: "uint64",
            id: 54
          }
        }
      },
      PBRenewalFailType: {
        values: {
          RENEWAL_FAIL_VOUCHER_ERROR: 0,
          RENEWAL_FAIL_EXPIRED: 1,
          RENEWAL_FAIL_LOST: 2,
          RENEWAL_NOT: 3,
          RENEWAL_OTHER: 4
        }
      },
      PBRemittanceVoucher: {
        fields: {
          id: {
            type: "uint64",
            id: 1
          },
          userId: {
            type: "uint32",
            id: 2
          },
          renewalId: {
            type: "uint64",
            id: 3
          },
          instructions: {
            type: "string",
            id: 4
          },
          screenshot: {
            type: "string",
            id: 5
          },
          createDate: {
            type: "uint64",
            id: 6
          }
        }
      },
      PBRenewalExtraStatus: {
        values: {
          RENEW_NONE: 0,
          RENEW_DELAY: 1,
          RENEW_CHANGE: 2,
          RENEW_ADVANCE: 3,
          RENEW_PRE_LOST: 4,
          RENEW_PART_LOST: 5,
          RENEW_NUM_CHANGE: 6
        }
      },
      PBRenewSuccessReq: {
        fields: {
          renewalId: {
            type: "uint64",
            id: 1
          },
          remitterName: {
            type: "string",
            id: 2
          },
          arrivalDate: {
            type: "uint64",
            id: 5
          }
        }
      },
      PBRenewFailReq: {
        fields: {
          renewalId: {
            type: "uint64",
            id: 1
          },
          failType: {
            type: "PBRenewalFailType",
            id: 2
          },
          failReason: {
            type: "string",
            id: 3
          }
        }
      },
      PBRenewalSearchDateType: {
        values: {
          RENEWAL_SEARCH_DATE_ARRIVE: 0,
          RENEWAL_SEARCH_DATE_VOUCHER: 1,
          RENEWAL_SEARCH_DATE_REVIEW: 2,
          RENEWAL_SEARCH_DATE_EFFECTIVE_BEFORE: 3,
          RENEWAL_SEARCH_DATE_EFFECTIVE_AFTER: 4
        }
      },
      PBGetRenewalListReq: {
        fields: {
          status: {
            type: "int32",
            id: 1
          },
          dateType: {
            type: "PBRenewalSearchDateType",
            id: 2
          },
          beginDate: {
            type: "uint64",
            id: 3
          },
          endDate: {
            type: "uint64",
            id: 4
          },
          renewalBeginDate: {
            type: "uint64",
            id: 5
          },
          renewalEndDate: {
            type: "uint64",
            id: 6
          },
          name: {
            type: "string",
            id: 7
          },
          serviceType: {
            type: "PBServiceType",
            id: 8
          },
          closed: {
            type: "framework.PBBoolValue",
            id: 9
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBRenewalList: {
        fields: {
          renewals: {
            rule: "repeated",
            type: "PBRenewal",
            id: 1
          },
          customerCount: {
            type: "uint32",
            id: 2
          },
          totalPrice: {
            type: "uint64",
            id: 3
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 20
          }
        }
      },
      PBRenewalSendNotifyReq: {
        fields: {
          renewalId: {
            type: "uint64",
            id: 1
          },
          contacts: {
            rule: "repeated",
            type: "PBContact",
            id: 2
          }
        }
      },
      PBRenewalLoginReq: {
        fields: {
          renewalStr: {
            type: "string",
            id: 1
          },
          account: {
            type: "string",
            id: 2
          },
          validCode: {
            type: "string",
            id: 3
          }
        }
      },
      PBRenewalGetByTokenReq: {
        fields: {
          renewalStr: {
            type: "string",
            id: 1
          },
          userToken: {
            type: "string",
            id: 2
          },
          adminToken: {
            type: "string",
            id: 3
          }
        }
      },
      PBChangeRenewReq: {
        fields: {
          renewalId: {
            type: "uint64",
            id: 1
          },
          changeInfo: {
            type: "PBRenewalInfo",
            id: 2
          },
          isNumChange: {
            type: "bool",
            id: 3
          }
        }
      },
      PBModifyPreLostReq: {
        fields: {
          renewalId: {
            type: "uint64",
            id: 1
          },
          preLost: {
            type: "bool",
            id: 2
          }
        }
      },
      PBGetOwnerRenewalListReq: {
        fields: {
          process: {
            type: "bool",
            id: 1
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBCloseRenewReq: {
        fields: {
          renewalId: {
            type: "uint64",
            id: 1
          },
          churn: {
            type: "bool",
            id: 2
          }
        }
      },
      PBDelayApiTimeReq: {
        fields: {
          renewalId: {
            type: "uint64",
            id: 1
          },
          delayApiTime: {
            type: "uint64",
            id: 2
          }
        }
      },
      PBRemittanceVoucherReq: {
        fields: {
          renewalId: {
            rule: "repeated",
            type: "uint64",
            id: 1
          },
          voucher: {
            type: "PBRemittanceVoucher",
            id: 2
          }
        }
      },
      PBInvoiceStatus: {
        values: {
          INVOICE_STATUS_PRE_APPLY: 0,
          INVOICE_STATUS_PENDING: 1,
          INVOICE_STATUS_BUSINESS_FOLLOW: 2,
          INVOICE_STATUS_TO_OPEN: 3,
          INVOICE_STATUS_OPENED: 4,
          INVOICE_STATUS_SENT: 5,
          INVOICE_STATUS_SIGNED: 6,
          INVOICE_STATUS_REJECT: 7
        }
      },
      PBInvoicePendingType: {
        values: {
          INVOICE_PENDING_BUSINESS: 0,
          INVOICE_PENDING_DIRECTOR: 1,
          INVOICE_PENDING_FINANCE: 2
        }
      },
      PBInvoiceDealType: {
        values: {
          INVOICE_DEAL_NONE: 0,
          INVOICE_DEAL_AGREE: 1,
          INVOICE_DEAL_TURN_BD: 2,
          INVOICE_DEAL_REAPPLY: 3,
          INVOICE_DEAL_REJECT: 4
        }
      },
      PBInvoice: {
        fields: {
          id: {
            type: "uint64",
            id: 1
          },
          userId: {
            type: "uint32",
            id: 2
          },
          invoiceType: {
            type: "PBInvoiceType",
            id: 3
          },
          status: {
            type: "PBInvoiceStatus",
            id: 4
          },
          pendingType: {
            type: "PBInvoicePendingType",
            id: 5
          },
          applyDate: {
            type: "uint64",
            id: 7
          },
          price: {
            type: "uint64",
            id: 8
          },
          finance: {
            type: "PBFinance",
            id: 9
          },
          billInfo: {
            type: "PBBillInfo",
            id: 10
          },
          openDate: {
            type: "uint64",
            id: 11
          },
          delivery: {
            type: "PBDelivery",
            id: 12
          },
          systemApply: {
            type: "bool",
            id: 13
          },
          deliveryAddress: {
            type: "PBDeliveryAddress",
            id: 14
          },
          pendingDate: {
            type: "uint64",
            id: 20
          },
          pendingAdmin: {
            type: "framework.PBAdmin",
            id: 21
          },
          adminUpdateDate: {
            type: "uint64",
            id: 22
          },
          modifyAdmin: {
            type: "framework.PBAdmin",
            id: 23
          },
          adminRemark: {
            type: "string",
            id: 24
          },
          events: {
            rule: "repeated",
            type: "PBInvoiceEvent",
            id: 100
          }
        }
      },
      PBInvoiceEventType: {
        values: {
          INVOICE_EVENT_APPLY: 0,
          INVOICE_EVENT_BUSINESS_PENDING: 1,
          INVOICE_EVENT_DIRECTOR_PENDING: 2,
          INVOICE_EVENT_FINANCE_PENDING: 3,
          INVOICE_EVENT_FLOW: 4,
          INVOICE_EVENT_OPENED: 5,
          INVOICE_EVENT_SENT: 6,
          INVOICE_EVENT_SIGNED: 7
        }
      },
      PBInvoiceEvent: {
        fields: {
          id: {
            type: "uint64",
            id: 1
          },
          invoiceId: {
            type: "uint64",
            id: 2
          },
          eventType: {
            type: "PBInvoiceEventType",
            id: 3
          },
          desc: {
            type: "string",
            id: 4
          },
          remark: {
            type: "string",
            id: 5
          },
          admin: {
            type: "framework.PBAdmin",
            id: 6
          },
          createDate: {
            type: "uint64",
            id: 7
          }
        }
      },
      PBSearchInvoiceListReq: {
        fields: {
          status: {
            type: "PBInvoiceStatus",
            id: 1
          },
          pendingType: {
            type: "PBInvoicePendingType",
            id: 2
          },
          openBeginDate: {
            type: "uint64",
            id: 3
          },
          openEndDate: {
            type: "uint64",
            id: 4
          },
          taxpayerName: {
            type: "string",
            id: 5
          },
          invoiceTypeList: {
            rule: "repeated",
            type: "PBInvoiceType",
            id: 6
          },
          deliveryStatusList: {
            rule: "repeated",
            type: "PBDeliveryStatus",
            id: 7
          },
          userId: {
            type: "uint32",
            id: 8
          },
          accountId: {
            type: "uint32",
            id: 9
          },
          page: {
            type: "framework.PBPagePara",
            id: 20
          }
        }
      },
      PBInvoiceEventList: {
        fields: {
          records: {
            rule: "repeated",
            type: "PBInvoiceEvent",
            id: 1
          }
        }
      },
      PBInvoiceList: {
        fields: {
          invoices: {
            rule: "repeated",
            type: "PBInvoice",
            id: 1
          },
          pendingCount: {
            type: "uint32",
            id: 2
          },
          flowCount: {
            type: "uint32",
            id: 3
          },
          preApplyCount: {
            type: "uint32",
            id: 4
          },
          toOpenCount: {
            type: "uint32",
            id: 5
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBFillDeliveryReq: {
        fields: {
          invoiceId: {
            type: "uint64",
            id: 1
          },
          deliveryCompany: {
            type: "PBDeliveryCompanyType",
            id: 2
          },
          deliveryNo: {
            type: "string",
            id: 3
          }
        }
      },
      PBInvoiceAuditReq: {
        fields: {
          invoiceId: {
            type: "uint64",
            id: 1
          },
          pendingType: {
            type: "PBInvoicePendingType",
            id: 2
          },
          dealType: {
            type: "PBInvoiceDealType",
            id: 3
          },
          remark: {
            type: "string",
            id: 4
          }
        }
      },
      PBInvoiceBatchAgreeReq: {
        fields: {
          invoiceIds: {
            rule: "repeated",
            type: "uint64",
            id: 1
          },
          pendingType: {
            type: "PBInvoicePendingType",
            id: 2
          }
        }
      },
      PBInvoiceFollowReq: {
        fields: {
          invoiceId: {
            type: "uint64",
            id: 1
          },
          dealType: {
            type: "PBInvoiceDealType",
            id: 2
          },
          remark: {
            type: "string",
            id: 3
          }
        }
      },
      PBMixInvoice: {
        fields: {
          userId: {
            type: "uint32",
            id: 1
          },
          invoice: {
            type: "PBInvoice",
            id: 2
          },
          preOpenInvoice: {
            type: "PBInvoice",
            id: 3
          },
          deliveryAddress: {
            type: "PBDeliveryAddress",
            id: 4
          }
        }
      },
      PBMixInvoiceList: {
        fields: {
          invoices: {
            rule: "repeated",
            type: "PBMixInvoice",
            id: 1
          },
          pendingCount: {
            type: "uint32",
            id: 2
          },
          bsPendingCount: {
            type: "uint32",
            id: 3
          },
          dcPendingCount: {
            type: "uint32",
            id: 4
          },
          fsPendingCount: {
            type: "uint32",
            id: 5
          },
          followCount: {
            type: "uint32",
            id: 6
          },
          preApplyCount: {
            type: "uint32",
            id: 7
          },
          toOpenCount: {
            type: "uint32",
            id: 8
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBDeliveryCompanyType: {
        values: {
          DELIVERT_COMPANY_SF: 0
        }
      },
      PBDeliveryStatus: {
        values: {
          DELIVERY_STATUS_NULL: 0,
          DELIVERY_STATUS_SENT: 1,
          DELIVERY_STATUS_SIGNED: 2
        }
      },
      PBDelivery: {
        fields: {
          id: {
            type: "uint64",
            id: 1
          },
          status: {
            type: "PBDeliveryStatus",
            id: 2
          },
          deliveryCompany: {
            type: "PBDeliveryCompanyType",
            id: 3
          },
          deliveryNo: {
            type: "string",
            id: 4
          },
          info: {
            rule: "repeated",
            type: "PBDeliveryRoute",
            id: 5
          }
        }
      },
      PBDeliveryRoute: {
        fields: {
          acceptAddress: {
            type: "string",
            id: 1
          },
          acceptTime: {
            type: "uint64",
            id: 2
          },
          remark: {
            type: "string",
            id: 3
          },
          opcode: {
            type: "uint32",
            id: 4
          }
        }
      },
      PBContent: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          type: {
            type: "PBContentType",
            id: 2
          },
          title: {
            type: "string",
            id: 3
          },
          content: {
            type: "string",
            id: 4
          },
          visible: {
            type: "bool",
            id: 5
          }
        }
      },
      PBContentType: {
        values: {
          CT_FAQ: 0,
          CT_ABOUT: 1,
          CT_DISCLAIMER: 2
        }
      },
      PBArticleType: {
        fields: {
          typeId: {
            type: "uint32",
            id: 1
          },
          typeName: {
            type: "string",
            id: 2
          },
          platform: {
            type: "PBPlatformType",
            id: 3
          },
          childType: {
            rule: "repeated",
            type: "PBArticleChildType",
            id: 4
          },
          maxSortNumber: {
            type: "uint32",
            id: 5
          }
        }
      },
      PBArticleChildType: {
        fields: {
          childTypeId: {
            type: "uint32",
            id: 1
          },
          childTypeName: {
            type: "string",
            id: 2
          },
          maxSortNumber: {
            type: "uint32",
            id: 3
          }
        }
      },
      PBArticleStatus: {
        values: {
          SHOW: 0,
          HIDE: 1
        }
      },
      PBArticle: {
        fields: {
          articleId: {
            type: "uint32",
            id: 1
          },
          title: {
            type: "string",
            id: 2
          },
          content: {
            type: "string",
            id: 3
          },
          articleType: {
            type: "PBArticleType",
            id: 4
          },
          articleChildType: {
            type: "PBArticleChildType",
            id: 5
          },
          keywords: {
            type: "string",
            id: 6
          },
          description: {
            type: "string",
            id: 7
          },
          coverImage: {
            type: "string",
            id: 8
          },
          status: {
            type: "PBArticleStatus",
            id: 9
          },
          updateDate: {
            type: "uint64",
            id: 10
          },
          readNum: {
            type: "uint32",
            id: 11
          },
          sortNumber: {
            type: "uint32",
            id: 12
          },
          modifyAdmin: {
            type: "framework.PBAdmin",
            id: 13
          }
        }
      },
      PBArticleInquireReq: {
        fields: {
          articleId: {
            type: "uint32",
            id: 1
          },
          title: {
            type: "string",
            id: 2
          },
          platform: {
            type: "PBPlatformType",
            id: 3
          },
          typeId: {
            type: "uint32",
            id: 4
          },
          childTypeId: {
            type: "uint32",
            id: 5
          },
          status: {
            type: "int32",
            id: 6
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBArticleByTypeReq: {
        fields: {
          typeId: {
            type: "uint32",
            id: 1
          },
          childTypeId: {
            type: "uint32",
            id: 2
          },
          articleId: {
            type: "uint32",
            id: 3
          },
          updateDate: {
            type: "uint64",
            id: 4
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBArticleList: {
        fields: {
          articleList: {
            rule: "repeated",
            type: "PBArticle",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 2
          }
        }
      },
      PBArticleAndTypeList: {
        fields: {
          childTypeList: {
            rule: "repeated",
            type: "PBArticleChildType",
            id: 1
          },
          articleList: {
            rule: "repeated",
            type: "PBArticle",
            id: 2
          }
        }
      },
      PBArticleTypeList: {
        fields: {
          typeList: {
            rule: "repeated",
            type: "PBArticleType",
            id: 1
          }
        }
      },
      PBFwBasicConfig: {
        fields: {
          disclaimerUrl: {
            type: "string",
            id: 1
          },
          aboutUrl: {
            type: "string",
            id: 2
          },
          faqUrl: {
            type: "string",
            id: 3
          }
        }
      },
      PBFwError: {
        values: {
          FW_ERROR_SUCCESS: 0,
          FW_ERROR_UNKNOWN: 1,
          FW_NOT_FOUND: 2,
          ADMIN_ROLE_ERROR: 10,
          INCORRECT_VALID_CODE: 1000,
          BAD_REQUEST: 10008,
          CONTENT_NOT_FOUND: 2000,
          SMS_SEND_ERROR: 3000,
          EMAIL_SEND_ERROR: 3001,
          SMS_IP_LIMIT: 3002,
          USER_MOBILE_EXISTS: 10000,
          USER_EMAIL_EXISTS: 10001,
          USER_NOT_FOUND: 10002,
          USER_PASSWORD_ERROR: 10003,
          USER_LOCKED: 10004,
          USER_LOST_ERROR: 10005,
          USER_COOPERATION_STATUS_MODIFY_ERROR: 10006,
          USER_REGISTER_INVITATION_CODE_NOT_EXIST: 10007,
          USER_BUSINESS_CONTACT_NOT_FOUND: 11000,
          USER_BUSINESS_CONTACT_HAS_PROCESSED: 11001,
          USER_BUSINESS_CONTACT_EXISTS: 11002,
          USER_ENTERPRISE_AUTH_NOT_FOUND: 12000,
          USER_ENTERPRISE_AUTH_NO_PASS: 12001,
          USER_ENTERPRISE_AUTH_EXISTS: 12002,
          USER_ENTERPRISE_AUTH_MODIFY_ERROR: 12003,
          USER_ENTERPRISE_AUTH_CONTACT_NOT_FOUND: 12004,
          USER_ENTERPRISE_AUTH_PENDING: 12005,
          USER_IP_CONFIG_ERROR: 13000,
          USER_IP_CONFIG_NO_AUTH: 13001,
          USER_IP_CONFIG_NOT_FOUND: 13002,
          USER_IP_CONFIG_INC_COUNT_ERROR: 13003,
          USER_PRODUCT_NOT_FOUND: 14000,
          USER_PRODUCT_RENEW_ERROR: 14001,
          USER_PRODUCT_RE_PURCHASE_ERROR: 14002,
          USER_PRODUCT_UPDATE_ERROR: 14003,
          USER_PRODUCT_ADD_ERROR: 14004,
          USER_PRODUCT_MODIFY_TO_BE_ERROR: 14005,
          USER_PRODUCT_UNIT_TYPE_ERROR: 14006,
          USER_PURCHASE_INTENTION_UN_PROCESS_NOT_FOUND: 15000,
          USER_PURCHASE_INTENTION_COMMIT_ERROR: 15001,
          USER_PURCHASE_INTENTION_NOT_FOUND: 15002,
          USER_PURCHASE_INTENTION_PROCESS_ERROR: 15003,
          USER_LOG_NOT_FOUND: 16000,
          BUSINESS_CASE_NOT_FOUND: 20000,
          PRODUCT_NOT_FOUND: 30000,
          PRODUCT_ORDER_UN_UNIQUE: 30001,
          PRODUCT_TRY_TIME_LIMIT: 30002,
          PRODUCT_TRY_IN_TRIAL_ERROR: 30003,
          PRODUCT_TRY_PURCHASE_ERROR: 30004,
          PRODUCT_IS_VIRTUAL: 30005,
          PRODUCT_EMPTY_MAIN_POINT: 30006,
          PRODUCT_EMPTY_TKD: 30007,
          API_DOCUMENT_LIST_NO_AUTH: 40000,
          API_DOCUMENT_LIST_ERROR: 40001,
          API_DOCUMENT_SHARE_EXPIRED: 40002,
          API_DOCUMENT_NOT_FOUND: 40003,
          API_DOCUMENT_API_EXPIRED: 40004,
          API_INTERFACE_DESC_NOT_FOUND: 40005,
          API_DOCUMENT_TOKEN_NOT_FOUND: 40006,
          CUSTOMER_NOT_FOUND: 100000,
          CUSTOMER_CONTRACT_NOT_FOUND: 100010,
          CUSTOMER_BILL_NOT_FOUND: 100020,
          CUSTOMER_CONTACT_NOT_FOUND: 100030,
          CUSTOMER_DELIVERY_ADDRESS_NOT_FOUND: 100040,
          CUSTOMER_DELIVERY_ADDRESS_SUPPLY: 100041,
          CUSTOMER_RETURN_VISIT_RECORD_NOT_FOUND: 100050,
          CUSTOMER_BILL_INFO_MODIFY_ERROR: 100051,
          CUSTOMER_BILL_INFO_CANCEL_ERROR: 100052,
          CUSTOMER_BILL_INFO_CHECK_ERROR: 100053,
          CUSTOMER_BILL_INFO_MODIFY_EMAIL_ERROR: 100054,
          CUSTOMER_BILL_INFO_RESUBMIT_ERROR: 100055,
          CUSTOMER_BILL_INFO_NO_COMMIT: 100056,
          CUSTOMER_BILL_INFO_MODIFY_PENDING_ERROR: 100057,
          CUSTOMER_BILL_INFO_EXISTS: 100058,
          CUSTOMER_BILL_INFO_BG_MODIFY_ERROR: 100059,
          RENEWAL_NOT_FOUND: 110000,
          RENEWAL_SUBMIT_VOUCHER_ERROR: 110001,
          RENEWAL_STATUS_ERROR: 110002,
          RENEWAL_SEND_NOTIFY_ERROR: 110003,
          RENEWAL_FAIL_EXPIRED_ERROR: 110004,
          RENEWAL_UNCLOSED: 110005,
          RENEWAL_CLOSED: 110006,
          RENEWAL_CLOSE_ERROR: 110007,
          RENEWAL_VERIFY_ERROR: 110008,
          RENEWAL_VOUCHER_NOT_FOUND: 110009,
          FINANCE_NOT_FOUND: 120000,
          FINANCE_UPDATE_TARGET_ERROR: 120001,
          LINK_NOT_FOUND: 140000,
          INVOICE_NOT_FOUND: 150000,
          INVOICE_PENDING_CHECK_ERROR: 150001,
          INVOICE_PENDING_STAUTUS_ERROR: 150002,
          INVOICE_PENDING_AMDIN_ROLE_ERROR: 150003,
          INVOICE_PENDING_TYPE_ERROR: 150004,
          INVOICE_DEAL_TYPE_ERROR: 150005,
          INVOICE_FOLLOW_STATUS_ERROR: 150006,
          INVOICE_FOLLOW_AMDIN_ROLE_ERROR: 150007,
          INVOICE_TO_OPEN_STATUS_ERROR: 150008,
          INVOICE_DELIVERY_NOT_FOUND: 150009,
          INVOICE_NOT_PAPER_ERROR: 150010,
          INVOICE_PRIVATE_TRANSFER_CAN_NOT_APPLY: 150011,
          INVOICE_CAN_NOT_APPLY: 150012,
          INVOICE_NOT_OPENED_ERROR: 150013,
          ARTICLE_NOT_FOUNT: 160000,
          FAILURE_RECORD_NOT_FOUND: 170000,
          FAILURE_RECORD_SYSTEM_ID_IS_NULL: 170001,
          FAILURE_RECORD_PROCESS_ERROR: 170002,
          FAILURE_RECORD_NOT_FIXED: 170003,
          NAME_KEY_MAPPING_NOT_FOUND: 170020,
          AUTH_ACCESS_KEY_INVALID: 171000,
          AUTH_PRODUCT_NOT_PERMITTED: 171001,
          AUTH_INVALID: 171002,
          AUTH_TIMESTAMP_INVALID: 171003,
          AUTH_HOST_INVALID: 171004,
          AUTH_NUMBER_OUT_LIMIT: 171005,
          AUTH_PARAM_FORMAT: 171006,
          ADVISORY_EXIST_PENDING: 172000,
          LIVE_SOURCE_NAME_DUPLICATED: 173000
        }
      },
      PBLink: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          webName: {
            type: "string",
            id: 2
          },
          url: {
            type: "string",
            id: 3
          },
          order: {
            type: "uint32",
            id: 4
          },
          updateDate: {
            type: "uint64",
            id: 5
          },
          modifyAdmin: {
            type: "framework.PBAdmin",
            id: 6
          },
          platform: {
            type: "PBPlatformType",
            id: 7
          },
          createDate: {
            type: "uint64",
            id: 8
          }
        }
      },
      PBGetLinksReq: {
        fields: {
          platform: {
            type: "int32",
            id: 1
          },
          orderType: {
            type: "PBOrderType",
            id: 2
          }
        }
      },
      PBLinkList: {
        fields: {
          links: {
            rule: "repeated",
            type: "PBLink",
            id: 1
          }
        }
      },
      PBFwMessageType: {
        values: {
          DEFAULT_TYPE: 0,
          USER_SEND_MOBILE_VALID_CODE: 10000,
          USER_SEND_EMAIL_VALID_CODE: 10001,
          USER_MOBILE_REGISTER: 10005,
          USER_EMAIL_REGISTER: 10006,
          USER_LOGIN: 10007,
          USER_MOBILE_RESET_PASSWORD: 10008,
          USER_EMAIL_RESET_PASSWORD: 10009,
          USER_ADD_REMARK_BG: 10010,
          USER_BIND_MOBILE: 10011,
          USER_BIND_EMAIL: 10012,
          USER_VALID_PASSWORD: 10013,
          USER_LOG_LIST: 10014,
          USER_LOGOUT: 10015,
          USER_GET_BY_ID: 10016,
          USER_LIST_SEARCH: 10017,
          USER_MOBILE_IS_EXISTS: 10018,
          USER_EMAIL_IS_EXISTS: 10019,
          USER_GET_BY_ID_BG: 10020,
          USER_MODIFY_SOURCE_BG: 10021,
          USER_MODIFY_LOCKED_BG: 10022,
          USER_REPLACE_MOBILE: 10023,
          USER_REPLACE_EMAIL: 10024,
          USER_LOGIN_BY_VALID_CODE: 10025,
          USER_UPDATE_TESTER_BG: 10026,
          USER_KEY_RESET: 10027,
          USER_MOBILE_REGISTER_AND_AUTH: 10028,
          USER_EMAIL_REGISTER_AND_AUTH: 10029,
          USER_LOGIN_RECORD_SEARCH_BG: 10030,
          USER_LOGIN_RECORD_IP_DOUBT: 10031,
          USER_EXISTS_DOUBT_IP: 10032,
          USER_IS_IP_DOUBT: 10033,
          USER_LIST_BY_IP_BG: 10034,
          USER_PURCHASE_INTENTION_GET: 11100,
          USER_PURCHASE_INTENTION_COMMIT: 11101,
          USER_PURCHASE_INTENTION_USER_LIST_BG: 11103,
          USER_PURCHASE_INTENTION_UPDATE_REMARK_BG: 11104,
          USER_PURCHASE_INTENTION_USER_LIST: 11105,
          USER_PURCHASE_INTENTION_LIST_BG: 11106,
          USER_PURCHASE_INTENTION_UNPROCESS_COUNT: 11107,
          USER_PURCHASE_INTENTION_MODIFY_STATUS_BG: 11108,
          USER_ENTERPRISE_AUTH_ADD: 12000,
          USER_ENTERPRISE_AUTH_ADD_REMARK_BG: 12001,
          USER_ENTERPRISE_AUTH_UPDATE_STATUS_BG: 12002,
          USER_ENTERPRISE_AUTH_GET_BY_USER_ID: 12003,
          USER_ENTERPRISE_AUTH_LIST_BG: 12004,
          USER_ENTERPRISE_AUTH_MODIFY: 12005,
          USER_ENTERPRISE_AUTH_GET: 12006,
          USER_ENTERPRISE_AUTH_UNCHECK_COUNT: 12007,
          USER_ENTERPRISE_AUTH_SAVE_LICENSES_BG: 12008,
          USER_PRODUCT_TRY: 13000,
          USER_PRODUCT_LIST_BG: 13003,
          USER_PRODUCT_PURCHASE_LIST: 13004,
          USER_PRODUCT_RENEW_BG: 13005,
          USER_PRODUCT_UPDATE_BG: 13006,
          USER_PRODUCT_REPURCHASE_BG: 13007,
          USER_PRODUCT_IS_CAN_TRY: 13008,
          USER_PRODUCT_MODIFY_TRIAL_EFFECTIVE_BG: 13009,
          USER_PRODUCT_DELETE_TRIAL_PRODUCT_BG: 13010,
          USER_PRODUCT_BATCH_ADD_TRIAL_PRODUCT_BG: 13011,
          USER_PRODUCT_PURCHASE_AND_TRIAL_LIST: 13012,
          USER_PRODUCT_TRIAL_COUNT: 13013,
          USER_PRODUCT_HISTORY_BOUGHT_LIST: 13014,
          USER_PRODUCT_HISTORY_TRIAL_LIST: 13015,
          USER_PRODUCT_HISTORY_BOUGHT_COUNT: 13016,
          USER_PRODUCT_HISTORY_TRIAL_COUNT: 13017,
          USER_PRODUCT_BATCH_RENEW_BG: 13018,
          USER_PRODUCT_IS_CAN_BUY: 13019,
          USER_PRODUCT_PRODUCT_LIST_BG: 13020,
          USER_PRODUCT_GET_DOC_FORMAT: 13021,
          USER_PRODUCT_SET_DOC_FORMAT: 13022,
          USER_CONFIG_MODIFY: 14000,
          USER_CONFIG_LIST_BG: 14002,
          USER_CONFIG_INC_COUNT_BG: 14003,
          USER_CONFIG_MODIFY_BG: 14004,
          USER_CONFIG_HANDLE_PENDING_BG: 14005,
          USER_CONFIG_ADD_REMARK: 14006,
          USER_CONFIG_GET_BY_USER_ID_BG: 14007,
          USER_CONFIG_LIST_UNPROCESS_COUNT: 14008,
          USER_CONFIG_CHECK: 14010,
          USER_CONFIG_GET: 14011,
          USER_CONFIG_DELETE: 14012,
          ANIMATION_MATERIAL_LIST: 14100,
          ANIMATION_CONFIG_UPDATE_BY_USER_ID: 14101,
          ANIMATION_CONFIG_GET_BY_USER_ID: 14102,
          BUSINESS_CASE_ADD_BG: 30000,
          BUSINESS_CASE_UPDATE_BG: 30001,
          BUSINESS_CASE_UPDATE_VISIBLE_BG: 30002,
          BUSINESS_CASE_UPDATE_ORDER_BG: 30003,
          BUSINESS_CASE_SEARCH_BG: 30004,
          BUSINESS_CASE_LIST: 30005,
          BUSINESS_CASE_GET_BY_ID: 30006,
          BUSINESS_CASE_DELETE_BG: 30007,
          PRODUCT_CATEGORY_LIST: 40000,
          PRODUCT_CATEGORY_LIST_BG: 40002,
          PRODUCT_LIST_GET_BY_CATEGORY: 40003,
          PRODUCT_SEARCH_BG: 40004,
          PRODUCT_UPDATE_ORDER_BG: 40005,
          PRODUCT_UPDATE_VISIBLE_BG: 40006,
          PRODUCT_DELETE_BG: 40007,
          PRODUCT_ADD_BG: 40008,
          PRODUCT_UPDATE_BG: 40009,
          PRODUCT_MAIN_POINT_ADD_BG: 40014,
          PRODUCT_MAIN_POINT_UPDATE_BG: 40015,
          PRODUCT_MAIN_POINT_DELETE_BG: 40016,
          PRODUCT_LIST: 40010,
          PRODUCT_GET_BY_ID: 40011,
          PRODUCT_GET_BY_ID_BG: 40012,
          PRODUCT_CATEGORY_UPDATE_VISIBLE: 40013,
          PRODUCT_CONFIG_LIST: 40017,
          PRODUCT_CONFIG_TRY_SET: 40018,
          PRODUCT_CONFIG_BUY_SET: 40019,
          PRODUCT_CONFIG_DESC_UPDATE: 40020,
          PRODUCT_UPDATE_GUIDANCE_ORDER_BG: 40021,
          PRODUCT_MULTI_UPDATE_ORDER_BG: 40022,
          PRODUCT_MULTI_UPDATE_GUIDANCE_ORDER_BG: 40023,
          PRODUCT_TKD_UPDATE_BG: 40024,
          API_DOCUMENT_LIST: 50000,
          API_DOCUMENT_LIST_SHARE: 50001,
          API_DOCUMENT_REQUEST: 50002,
          API_DOCUMENT_LIST_BG: 50003,
          API_DOCUMENT_INTERFACE_ADD: 50004,
          API_DOCUMENT_INTERFACE_MODIFY: 50005,
          API_DOCUMENT_INTERFACE_MODIFY_FILE: 500016,
          API_DOCUMENT_INTERFACE_MODIFY_ORDER_LIST: 50006,
          API_DOCUMENT_INTERFACE_BIND_CATEGORY: 50007,
          API_DOCUMENT_INTERFACE_CHANGE_LOG_LIST: 50008,
          API_DOCUMENT_INTERFACE_DEPRECATED: 50009,
          API_DOCUMENT_INTERFACE_CHANGE_LOG_ADD: 500010,
          API_DOCUMENT_INTERFACE_CATEGORY_ADD: 500011,
          API_DOCUMENT_INTERFACE_CATEGORY_LIST: 500012,
          API_DOCUMENT_INTERFACE_CATEGORY_MODIFY_ORDER: 500013,
          API_DOCUMENT_INTERFACE_CATEGORY_MODIFY_NAME: 500014,
          API_DOCUMENT_INTERFACE_CATEGORY_LIST_BY_DOCID: 500015,
          API_DOCUMENT_DESC_RELATED_LIST: 500017,
          USER_STATISTICS_SEARCH: 60000,
          USER_STATISTICS_EXPORT_EXCEL: 60001,
          SPORTS_FLOW_STATISTICS_SEARCH: 60002,
          ESPORTS_FLOW_STATISTICS_SEARCH: 60003,
          CUSTOMER_DETAIL: 100000,
          CUSTOMER_UPDATE_INFO: 100001,
          CUSTOMER_SEARCH: 100002,
          CUSTOMER_PRODUCT_BATCH_ADD_BG: 100003,
          CUSTOMER_GET_BY_ID: 100004,
          CUSTOMER_GET_RECORD_BY_ID: 100005,
          ADVISORY_ADD: 101000,
          ADVISORY_SEARCH: 101001,
          ADVISORY_UPDATE_STATUS: 101002,
          ADVISORY_UPDATE_REMARK: 101003,
          ADVISORY_GET_BY_USER_ID: 101004,
          ADVISORY_GET_NUM: 101005,
          ADVISORY_GET_NUM_BY_USER_ID: 101006,
          CUSTOMER_CONTRACT_GET_BY_ID: 100010,
          CUSTOMER_CONTRACT_LIST: 100011,
          CUSTOMER_CONTRACT_ADD: 100012,
          CUSTOMER_CONTRACT_MODIFY: 100013,
          CUSTOMER_CONTRACT_DELETE: 100014,
          CUSTOMER_CONTRACT_MODIFY_CIRCULATION: 100015,
          CUSTOMER_CONTRACT_GET_LATEST: 100016,
          CUSTOMER_BILL_GET_BY_ID: 100020,
          CUSTOMER_BILL_GET_BY_USER_ID: 100021,
          CUSTOMER_BILL_GET: 100022,
          CUSTOMER_BILL_MODIFY_BG: 100023,
          CUSTOMER_BILL_SUBMIT: 100024,
          CUSTOMER_BILL_MODIFY_EMAIL: 100025,
          CUSTOMER_BILL_SEARCH: 100026,
          CUSTOMER_BILL_CHECK: 100027,
          CUSTOMER_BILL_MODIFY: 100028,
          CUSTOMER_BILL_UPDATE_REMARK: 100029,
          CUSTOMER_BILL_INFO_CANCEL_MODIFY: 100030,
          CUSTOMER_BILL_INFO_ADD_BG: 100031,
          CUSTOMER_BILL_INFO_PENDING_COUNT: 100032,
          CUSTOMER_BILL_CANCEL_IGNORE: 100033,
          CUSTOMER_BILL_SUBMIT_BG: 100034,
          CUSTOMER_BILL_TRANSFER_LIST: 100035,
          INVOICE_LIST: 150000,
          INVOICE_APPLY: 150001,
          INVOICE_AUDIT: 150002,
          INVOICE_BATCH_AGREE_AUDIT: 150003,
          INVOICE_FOLLOW: 150004,
          INVOICE_UPDATE_OPENED: 150005,
          INVOICE_BATCH_UPDATE_OPENED: 150006,
          INVOICE_GET_TO_OPEN_STATISTICS: 150007,
          INVOICE_UPDATE_DELIVERY: 150008,
          INVOICE_LIST_SEARCH: 150009,
          INVOICE_EVENT_LIST: 150010,
          INVOICE_DELIVERY_GET: 1500011,
          INVOICE_GET_BY_ID: 1500012,
          INVOICE_NO_APPLY_LIST: 1500013,
          INVOICE_PENDING_COUNT: 1500014,
          INVOICE_NOTIFY_ADMIN: 1500015,
          CUSTOMER_CONTACT_GET_BY_ID: 100100,
          CUSTOMER_CONTACT_LIST: 100101,
          CUSTOMER_CONTACT_ADD: 100102,
          CUSTOMER_CONTACT_MODIFY: 100103,
          CUSTOMER_CONTACT_DELETE: 100104,
          CUSTOMER_CONTACT_SET_PRIMARY: 100105,
          CUSTOMER_CONTACT_GET_PRIMARY: 100106,
          CUSTOMER_DELIVERY_ADDRESS_GET_BY_ID: 100200,
          CUSTOMER_DELIVERY_ADDRESS_UPDATE_BG: 100201,
          CUSTOMER_DELIVERY_ADDRESS_UPDATE: 100203,
          CUSTOMER_DELIVERY_ADDRESS_GET: 100204,
          CUSTOMER_RETURN_VISIT_RECORD_LIST: 100300,
          CUSTOMER_RETURN_VISIT_RECORD_GET_BY_ID: 100301,
          CUSTOMER_RETURN_VISIT_RECORD_UPDATE: 100302,
          CUSTOMER_RETURN_VISIT_RECORD_ADD: 100303,
          CUSTOMER_RETURN_VISIT_RECORD_DELETE: 100304,
          FINANCE_INCOME_SEARCH: 120000,
          FINANCE_INCOME_MODIFY_TARGET: 120001,
          FINANCE_INCOME_PROGRESS_GET: 120002,
          FINANCE_INCOME_STATISTICS: 120003,
          FINANCE_INCOME_SEARCH_TREND: 120004,
          FINANCE_INCOME_BIND_CONTRACT: 120005,
          FINANCE_INCOME_UPDATE_REMARK: 120006,
          RENEWAL_GET_BY_ID: 110001,
          RENEWAL_UPDATE_REMARK: 110002,
          RENEWAL_LIST_ADMIN: 110003,
          RENEWAL_RENEW_SUCCESS: 110004,
          RENEWAL_RENEW_FAIL: 110005,
          RENEWAL_PENDING_COUNT: 110006,
          RENEWAL_LIST: 110007,
          RENEWAL_SUBMIT_VOUCHER: 110008,
          RENEWAL_MODIFY_FAIL: 110009,
          RENEWAL_NEAREST_GET: 110010,
          RENEWAL_MODIFY_VOUCHER: 110011,
          RENEWAL_SEND_NOTIFY: 110012,
          RENEWAL_CONVERT_ID: 110013,
          RENEWAL_CLOSE: 110014,
          RENEWAL_LOGIN_VERIFY: 110015,
          RENEWAL_GET_BY_TOKEN: 110016,
          RENEWAL_ID_CONVERT: 110017,
          RENEWAL_MODIFY_TASK_DATE: 110018,
          RENEWAL_MODIFY_VOUCHER_SCREENSHOT: 110019,
          RENEWAL_CHANGE: 110020,
          RENEWAL_MODIFY_PRE_LOST: 110021,
          RENEWAL_PERMISSION_VERIFY: 110022,
          RENEWAL_DELAY_API_TIME_SET: 110023,
          RENEWAL_PROCESS_LIST_BY_ID: 110024,
          CHURN_RECORD_CHECK: 111000,
          CHURN_RECORD_LIST: 111001,
          CHURN_RECORD_UPDATE_FOLLOW_UP: 111002,
          CHURN_RECORD_UPDATE_REASON: 111003,
          CHURN_RECORD_UPDATE_REMARK: 111004,
          USER_LOG_GET_BY_CATEGORY: 130000,
          USER_LOG_GET_TOP: 130001,
          USER_LOG_UPDATE_TOP: 130002,
          LINK_ADD_FW: 140000,
          LINK_DELETE_FW: 140001,
          LINK_UPDATE_FW: 140002,
          LINK_GET_BY_ID_FW: 140003,
          LINK_LIST_FW: 140004,
          FW_SEARCH: 1700000,
          FW_SEARCH_SYNC: 1700001,
          NOTICE_LIST: 1800000,
          NOTICE_RESEND: 1800001,
          NOTICE_IGNORE: 1800002,
          NOTICE_NUMBER: 1800003,
          AUTH_SPORT: 1810000
        }
      },
      PBNoticeType: {
        values: {
          NOTICE_TYPE_SMS: 0,
          NOTICE_TYPE_EMAIL: 1
        }
      },
      PBNoticeStatus: {
        values: {
          NOTICE_STATUS_SUCCESS: 0,
          NOTICE_STATUS_FAIL: 1,
          NOTICE_STATUS_UN_SENT: 2,
          NOTICE_STATUS_RESENT: 3
        }
      },
      PBNotice: {
        fields: {
          noticeId: {
            type: "uint32",
            id: 1
          },
          subject: {
            type: "string",
            id: 2
          },
          title: {
            type: "string",
            id: 3
          },
          content: {
            type: "string",
            id: 4
          },
          type: {
            type: "PBNoticeType",
            id: 5
          },
          recipient: {
            type: "string",
            id: 6
          },
          userId: {
            type: "uint32",
            id: 7
          },
          customerId: {
            type: "uint32",
            id: 8
          },
          customerName: {
            type: "string",
            id: 9
          },
          createDate: {
            type: "uint64",
            id: 10
          },
          modifyDate: {
            type: "uint64",
            id: 11
          },
          status: {
            type: "PBNoticeStatus",
            id: 12
          },
          platform: {
            type: "PBPlatformType",
            id: 13
          },
          modifyAdmin: {
            type: "framework.PBAdmin",
            id: 14
          },
          isSystemMail: {
            type: "bool",
            id: 15
          },
          failInfo: {
            type: "string",
            id: 16
          }
        }
      },
      PBNoticeReq: {
        fields: {
          platform: {
            type: "PBPlatformType",
            id: 1
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBNoticeList: {
        fields: {
          notices: {
            rule: "repeated",
            type: "PBNotice",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBPaymentNotify: {
        fields: {
          orderId: {
            type: "string",
            id: 1
          },
          paymentId: {
            type: "string",
            id: 2
          },
          platformType: {
            type: "PBPlatformType",
            id: 3
          },
          paymentType: {
            type: "PBPaymentType",
            id: 4
          },
          paymentDate: {
            type: "uint64",
            id: 5
          },
          amount: {
            type: "int64",
            id: 6
          },
          paymentBank: {
            type: "string",
            id: 7
          }
        }
      },
      PBPaymentType: {
        values: {
          PT_DEFAULT: 0,
          PT_WECHAT_NATIVE: 1,
          PT_ALIPAY_WEB: 2,
          PT_99BILL: 3,
          PT_BANK: 4
        }
      },
      PBPaymentStatus: {
        values: {
          PS_DEFAULT: 0,
          PS_PENDING: 1,
          PS_PAID: 2
        }
      },
      PBSearchSource: {
        values: {
          SEARCH_ARTICLE: 0,
          SEARCH_API_DOC: 1
        }
      },
      PBSearchResult: {
        fields: {
          title: {
            type: "string",
            id: 1
          },
          content: {
            type: "string",
            id: 2
          },
          sourceDesc: {
            type: "string",
            id: 3
          },
          resultId: {
            type: "string",
            id: 4
          },
          source: {
            type: "PBSearchSource",
            id: 5
          },
          isBought: {
            type: "bool",
            id: 6
          },
          typeId: {
            type: "uint32",
            id: 7
          }
        }
      },
      PBSearchResultList: {
        fields: {
          resultList: {
            rule: "repeated",
            type: "PBSearchResult",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 2
          }
        }
      },
      PBSearchReq: {
        fields: {
          keyword: {
            type: "string",
            id: 1
          },
          userId: {
            type: "uint32",
            id: 2
          },
          sort: {
            type: "uint32",
            id: 3
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBCell: {
        fields: {
          key: {
            type: "string",
            id: 1
          },
          value: {
            type: "string",
            id: 2
          }
        }
      },
      PBRow: {
        fields: {
          name: {
            type: "string",
            id: 1
          },
          cells: {
            rule: "repeated",
            type: "PBCell",
            id: 2
          }
        }
      },
      PBUserStatistics: {
        fields: {
          lineStat: {
            type: "PBLineStat",
            id: 1
          },
          lineTableStat: {
            type: "PBLineTableStat",
            id: 2
          },
          tableStat: {
            type: "PBTableStat",
            id: 3
          }
        }
      },
      PBLineStat: {
        fields: {
          newUserFlow: {
            rule: "repeated",
            type: "PBLineItem",
            id: 1
          },
          newEaFlow: {
            rule: "repeated",
            type: "PBLineItem",
            id: 2
          },
          passEaFlow: {
            rule: "repeated",
            type: "PBLineItem",
            id: 3
          },
          failEaFlow: {
            rule: "repeated",
            type: "PBLineItem",
            id: 4
          },
          newBcFlow: {
            rule: "repeated",
            type: "PBLineItem",
            id: 5
          },
          contactedBcFlow: {
            rule: "repeated",
            type: "PBLineItem",
            id: 6
          },
          ignoreBcFlow: {
            rule: "repeated",
            type: "PBLineItem",
            id: 7
          }
        }
      },
      PBLineTableStat: {
        fields: {
          headers: {
            rule: "repeated",
            type: "string",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          newRegisterUserCount: {
            type: "uint32",
            id: 3
          },
          newEaCount: {
            type: "uint32",
            id: 4
          },
          passEaCount: {
            type: "uint32",
            id: 5
          },
          failEaCount: {
            type: "uint32",
            id: 6
          },
          newBcCount: {
            type: "uint32",
            id: 7
          },
          contactedBcCount: {
            type: "uint32",
            id: 8
          },
          ignoreBcCount: {
            type: "uint32",
            id: 9
          }
        }
      },
      PBTableStat: {
        fields: {
          headers: {
            rule: "repeated",
            type: "string",
            id: 1
          },
          items: {
            rule: "repeated",
            type: "PBTableItem",
            id: 2
          }
        }
      },
      PBTableItem: {
        fields: {
          name: {
            type: "string",
            id: 1
          },
          recent3: {
            type: "uint32",
            id: 2
          },
          recent7: {
            type: "uint32",
            id: 3
          },
          recent30: {
            type: "uint32",
            id: 4
          },
          total: {
            type: "uint32",
            id: 5
          }
        }
      },
      PBLineItem: {
        fields: {
          count: {
            type: "uint32",
            id: 1
          },
          date: {
            type: "uint64",
            id: 2
          }
        }
      },
      PBSearchUserStatisticsReq: {
        fields: {
          beginDate: {
            type: "uint64",
            id: 1
          },
          endDate: {
            type: "uint64",
            id: 2
          }
        }
      },
      PBUserStatisticsExportExcelReq: {
        fields: {
          beginDate: {
            type: "uint64",
            id: 1
          },
          endDate: {
            type: "uint64",
            id: 2
          }
        }
      },
      PBTrafficSearchType: {
        values: {
          TRAFFIC_DEFAULT: 0,
          TRAFFIC_SEARCH_CUSTOMER_NAME: 1,
          TRAFFIC_SEARCH_USER_ID: 2,
          TRAFFIC_SEARCH_CUSTOMER_ID: 3,
          TRAFFIC_SEARCH_MOBILE: 4,
          TRAFFIC_SEARCH_EMAIL: 5,
          TRAFFIC_SEARCH_ACCESS_KEY: 6
        }
      },
      PBSearchSportsFlowStatisticsReq: {
        fields: {
          beginDate: {
            type: "uint64",
            id: 1
          },
          endDate: {
            type: "uint64",
            id: 2
          },
          productType: {
            type: "int32",
            id: 3
          },
          productId: {
            type: "uint32",
            id: 4
          },
          searchType: {
            type: "PBTrafficSearchType",
            id: 5
          },
          searchKey: {
            type: "string",
            id: 6
          }
        }
      },
      PBSearchEsportsFlowStatisticsReq: {
        fields: {
          beginDate: {
            type: "uint64",
            id: 2
          },
          endDate: {
            type: "uint64",
            id: 3
          },
          productId: {
            type: "uint32",
            id: 4
          },
          categoryId: {
            type: "uint32",
            id: 5
          },
          searchType: {
            type: "PBTrafficSearchType",
            id: 6
          },
          searchKey: {
            type: "string",
            id: 7
          }
        }
      },
      PBTrafficStatistics: {
        fields: {
          dailyTotalFlow: {
            type: "PBDailyTotalFlow",
            id: 1
          }
        }
      },
      PBDailyTotalFlow: {
        fields: {
          total: {
            type: "PBDailyFlowItem",
            id: 1
          },
          items: {
            rule: "repeated",
            type: "PBDailyFlowItem",
            id: 2
          }
        }
      },
      PBDailyFlowItem: {
        fields: {
          name: {
            type: "string",
            id: 1
          },
          productNames: {
            rule: "repeated",
            type: "string",
            id: 2
          },
          avg: {
            type: "uint64",
            id: 3
          },
          total: {
            type: "uint64",
            id: 4
          },
          units: {
            rule: "repeated",
            type: "PBDailyFlow",
            id: 5
          }
        }
      },
      PBDailyFlow: {
        fields: {
          count: {
            type: "uint64",
            id: 1
          },
          date: {
            type: "uint64",
            id: 2
          }
        }
      },
      PBFinanceStatistics: {
        fields: {
          lastWeekSituation: {
            type: "PBFinanceLastWeekSituationStatistics",
            id: 1
          },
          userStatistics: {
            type: "PBFinanceCooperationUserStatistics",
            id: 2
          },
          totalStatistics: {
            type: "PBFinanceTotalStatistics",
            id: 3
          }
        }
      },
      PBFinanceLastWeekSituation: {
        fields: {
          title: {
            type: "string",
            id: 1
          },
          count: {
            type: "uint64",
            id: 2
          },
          weekGrowth: {
            type: "string",
            id: 3
          },
          monthGrowth: {
            type: "string",
            id: 4
          }
        }
      },
      PBFinanceLastWeekSituationStatistics: {
        fields: {
          title: {
            type: "string",
            id: 1
          },
          situations: {
            rule: "repeated",
            type: "PBFinanceLastWeekSituation",
            id: 2
          }
        }
      },
      PBFinanceCooperationUserStatistics: {
        fields: {
          titles: {
            rule: "repeated",
            type: "string",
            id: 1
          },
          count: {
            rule: "repeated",
            type: "uint64",
            id: 2
          }
        }
      },
      PBFinanceTotalStatistics: {
        fields: {
          headers: {
            rule: "repeated",
            type: "string",
            id: 1
          },
          rows: {
            rule: "repeated",
            type: "PBRow",
            id: 2
          }
        }
      },
      PBFinanceStatisticsDateType: {
        values: {
          FINANCE_STATISTICS_DAY: 0,
          FINANCE_STATISTICS_WEEK: 1,
          FINANCE_STATISTICS_MONTH: 2
        }
      },
      PBSearchFinanceTrendStatisticsReq: {
        fields: {
          dateType: {
            type: "PBFinanceStatisticsDateType",
            id: 1
          },
          beginDate: {
            type: "uint64",
            id: 2
          },
          endDate: {
            type: "uint64",
            id: 3
          },
          serviceType: {
            type: "PBServiceType",
            id: 4
          }
        }
      },
      PBFinanceTrendStatistics: {
        fields: {
          rows: {
            rule: "repeated",
            type: "PBRow",
            id: 1
          }
        }
      },
      PBToOpenInvoiceStatistics: {
        fields: {
          headers: {
            rule: "repeated",
            type: "string",
            id: 1
          },
          rows: {
            rule: "repeated",
            type: "PBRow",
            id: 2
          }
        }
      },
      PBUserLogCategory: {
        values: {
          ULC_OTHER: 0,
          ULC_ADMIN_OPERATION: 1,
          ULC_USER_OPERATION: 2,
          ULC_SYSTEM_INFO: 3,
          ULC_DEMAND: 4,
          ULC_PROBLEM: 5
        }
      },
      PBUserLog: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          userId: {
            type: "uint32",
            id: 2
          },
          name: {
            type: "string",
            id: 3
          },
          event: {
            type: "string",
            id: 4
          },
          desc: {
            type: "string",
            id: 5
          },
          createDate: {
            type: "uint64",
            id: 6
          },
          userCreate: {
            type: "bool",
            id: 7
          },
          top: {
            type: "bool",
            id: 8
          },
          category: {
            type: "PBUserLogCategory",
            id: 9
          }
        }
      },
      PBAddUserRemarkReq: {
        fields: {
          userId: {
            type: "uint32",
            id: 1
          },
          remark: {
            type: "string",
            id: 2
          },
          category: {
            type: "PBUserLogCategory",
            id: 3
          }
        }
      },
      PBGetUserLogListReq: {
        fields: {
          userId: {
            type: "uint32",
            id: 1
          },
          top: {
            type: "bool",
            id: 2
          },
          category: {
            type: "int32",
            id: 3
          },
          page: {
            type: "framework.PBPagePara",
            id: 10
          }
        }
      },
      PBUserLogList: {
        fields: {
          logs: {
            rule: "repeated",
            type: "PBUserLog",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      }
    }
  },
  lottery: {
    nested: {
      PBCustomer: {
        fields: {
          id: {
            type: "uint32",
            id: 1
          },
          user: {
            type: "fw.PBUser",
            id: 2
          },
          name: {
            type: "string",
            id: 3
          },
          location: {
            type: "framework.PBLocation",
            id: 4
          },
          businessTypes: {
            rule: "repeated",
            type: "PBBgCustomerBusinessType",
            id: 5
          },
          productForms: {
            rule: "repeated",
            type: "PBBgCustomerProductForm",
            id: 6
          },
          productName: {
            type: "string",
            id: 7
          },
          websiteInfo: {
            type: "string",
            id: 8
          },
          contribution: {
            type: "PBBgCustomerContribution",
            id: 10
          },
          techLevel: {
            type: "PBBgCustomerTechLevel",
            id: 11
          },
          popularity: {
            type: "PBBgCustomerPopularity",
            id: 12
          },
          cooperationStatus: {
            type: "PBBgCustomerCooperationStatus",
            id: 13
          },
          initialCpDate: {
            type: "uint64",
            id: 14
          },
          initialTryDate: {
            type: "uint64",
            id: 15
          },
          hasCallInterface: {
            type: "bool",
            id: 16
          },
          createDate: {
            type: "uint64",
            id: 19
          },
          modifyDate: {
            type: "uint64",
            id: 20
          }
        }
      },
      PBCustomerRecord: {
        fields: {
          customerId: {
            type: "uint32",
            id: 1
          },
          userId: {
            type: "uint32",
            id: 2
          },
          name: {
            type: "string",
            id: 3
          },
          mobile: {
            type: "string",
            id: 4
          },
          email: {
            type: "string",
            id: 5
          },
          cooperationStatus: {
            type: "PBBgCustomerCooperationStatus",
            id: 6
          },
          invoiceType: {
            type: "fw.PBInvoiceType",
            id: 7
          },
          invoiceTitle: {
            type: "string",
            id: 8
          },
          interfaceTypeCounts: {
            rule: "repeated",
            type: "PBInterfaceTypeCount",
            id: 9
          },
          token: {
            type: "string",
            id: 10
          },
          initialCpDate: {
            type: "uint64",
            id: 11
          },
          initialTryDate: {
            type: "uint64",
            id: 12
          },
          hasCallInterface: {
            type: "bool",
            id: 13
          },
          userProducts: {
            keyType: "uint64",
            type: "PBUserProductList",
            id: 14
          },
          refererUrl: {
            type: "string",
            id: 15
          }
        }
      },
      PBInterfaceTypeCount: {
        fields: {
          userId: {
            type: "uint32",
            id: 1
          },
          interfaceType: {
            type: "PBInterfaceType",
            id: 2
          },
          interfaceCount: {
            type: "uint32",
            id: 3
          }
        }
      },
      PBCustomerRecordList: {
        fields: {
          customers: {
            rule: "repeated",
            type: "PBCustomerRecord",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 10
          }
        }
      },
      PBCustomerDetail: {
        fields: {
          customer: {
            type: "PBCustomer",
            id: 1
          },
          boughtProductCount: {
            type: "uint32",
            id: 3
          },
          historyBoughtProductCount: {
            type: "uint32",
            id: 4
          },
          historyTryProductCount: {
            type: "uint32",
            id: 5
          },
          boughtProducts: {
            rule: "repeated",
            type: "PBUserProduct",
            id: 6
          },
          billInfo: {
            type: "fw.PBBillInfo",
            id: 7
          },
          contacts: {
            rule: "repeated",
            type: "fw.PBContact",
            id: 8
          },
          deliverAddress: {
            type: "fw.PBDeliveryAddress",
            id: 9
          },
          returnVisitRecords: {
            rule: "repeated",
            type: "fw.PBReturnVisitRecord",
            id: 10
          }
        }
      },
      PBBgCustomerBusinessType: {
        values: {
          CBT_DEFAULT: 0,
          CBT_LOTTERY: 1,
          CBT_INFORMATION: 2,
          CBT_LIVE: 3,
          CBT_RECOMMEND: 4,
          CBT_DATA: 5,
          CBT_QUIZ: 6,
          CBT_GAME: 7
        }
      },
      PBBgCustomerProductForm: {
        values: {
          CPF_DEFAULT: 0,
          CPF_PC: 1,
          CPF_APP: 2,
          CPF_MINI_PROGRAM: 3,
          CPF_H5: 4
        }
      },
      PBBgCustomerContribution: {
        values: {
          CC_DEFAULT: 0,
          CC_LOW: 1,
          CC_MEDIUM: 2,
          CC_HIGH: 3
        }
      },
      PBBgCustomerTechLevel: {
        values: {
          CTL_DEFAULT: 0,
          CTL_LOW: 1,
          CTL_MEDIUM: 2,
          CTL_HIGH: 3
        }
      },
      PBBgCustomerPopularity: {
        values: {
          CP_DEFAULT: 0,
          CP_LOW: 1,
          CP_MEDIUM: 2,
          CP_HIGH: 3
        }
      },
      PBBgCustomerCooperationStatus: {
        values: {
          CCS_DEFAULT: 0,
          CCS_NOT_CUSTOMER: 1,
          CCS_IN_TRIAL: 2,
          CCS_NOT_COOPERATION: 3,
          CCS_IN_COOPERATION: 4,
          CCS_INTERFACE_EXPIRED: 5
        }
      },
      PBInterface: {
        fields: {
          interfaceId: {
            type: "uint64",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          lotteryType: {
            type: "PBLotteryType",
            id: 3
          },
          requestParam: {
            rule: "repeated",
            type: "PBParam",
            id: 4
          },
          responseParam: {
            rule: "repeated",
            type: "PBParam",
            id: 5
          },
          description: {
            type: "string",
            id: 6
          },
          interfaceType: {
            type: "PBInterfaceType",
            id: 7
          },
          locationName: {
            type: "string",
            id: 8
          },
          organization: {
            type: "PBLotteryOrganization",
            id: 9
          },
          status: {
            type: "PBInterfaceStatus",
            id: 11
          },
          debugUrl: {
            type: "string",
            id: 12
          },
          lotteryResult: {
            type: "PBLotteryResult",
            id: 17
          },
          matchLottery: {
            type: "PBMatchLottery",
            id: 18
          },
          createDate: {
            type: "uint64",
            id: 19
          },
          modifyDate: {
            type: "uint64",
            id: 20
          }
        }
      },
      PBInterfaceList: {
        fields: {
          interfaces: {
            rule: "repeated",
            type: "PBInterface",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 9
          }
        }
      },
      PBParam: {
        fields: {
          name: {
            type: "string",
            id: 1
          },
          type: {
            type: "string",
            id: 2
          },
          meaning: {
            type: "string",
            id: 3
          },
          description: {
            type: "string",
            id: 4
          },
          required: {
            type: "bool",
            id: 5
          },
          arrangement: {
            type: "uint32",
            id: 6
          }
        }
      },
      PBInterfaceDocument: {
        fields: {
          interfaceType: {
            type: "PBInterfaceType",
            id: 1
          },
          description: {
            type: "string",
            id: 2
          },
          url: {
            type: "string",
            id: 3
          },
          method: {
            type: "PBInterfaceRequestMethod",
            id: 4
          },
          format: {
            type: "PBInterfaceFormat",
            id: 5
          },
          dayLimit: {
            type: "int32",
            id: 6
          },
          requestParam: {
            rule: "repeated",
            type: "PBParam",
            id: 7
          },
          responseParam: {
            rule: "repeated",
            type: "PBParam",
            id: 8
          },
          interfaceList: {
            rule: "repeated",
            type: "PBInterface",
            id: 9
          },
          responseFormats: {
            rule: "repeated",
            type: "PBInterfaceFormat",
            id: 10
          }
        }
      },
      PBActivityPackage: {
        fields: {
          packageId: {
            type: "uint64",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          description: {
            type: "string",
            id: 3
          },
          price: {
            type: "int64",
            id: 4
          },
          originPrice: {
            type: "int64",
            id: 5
          },
          type: {
            type: "PBActivityType",
            id: 6
          },
          interfaceType: {
            type: "PBInterfaceType",
            id: 7
          },
          productIds: {
            rule: "repeated",
            type: "uint64",
            id: 8
          },
          duration: {
            type: "uint32",
            id: 9
          },
          status: {
            type: "PBActivityPackageStatus",
            id: 10
          },
          createDate: {
            type: "uint64",
            id: 19
          },
          modifyDate: {
            type: "uint64",
            id: 20
          }
        }
      },
      PBActivityPackageList: {
        fields: {
          packages: {
            rule: "repeated",
            type: "PBActivityPackage",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 9
          }
        }
      },
      PBProduct: {
        fields: {
          productId: {
            type: "uint64",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          iface: {
            type: "PBInterface",
            id: 3
          },
          monthPrice: {
            type: "int64",
            id: 4
          },
          quarterPrice: {
            type: "int64",
            id: 5
          },
          yearPrice: {
            type: "int64",
            id: 6
          },
          description: {
            type: "string",
            id: 7
          },
          status: {
            type: "PBProductStatus",
            id: 8
          },
          type: {
            type: "PBProductType",
            id: 9
          },
          logo: {
            type: "string",
            id: 10
          },
          dayLimit: {
            type: "int32",
            id: 11
          },
          buyCount: {
            type: "int64",
            id: 12
          },
          demoUrl: {
            type: "string",
            id: 13
          },
          showType: {
            type: "PBProductShowType",
            id: 14
          },
          originMonthPrice: {
            type: "int64",
            id: 15
          },
          showSort: {
            type: "int32",
            id: 16
          },
          hotStatus: {
            type: "PBProductHotStatus",
            id: 17
          },
          admin: {
            type: "framework.PBAdmin",
            id: 18
          },
          createDate: {
            type: "uint64",
            id: 19
          },
          modifyDate: {
            type: "uint64",
            id: 20
          }
        }
      },
      PBProductList: {
        fields: {
          products: {
            rule: "repeated",
            type: "PBProduct",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 9
          }
        }
      },
      PBProductSetting: {
        fields: {
          type: {
            type: "PBInterfaceType",
            id: 1
          },
          name: {
            type: "string",
            id: 2
          },
          description: {
            type: "string",
            id: 3
          },
          total: {
            type: "int64",
            id: 4
          },
          monthPrice: {
            type: "int64",
            id: 5
          },
          originMonthPrice: {
            type: "int64",
            id: 6
          },
          yearPrice: {
            type: "int64",
            id: 7
          },
          containLocation: {
            rule: "repeated",
            type: "string",
            id: 8
          },
          products: {
            rule: "repeated",
            type: "PBProduct",
            id: 9
          },
          disableProducts: {
            rule: "repeated",
            type: "PBProduct",
            id: 10
          },
          createDate: {
            type: "uint64",
            id: 19
          },
          modifyDate: {
            type: "uint64",
            id: 20
          }
        }
      },
      PBProductSettingList: {
        fields: {
          settings: {
            rule: "repeated",
            type: "PBProductSetting",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 9
          }
        }
      },
      PBUserInterface: {
        fields: {
          recordId: {
            type: "uint64",
            id: 1
          },
          user: {
            type: "fw.PBUser",
            id: 2
          },
          "interface": {
            type: "PBInterface",
            id: 3
          },
          totalCount: {
            type: "uint64",
            id: 4
          },
          todayCount: {
            type: "uint64",
            id: 5
          },
          expirationDate: {
            type: "uint64",
            id: 6
          },
          lastCallDate: {
            type: "uint64",
            id: 7
          },
          lastCallIp: {
            type: "string",
            id: 8
          },
          dayLimit: {
            type: "uint32",
            id: 9
          },
          tryBeginDate: {
            type: "uint64",
            id: 10
          },
          tryEndDate: {
            type: "uint64",
            id: 11
          },
          beginDate: {
            type: "uint64",
            id: 12
          },
          productStatus: {
            type: "PBProductStatus",
            id: 17
          },
          productId: {
            type: "uint64",
            id: 18
          },
          createDate: {
            type: "uint64",
            id: 19
          },
          modifyDate: {
            type: "uint64",
            id: 20
          }
        }
      },
      PBUserInterfaceList: {
        fields: {
          interfaces: {
            rule: "repeated",
            type: "PBUserInterface",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 9
          }
        }
      },
      PBUserProduct: {
        fields: {
          recordId: {
            type: "uint64",
            id: 1
          },
          user: {
            type: "fw.PBUser",
            id: 2
          },
          product: {
            type: "PBProduct",
            id: 3
          },
          orderId: {
            type: "uint64",
            id: 4
          },
          duration: {
            type: "uint32",
            id: 5
          },
          expirationDate: {
            type: "uint64",
            id: 6
          },
          todayCount: {
            type: "uint64",
            id: 7
          },
          beginDate: {
            type: "uint64",
            id: 8
          },
          createDate: {
            type: "uint64",
            id: 19
          },
          modifyDate: {
            type: "uint64",
            id: 20
          }
        }
      },
      PBUserProductList: {
        fields: {
          products: {
            rule: "repeated",
            type: "PBUserProduct",
            id: 1
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 9
          }
        }
      },
      PBUserFavorProduct: {
        fields: {
          user: {
            type: "fw.PBUser",
            id: 1
          },
          products: {
            rule: "repeated",
            type: "PBUserProduct",
            id: 2
          },
          createDate: {
            type: "uint64",
            id: 19
          },
          modifyDate: {
            type: "uint64",
            id: 20
          }
        }
      },
      PBInterfaceFormat: {
        values: {
          IF_JSON: 0,
          IF_XML: 1
        }
      },
      PBInterfaceRequestMethod: {
        values: {
          IRM_DEFAULT: 0,
          IRM_GET: 1,
          IRM_POST: 2
        }
      },
      PBInterfaceType: {
        values: {
          IT_DEFAULT: 0,
          IT_NATIONWIDE_LOTTERY: 1,
          IT_DISTRICT_LOTTERY: 2,
          IT_HIGH_FREQUENCY_LOTTERY: 3,
          IT_FOOTBALL_LOTTERY: 4,
          IT_SCORE_LOTTERY: 5
        }
      },
      PBProductType: {
        values: {
          PT_DEFAULT: 0,
          PT_FREE_LOTTERY: 1,
          PT_SINGLE_LOTTERY: 2
        }
      },
      PBProductStatus: {
        values: {
          PS_DEFAULT: 0,
          PS_ENABLE: 1,
          PS_DISABLE: 2
        }
      },
      PBInterfaceStatus: {
        values: {
          IS_DEFAULT: 0,
          IS_ENABLE: 1,
          IS_DISABLE: 2
        }
      },
      PBProductShowType: {
        values: {
          PST_DEFAULT: 0,
          PST_BALL: 1,
          PST_POKER: 2,
          PST_NUMBER: 3,
          PST_SCORE: 4,
          PST_LINK: 5
        }
      },
      PBProductHotStatus: {
        values: {
          PHS_DEFAULT: 0,
          PHS_NORMAL: 1,
          PHS_HOT: 2
        }
      },
      PBActivityPackageStatus: {
        values: {
          APS_DEFAULT: 0,
          APS_ENABLE: 1,
          APS_DISABLE: 2
        }
      },
      PBActivityType: {
        values: {
          AT_DEFAULT: 0,
          AT_NEW_YEAR_2019: 1
        }
      },
      PBLotteryResult: {
        fields: {
          resultId: {
            type: "string",
            id: 1
          },
          type: {
            type: "PBLotteryType",
            id: 2
          },
          period: {
            type: "string",
            id: 3
          },
          winningNumbers: {
            rule: "repeated",
            type: "string",
            id: 4
          },
          specialWinningNumbers: {
            rule: "repeated",
            type: "string",
            id: 5
          },
          sales: {
            type: "int64",
            id: 6
          },
          jackpot: {
            type: "int64",
            id: 7
          },
          returnRate: {
            type: "int64",
            id: 8
          },
          ballSet: {
            type: "uint32",
            id: 10
          },
          awards: {
            rule: "repeated",
            type: "PBLotteryAward",
            id: 11
          },
          openDate: {
            type: "uint64",
            id: 12
          },
          createDate: {
            type: "uint64",
            id: 19
          },
          crawlDate: {
            type: "uint64",
            id: 20
          }
        }
      },
      PBLotteryAward: {
        fields: {
          name: {
            type: "string",
            id: 1
          },
          totalBonus: {
            type: "int64",
            id: 2
          },
          potBonus: {
            type: "int64",
            id: 3
          },
          potCount: {
            type: "uint64",
            id: 4
          },
          additionalBonus: {
            type: "int64",
            id: 5
          },
          additionalPotCount: {
            type: "uint64",
            id: 6
          },
          additionalPotBonus: {
            type: "int64",
            id: 7
          }
        }
      },
      PBLotteryOrganization: {
        values: {
          LO_DEFAULT: 0,
          LO_CHINA_WELFARE_LOTTERY: 1,
          LO_CHINA_SPORTS_LOTTERY: 2,
          LO_OTHER: 100
        }
      },
      PBLotteryPeriodType: {
        values: {
          LPT_DEFAULT: 0,
          LPT_ACCUMULATION: 1,
          LPT_SHORT_YEAR_ACCUMULATION: 2,
          LPT_YEAR_ACCUMULATION: 3,
          LPT_DAY_ACCUMULATION: 4,
          LPT_DATE: 5
        }
      },
      PBLotteryType: {
        values: {
          LT_DEFAULT: 0,
          LT_QG_SSQ: 1001,
          LT_QG_3D: 1002,
          LT_QG_3DSJH: 1003,
          LT_QG_QLC: 1004,
          LT_QG_DLT: 1005,
          LT_QG_PLS: 1006,
          LT_QG_PLW: 1007,
          LT_QG_QXC: 1008,
          LT_AH_25X5: 2001,
          LT_FJ_36X7: 2002,
          LT_FJ_22X5: 2003,
          LT_FJ_31X7: 2004,
          LT_GD_36X7: 2005,
          LT_GD_26X5: 2006,
          LT_GD_HC1: 2007,
          LT_GX_KLSC: 2008,
          LT_HN_4J1_QIONG: 2009,
          LT_HB_20X5_JI: 2010,
          LT_HB_PL7_JI: 2011,
          LT_HB_PL5_JI: 2012,
          LT_HB_HYC2_JI: 2013,
          LT_HB_HYC3_JI: 2014,
          LT_HN_22X5_YU: 2015,
          LT_HLJ_22X5: 2016,
          LT_HLJ_P62: 2017,
          LT_HLJ_36X7: 2018,
          LT_HLJ_6J1: 2019,
          LT_HB_30X5_E: 2020,
          LT_HD_15X5: 2021,
          LT_HD_DF6J1: 2022,
          LT_JS_7WS: 2023,
          LT_LN_35X7: 2024,
          LT_SH_TTCX4: 2025,
          LT_SZ_SZFC: 2026,
          LT_XJ_25X7: 2027,
          LT_XJ_35X7: 2028,
          LT_XJ_18X7: 2029,
          LT_ZJ_6J1: 2030,
          LT_ZJ_20X5: 2031,
          LT_AH_K3: 3001,
          LT_AH_11X5: 3002,
          LT_BJ_KL8: 3003,
          LT_BJ_SCPK10: 3004,
          LT_BJ_K3: 3005,
          LT_BJ_11X5: 3006,
          LT_BJ_KZC: 3007,
          LT_FJ_K3: 3008,
          LT_FJ_11X5: 3009,
          LT_GS_K3: 3010,
          LT_GS_11X5: 3011,
          LT_GD_KLSF: 3012,
          LT_GD_11X5: 3013,
          LT_GX_KLSF: 3014,
          LT_GX_K3: 3015,
          LT_GX_11X5: 3016,
          LT_GZ_K3: 3017,
          LT_GZ_11X5: 3018,
          LT_HN_FY_QIONG: 3019,
          LT_HN_HDS_QIONG: 3020,
          LT_HB_K3_JI: 3021,
          LT_HB_11X5_JI: 3022,
          LT_HN_K3_YU: 3023,
          LT_HN_11X5_YU: 3024,
          LT_HN_KY481_YU: 3025,
          LT_HLJ_KLSF: 3026,
          LT_HLJ_SSC: 3027,
          LT_HLJ_KLMJ: 3028,
          LT_HLJ_11X5: 3029,
          LT_HB_K3_E: 3030,
          LT_HB_11X5_E: 3031,
          LT_HN_KLSF_XIANG: 3032,
          LT_HN_XYSC_XIANG: 3033,
          LT_JL_K3: 3034,
          LT_JL_SSC: 3035,
          LT_JL_11X5: 3036,
          LT_JS_K3: 3037,
          LT_JS_11X5: 3038,
          LT_JX_K3: 3039,
          LT_JX_11X5: 3040,
          LT_LN_KL12: 3041,
          LT_LN_11X5: 3042,
          LT_NMG_K3: 3043,
          LT_NMG_SSC: 3044,
          LT_NMG_11X5: 3045,
          LT_NX_11X5: 3046,
          LT_QH_K3: 3047,
          LT_QH_11X5: 3048,
          LT_SD_QYH: 3049,
          LT_SD_11X5: 3050,
          LT_SD_KLPK3: 3051,
          LT_SX_KLSF_JIN: 3052,
          LT_SX_YTDJ_JIN: 3053,
          LT_SX_11X5_JIN: 3054,
          LT_SX_KLSF_SHAN: 3055,
          LT_SX_11X5_SHAN: 3056,
          LT_SH_SSL: 3057,
          LT_SH_K3: 3058,
          LT_SH_11X5: 3059,
          LT_SC_KL12: 3060,
          LT_SC_J7L: 3061,
          LT_TJ_KLSF: 3062,
          LT_TJ_SSC: 3063,
          LT_TJ_11X5: 3064,
          LT_XJ_SSC: 3065,
          LT_XJ_XLC: 3066,
          LT_XJ_11X5: 3067,
          LT_YN_SSC: 3068,
          LT_YN_KLSF: 3069,
          LT_YN_11X5: 3070,
          LT_ZJ_KL12: 3071,
          LT_ZJ_11X5: 3072,
          LT_ZJ_FY: 3073,
          LT_ZJ_YTDJ: 3074,
          LT_CQ_SSC: 3075,
          LT_CQ_KLSF: 3076,
          LT_QG_SFC: 4001,
          LT_QG_BQC: 4002,
          LT_QG_JQC: 4003,
          LT_QG_JCZQ_SPF: 5001,
          LT_QG_JCZQ_RQSPF: 5002,
          LT_QG_JCZQ_BF: 5003,
          LT_QG_JCZQ_ZJQS: 5004,
          LT_QG_JCZQ_BQCSPF: 5005,
          LT_QG_JCLQ_SF: 5006,
          LT_QG_JCLQ_RQSF: 5007,
          LT_QG_JCLQ_SFC: 5008,
          LT_QG_JCLQ_DXF: 5009,
          LT_QG_JCZQ_OP: 5010,
          LT_QG_JCZQ_YP: 5011,
          LT_QG_JCLQ_WW: 5012,
          LT_QG_BD_SFGG: 5013,
          LT_QG_BD_SPF: 5014,
          LT_QG_BD_ZJQS: 5015,
          LT_QG_BD_BQCSPF: 5016,
          LT_QG_BD_SXPDSS: 5017,
          LT_QG_BD_DCBF: 5018,
          LT_QG_BD_XBCBF: 5019,
          LT_QG_ZC_SFC: 5020,
          LT_QG_ZC_6CBQC: 5021,
          LT_QG_ZC_4CJQ: 5022,
          LT_QG_ZC_OP: 5023,
          LT_QG_ZC_YP: 5024,
          LT_QG_JCLQ_WW_YZ: 5025,
          LT_QG_JCLQ_WW_DXF: 5026
        }
      },
      PBMatchLottery: {
        fields: {
          lotteryId: {
            type: "string",
            id: 1
          },
          period: {
            type: "string",
            id: 2
          },
          type: {
            type: "PBLotteryType",
            id: 3
          },
          matches: {
            rule: "repeated",
            type: "PBMatch",
            id: 4
          },
          onSaleDate: {
            type: "uint64",
            id: 11
          },
          haltSaleDate: {
            type: "uint64",
            id: 12
          },
          openDate: {
            type: "uint64",
            id: 13
          },
          createDate: {
            type: "uint64",
            id: 14
          },
          crawlDate: {
            type: "uint64",
            id: 15
          }
        }
      },
      PBCompanyOdds: {
        fields: {
          company: {
            type: "string",
            id: 1
          },
          initialOdds: {
            type: "PBOdds",
            id: 2
          },
          instantOdds: {
            type: "PBOdds",
            id: 3
          },
          probability: {
            type: "PBOdds",
            id: 4
          },
          kelly: {
            type: "PBOdds",
            id: 5
          }
        }
      },
      PBOdds: {
        fields: {
          home: {
            type: "double",
            id: 1
          },
          draw: {
            type: "double",
            id: 2
          },
          away: {
            type: "double",
            id: 3
          },
          handicap: {
            type: "string",
            id: 4
          },
          homeSupport: {
            type: "double",
            id: 5
          },
          drawSupport: {
            type: "double",
            id: 6
          },
          awaySupport: {
            type: "double",
            id: 7
          }
        }
      },
      PBSingleOdds: {
        fields: {
          name: {
            type: "string",
            id: 1
          },
          odds: {
            type: "double",
            id: 2
          }
        }
      },
      PBMatch: {
        fields: {
          matchId: {
            type: "string",
            id: 1
          },
          number: {
            type: "int64",
            id: 2
          },
          leagueName: {
            type: "string",
            id: 3
          },
          homeTeam: {
            type: "PBMatchTeam",
            id: 4
          },
          awayTeam: {
            type: "PBMatchTeam",
            id: 5
          },
          matchDate: {
            type: "uint64",
            id: 6
          },
          enableSingle: {
            type: "bool",
            id: 7
          },
          status: {
            type: "PBMatchLotteryStatus",
            id: 8
          },
          memo: {
            type: "string",
            id: 9
          },
          result: {
            type: "string",
            id: 10
          },
          companyType: {
            type: "PBMatchCompanyType",
            id: 11
          },
          odds: {
            type: "PBOdds",
            id: 20
          },
          specialOdds: {
            rule: "repeated",
            type: "PBSingleOdds",
            id: 21
          },
          companyOdds: {
            rule: "repeated",
            type: "PBCompanyOdds",
            id: 22
          }
        }
      },
      PBMatchTeam: {
        fields: {
          name: {
            type: "string",
            id: 1
          },
          score: {
            type: "int32",
            id: 2
          },
          halfScore: {
            type: "int32",
            id: 3
          },
          rank: {
            type: "string",
            id: 4
          }
        }
      },
      PBMatchLotteryStatus: {
        values: {
          MLS_DEFAULT: 0,
          MLS_ON_SALE: 1,
          MLS_HALT_SALE: 2,
          MLS_OPEN: 3
        }
      },
      PBMatchCompanyType: {
        values: {
          MCT_DEFAULT: 0,
          MCT_SPORTTERY: 1,
          MCT_BJLOT: 2,
          MCT_ZGZCW: 3
        }
      },
      PBLotteryError: {
        values: {
          LOTTERY_SUCCESS: 0,
          USER_PERMISSION_DENIED: 1000001,
          USER_HAVE_NOT_INTERFACE: 1000002,
          USER_APP_INFO_NOT_FOUND: 1000003,
          USER_INTERFACE_CALL_TOO_MUCH: 1000004,
          USER_INTERFACE_EXPIRED: 1000005,
          USER_INCORRECT_VALID_CODE: 1000006,
          USER_CANNOT_TRY_PRODUCT: 1000007,
          USER_HAVE_NOT_PRODUCT: 1000008,
          USER_NOT_FOUND: 1000009,
          USER_EMAIL_EXISTS: 1000010,
          INTERFACE_NOT_RESULT: 2000001,
          INTERFACE_NOT_FOUND: 2000002,
          INTERFACE_DISABLE: 2000003,
          INTERFACE_NOT_SUPPORT_FORMAT: 2000004,
          INTERFACE_COUNT_TOO_LARGE: 2000005,
          INTERFACE_DATE_FORMAT_ERROR: 2000006,
          CUSTOMER_NOT_FOUND: 3000001,
          PRODUCT_SETTING_NOT_FOUND: 4000001,
          PRODUCT_NOT_FOUND: 4000002,
          PRODUCT_INTERFACE_DOCUMENT_NOT_FOUND: 4000003,
          PRODUCT_USER_INTERFACE_EXTEND_CANT_NULL: 4000004,
          PRODUCT_ACTIVITY_PACKAGE_DISABLE: 4000005,
          ORDER_NOT_FOUND: 5000001,
          ORDER_CANNOT_PAY: 5000002,
          ORDER_PRODUCT_INFO_ILLEGAL: 5000003,
          ORDER_CANNOT_GET: 5000004,
          ORDER_ITEMS_DATE_ILLEGAL: 5000005,
          ORDER_BILL_STATUS_CANT_MODIFY: 5000006,
          ORDER_AMOUNT_CANT_MODIFY: 5000007,
          PAYMENT_RECORD_NOT_FOUND: 6000001,
          NOTIFY_SMS_SEND_ERROR: 7000001,
          NOTIFY_EMAIL_SEND_ERROR: 7000002
        }
      },
      PBLotteryMessageType: {
        values: {
          DEFAULT_TYPE: 0,
          PRODUCT_QUERY_LIST: 100000,
          PRODUCT_SETTING_GET: 100001,
          PRODUCT_SETTING_LIST: 100002,
          PRODUCT_INTERFACE_TEST: 100003,
          PRODUCT_UPDATE: 100004,
          PRODUCT_GET: 100005,
          PRODUCT_INTERFACE_DOCUMENT_GET: 100006,
          PRODUCT_USER_INTERFACE_LIST: 100007,
          PRODUCT_INTERFACE_ALL_AVAIL: 100008,
          PRODUCT_PRICE_SETTING_LIST: 100009,
          PRODUCT_BATCH_UPDATE_SORTING: 100010,
          PRODUCT_UPDATE_HOT: 100011,
          PRODUCT_USER_INTERFACE_EXTEND: 100012,
          PRODUCT_ACTIVITY_PACKAGES_LIST: 100013,
          ORDER_CREATE: 110000,
          ORDER_PAY: 110001,
          ORDER_GET: 110002,
          ORDER_QUERY_LIST: 110003,
          ORDER_FREE_TRY: 110004,
          ORDER_CONFIRM: 110005,
          ORDER_USER_LIST: 110006,
          ORDER_CALCULATE: 110007,
          ORDER_MODIFY_BILL_STATUS: 110008,
          ORDER_MODIFY_AMOUNT: 110009,
          ORDER_PAY_BY_BANK: 110010,
          ORDER_BUY_ACTIVITY_PACKAGE: 110011,
          USER_SEND_MOBILE_VALID_CODE: 120000,
          USER_MOBILE_REGISTER: 120001,
          USER_LOGIN: 120002,
          USER_MOBILE_RESET_PASSWORD: 120003,
          USER_BIND_MOBILE: 120004,
          USER_VALID_PASSWORD: 120005,
          USER_BIND_EMAIL: 120006,
          USER_LOGOUT: 120007,
          USER_GET_BY_ID: 120008,
          USER_MOBILE_IS_EXISTS: 120009,
          USER_UPDATE_TOKEN: 120010,
          USER_FAVOR_PRODUCT_GET: 120011,
          USER_FAVOR_PRODUCT_UPDATE: 120012,
          USER_IS_CAN_FREE_TRY: 120013,
          USER_FAVOR_PRODUCT_ADD: 120014,
          USER_SEND_EMAIL_VALID_CODE: 120015,
          USER_UPDATE_TOKEN_BY_ADMIN: 120016,
          USER_REPLACE_MOBILE: 120017,
          USER_REPLACE_EMAIL: 120018,
          USER_LOG_GET_BY_CATEGORY: 120100,
          USER_LOG_GET_TOP: 120101,
          USER_LOG_UPDATE_TOP: 120102,
          CUSTOMER_DETAIL: 130000,
          CUSTOMER_UPDATE_INFO: 130001,
          CUSTOMER_SEARCH: 130002,
          CUSTOMER_GET_BY_ID: 130004,
          CUSTOMER_HISTORY_BOUGHT_INTERFACE_LIST: 130005,
          CUSTOMER_HISTORY_TRY_INTERFACE_LIST: 130006,
          CUSTOMER_GET_BY_USER_ID: 130007,
          CUSTOMER_DETAIL_BY_USER_ID: 130008,
          CUSTOMER_RENEWAL_NOTIFY_STATUS: 130009,
          CUSTOMER_CONTACT_GET_BY_ID: 130100,
          CUSTOMER_CONTACT_LIST: 130101,
          CUSTOMER_CONTACT_ADD: 130102,
          CUSTOMER_CONTACT_MODIFY: 130103,
          CUSTOMER_CONTACT_DELETE: 130104,
          CUSTOMER_CONTACT_SET_PRIMARY: 130105,
          CUSTOMER_CONTACT_GET_PRIMARY: 130106,
          CUSTOMER_DELIVERY_ADDRESS_GET_BY_ID: 130200,
          CUSTOMER_DELIVERY_ADDRESS_UPDATE_BY_ADMIN: 130201,
          CUSTOMER_DELIVERY_ADDRESS_UPDATE_BY_USER: 130202,
          CUSTOMER_DELIVERY_ADDRESS_GET: 130203,
          CUSTOMER_RETURN_VISIT_RECORD_LIST: 130300,
          CUSTOMER_RETURN_VISIT_RECORD_GET_BY_ID: 130301,
          CUSTOMER_RETURN_VISIT_RECORD_UPDATE: 130302,
          CUSTOMER_RETURN_VISIT_RECORD_ADD: 130303,
          CUSTOMER_RETURN_VISIT_RECORD_DELETE: 130304,
          CUSTOMER_BILL_GET_BY_ID: 130400,
          CUSTOMER_BILL_GET_BY_USER_ID: 130401,
          CUSTOMER_BILL_MODIFY_BY_ADMIN: 130402,
          STATISTIC_USER_INTERFACE: 140000,
          STATISTIC_CUSTOMER_YESTERDAY: 140001,
          STATISTIC_CUSTOMER_GET_BY_DATE: 140002,
          STATISTIC_REAL_TIME_CALL: 140003,
          LINK_LIST: 150000,
          ARTICLE_GET_BY_ID: 160001,
          ARTICLE_GET_BY_TYPE: 160002,
          ARTICLE_GET_TYPE_LIST: 160003
        }
      },
      PBOrder: {
        fields: {
          orderId: {
            type: "uint64",
            id: 1
          },
          orderNumber: {
            type: "string",
            id: 2
          },
          user: {
            type: "fw.PBUser",
            id: 3
          },
          items: {
            rule: "repeated",
            type: "PBOrderItem",
            id: 4
          },
          amount: {
            type: "int64",
            id: 5
          },
          payType: {
            type: "PBOrderPayType",
            id: 6
          },
          payId: {
            type: "string",
            id: 7
          },
          payDate: {
            type: "uint64",
            id: 8
          },
          payStatus: {
            type: "PBOrderPayStatus",
            id: 9
          },
          billStatus: {
            type: "PBBillStatus",
            id: 10
          },
          billMemo: {
            type: "string",
            id: 11
          },
          customer: {
            type: "PBCustomer",
            id: 12
          },
          discountAmount: {
            type: "int64",
            id: 13
          },
          hasChangeAmount: {
            type: "bool",
            id: 14
          },
          payBank: {
            type: "string",
            id: 15
          },
          payName: {
            type: "string",
            id: 16
          },
          modifyAdmin: {
            type: "framework.PBAdmin",
            id: 17
          },
          originAmount: {
            type: "int64",
            id: 18
          },
          createDate: {
            type: "uint64",
            id: 19
          },
          modifyDate: {
            type: "uint64",
            id: 20
          },
          activityType: {
            type: "PBActivityType",
            id: 30
          },
          packages: {
            rule: "repeated",
            type: "PBActivityPackage",
            id: 31
          }
        }
      },
      PBOrderList: {
        fields: {
          orders: {
            rule: "repeated",
            type: "PBOrder",
            id: 1
          },
          totalAmount: {
            type: "uint64",
            id: 2
          },
          payCount: {
            type: "uint64",
            id: 3
          },
          payAmount: {
            type: "uint64",
            id: 4
          },
          pageInfo: {
            type: "framework.PBPageInfo",
            id: 9
          }
        }
      },
      PBOrderItem: {
        fields: {
          product: {
            type: "PBProduct",
            id: 1
          },
          duration: {
            type: "uint32",
            id: 2
          },
          amount: {
            type: "int64",
            id: 3
          },
          originAmount: {
            type: "int64",
            id: 4
          },
          beginDate: {
            type: "uint64",
            id: 19
          },
          expirationDate: {
            type: "uint64",
            id: 20
          }
        }
      },
      PBOrderPayStatus: {
        values: {
          OPS_DEFAULT: 0,
          OPS_PENDING: 1,
          OPS_PAID: 2,
          OPS_CLOSE: 3
        }
      },
      PBBillStatus: {
        values: {
          BS_DEFAULT: 0,
          BS_UNBILLED: 1,
          BS_BILLED: 2
        }
      },
      PBOrderPayType: {
        values: {
          OPT_DEFAULT: 0,
          OPT_FREE: 1,
          OPT_WECHAT_NATIVE: 2,
          OPT_ALIPAY_WEB: 3,
          OPT_99BILL: 4,
          OPT_BANK: 5
        }
      },
      PBBatchUpdateProductSortingReq: {
        fields: {
          product: {
            rule: "repeated",
            type: "PBProduct",
            id: 1
          }
        }
      },
      PBGetProductSettingReq: {
        fields: {
          interfaceType: {
            type: "PBInterfaceType",
            id: 1
          }
        }
      },
      PBQueryProductListReq: {
        fields: {
          interfaceType: {
            rule: "repeated",
            type: "PBInterfaceType",
            id: 1
          },
          organization: {
            type: "PBLotteryOrganization",
            id: 2
          },
          locationName: {
            type: "string",
            id: 3
          },
          keyType: {
            type: "PBQueryProductKeyType",
            id: 4
          },
          searchKey: {
            type: "string",
            id: 5
          },
          status: {
            rule: "repeated",
            type: "PBInterfaceStatus",
            id: 6
          },
          needResult: {
            type: "bool",
            id: 7
          },
          hotStatus: {
            rule: "repeated",
            type: "PBProductHotStatus",
            id: 8
          },
          page: {
            type: "framework.PBPagePara",
            id: 20
          }
        }
      },
      PBInterfaceTestReq: {
        fields: {
          lotteryType: {
            type: "PBLotteryType",
            id: 1
          },
          period: {
            type: "string",
            id: 2
          },
          count: {
            type: "int32",
            id: 3
          },
          format: {
            type: "PBInterfaceFormat",
            id: 4
          },
          interfaceType: {
            type: "PBInterfaceType",
            id: 5
          }
        }
      },
      PBPayOrderReq: {
        fields: {
          orderId: {
            type: "uint64",
            id: 1
          },
          payType: {
            type: "PBOrderPayType",
            id: 2
          }
        }
      },
      PBOrderPayRsp: {
        fields: {
          orderId: {
            type: "uint64",
            id: 1
          },
          paymentParams: {
            type: "string",
            id: 2
          }
        }
      },
      PBQueryOrderReq: {
        fields: {
          payStatus: {
            rule: "repeated",
            type: "PBOrderPayStatus",
            id: 1
          },
          payType: {
            rule: "repeated",
            type: "PBOrderPayType",
            id: 2
          },
          billStatus: {
            rule: "repeated",
            type: "PBBillStatus",
            id: 3
          },
          keyType: {
            type: "PBQueryOrderKeyType",
            id: 4
          },
          searchKey: {
            type: "string",
            id: 5
          },
          dateType: {
            type: "PBQueryOrderDateType",
            id: 6
          },
          beginDate: {
            type: "uint64",
            id: 7
          },
          endDate: {
            type: "uint64",
            id: 8
          },
          refererUrl: {
            rule: "repeated",
            type: "string",
            id: 9
          },
          page: {
            type: "framework.PBPagePara",
            id: 20
          }
        }
      },
      PBUpdateTokenReq: {
        fields: {
          userId: {
            type: "uint32",
            id: 1
          },
          validCode: {
            type: "string",
            id: 2
          }
        }
      },
      PBQueryCustomerListReq: {
        fields: {
          searchDateType: {
            type: "PBCustomerQueryDateType",
            id: 1
          },
          beginDate: {
            type: "uint64",
            id: 2
          },
          endDate: {
            type: "uint64",
            id: 3
          },
          searchKeyType: {
            type: "PBCustomerQueryKeyType",
            id: 4
          },
          searchKey: {
            type: "string",
            id: 5
          },
          cooperationStatuses: {
            rule: "repeated",
            type: "PBBgCustomerCooperationStatus",
            id: 6
          },
          interfaceTypes: {
            rule: "repeated",
            type: "PBInterfaceType",
            id: 7
          },
          hasCall: {
            rule: "repeated",
            type: "bool",
            id: 8
          },
          page: {
            type: "framework.PBPagePara",
            id: 20
          }
        }
      },
      PBGetUserOrderReq: {
        fields: {
          userId: {
            type: "uint32",
            id: 1
          },
          status: {
            rule: "repeated",
            type: "PBOrderPayStatus",
            id: 2
          },
          page: {
            type: "framework.PBPagePara",
            id: 20
          }
        }
      },
      PBGetUserCallStatisticReq: {
        fields: {
          interfaceType: {
            type: "PBInterfaceType",
            id: 1
          },
          interfaceId: {
            type: "uint64",
            id: 2
          },
          keyType: {
            type: "PBUserCallStatisticSearchKeyType",
            id: 3
          },
          searchKey: {
            type: "string",
            id: 4
          },
          beginDate: {
            type: "uint64",
            id: 5
          },
          endDate: {
            type: "uint64",
            id: 6
          }
        }
      },
      PBGetUserCallStatisticRsp: {
        fields: {
          items: {
            rule: "repeated",
            type: "PBCallStatisticItem",
            id: 1
          }
        }
      },
      PBGetUserInterfaceListReq: {
        fields: {
          interfaceType: {
            type: "PBInterfaceType",
            id: 1
          },
          locationName: {
            type: "string",
            id: 2
          },
          userId: {
            type: "uint32",
            id: 3
          },
          page: {
            type: "framework.PBPagePara",
            id: 20
          }
        }
      },
      PBOrderModifyBillStatusReq: {
        fields: {
          orderId: {
            type: "uint64",
            id: 1
          },
          billStatus: {
            type: "PBBillStatus",
            id: 2
          },
          billMemo: {
            type: "string",
            id: 3
          }
        }
      },
      PBYesterdayCustomerStatisticRsp: {
        fields: {
          yesterday: {
            type: "PBCustomerStatistic",
            id: 1
          },
          beforeYesterday: {
            type: "PBCustomerStatistic",
            id: 2
          }
        }
      },
      PBGetCustomerStatisticReq: {
        fields: {
          beginDate: {
            type: "uint64",
            id: 1
          },
          endDate: {
            type: "uint64",
            id: 2
          }
        }
      },
      PBGetCustomerStatisticRsp: {
        fields: {
          detail: {
            rule: "repeated",
            type: "PBCustomerStatistic",
            id: 1
          },
          increase: {
            type: "PBCustomerStatistic",
            id: 2
          },
          total: {
            type: "PBCustomerStatistic",
            id: 3
          }
        }
      },
      PBExtendUserInterfaceReq: {
        fields: {
          userId: {
            type: "uint32",
            id: 1
          },
          productIds: {
            rule: "repeated",
            type: "uint64",
            id: 2
          },
          duration: {
            type: "uint32",
            id: 3
          }
        }
      },
      PBModifyOrderAmountReq: {
        fields: {
          orderId: {
            type: "uint64",
            id: 1
          },
          amount: {
            type: "uint64",
            id: 2
          }
        }
      },
      PBBuyActivityPackageReq: {
        fields: {
          userId: {
            type: "uint32",
            id: 1
          },
          packageIds: {
            rule: "repeated",
            type: "uint64",
            id: 2
          },
          activityType: {
            type: "PBActivityType",
            id: 3
          }
        }
      },
      PBBuyActivityPackageRsp: {
        fields: {
          order: {
            type: "PBOrder",
            id: 1
          },
          paymentParams: {
            type: "string",
            id: 2
          }
        }
      },
      PBUserCallStatisticSearchKeyType: {
        values: {
          UCSSKT_DEFAULT: 0,
          UCSSKT_CUSTOMER_ID: 1,
          UCSSKT_USER_ID: 2,
          UCSSKT_TOKEN: 3,
          UCSSKT_MOBILE: 4
        }
      },
      PBCustomerQueryDateType: {
        values: {
          CSDT_DEFAULT: 0,
          CSDT_INTERFACE_EFFECTIVE_DATE: 1,
          CSDT_INITIALCPDATE: 2,
          CSDT_INITIAL_TRY_DATE: 3
        }
      },
      PBCustomerQueryKeyType: {
        values: {
          CKS_DEFAULT: 0,
          CSK_CUSTOMER_ID: 1,
          CSK_CUSTOMER_NAME: 2,
          CSK_USER_ID: 3,
          CSK_MOBILE: 4,
          CSK_EMAIL: 5,
          CSK_BOUGHT_INTERFACE_NAME: 6,
          CSK_BOUGHT_INTERFACE_ID: 7
        }
      },
      PBQueryProductKeyType: {
        values: {
          QPKT_INTERFACE_NAME: 0,
          QPKT_LOTTERY_TYPE: 1
        }
      },
      PBQueryOrderKeyType: {
        values: {
          QOKT_ORDER_ID: 0,
          QOKT_CUSTOM_MOBILE: 1,
          QOKT_CUSTOM_ID: 2,
          QOKT_CUSTOM_NAME: 3,
          QOKT_PAY_ID: 4
        }
      },
      PBQueryOrderDateType: {
        values: {
          QODT_PAY_DATE: 0,
          QODT_CREATE_DATE: 1
        }
      },
      PBStatisticDateCountItem: {
        fields: {
          date: {
            type: "uint64",
            id: 1
          },
          count: {
            type: "int64",
            id: 2
          }
        }
      },
      PBCallStatisticItem: {
        fields: {
          name: {
            type: "string",
            id: 1
          },
          average: {
            type: "int64",
            id: 2
          },
          total: {
            type: "int64",
            id: 3
          },
          items: {
            rule: "repeated",
            type: "PBStatisticDateCountItem",
            id: 4
          }
        }
      },
      PBCustomerStatistic: {
        fields: {
          registerUser: {
            type: "int64",
            id: 1
          },
          tryCustomer: {
            type: "int64",
            id: 2
          },
          payCustomer: {
            type: "int64",
            id: 3
          },
          payAmount: {
            type: "int64",
            id: 4
          },
          newOrder: {
            type: "int64",
            id: 5
          },
          payOrder: {
            type: "int64",
            id: 6
          },
          closeOrder: {
            type: "int64",
            id: 7
          },
          date: {
            type: "uint64",
            id: 8
          },
          createDate: {
            type: "uint64",
            id: 10
          },
          modifyDate: {
            type: "uint64",
            id: 11
          }
        }
      }
    }
  }
});

module.exports = $root;



// WEBPACK FOOTER //
// ./src/proto/proto.js